import { Component, OnInit, OnChanges, SimpleChanges, Input, Output, EventEmitter } from '@angular/core';
import * as globalVariables from "../../commonVariableList/addInvoice";
import { ToasterService } from 'angular2-toaster';
import { WebServiceService } from '../../shared/services/web-service.service';
import { connectableObservableDescriptor } from 'rxjs/observable/ConnectableObservable';
import { LocalStorageService } from '../../shared/services/storage/local-storage.service';
import { CompanySetupService } from '../../shared/services/company-setup.service';
import { EesDesService } from '../../shared/services/ees-des.service';

@Component({
  selector: 'app-generic-table',
  templateUrl: './generic-table.component.html',
  styleUrls: ['./generic-table.component.scss'],
  providers: [WebServiceService, LocalStorageService]

})
export class GenericTableComponent implements OnInit, OnChanges {
  @Input() tableDetails: any;
  commonVariableList: any = {
    "heading": 'All D/C Note', "buttonProgressing": false, "isViewVisible": false,
    "breadCrumb": [], "isProgressing": false, "noteList": '', 'searchDC': '', 'isListVisible': true, 'isCreateVisible': false,
    "baseurl": '',
    "modalDetails": { "is_view": false },"columnList": [], "items": []
  }
  je_table:any=[];
  company_setup: any = {};
  isProgressing: boolean = true;
  buttonProgressing: boolean = false;
  stillLoading:boolean=false;
  fieldDocuments: any = {};
  enquiryList:any=[]
  actionsList:any=[]
  enquryNoteList:any=[{message:"To help improve efficiency (faster response from supplier/ procurement team), please submit the required info with maximum information possible",childNote:[]},
  {message:"For new product's enquiry - populate as many fields as you have information on ",childNote:[]},
  {message:"For existing product's enquiry - populate at least following MUST HAVE Fields (apart from name & CASH#) - ",childNote:[{message:'Quantity'},{message:'Intercom & Port of Discharge'},{message:'Packaging Requirement'}]}]
  @Output()
  sendAction = new EventEmitter()
  cgstfield: any;
  companyThemeBlockColor: any = "";
  CompanyThemetextColor: any = "";
  grnGrandTotalPrice: any = '';
  irnGrandTotalPrice: any = '';
  irn_to_grn: any;
  constructor(public eesdesService:EesDesService,private toasterService: ToasterService, private webService: WebServiceService,public _localStorageService: LocalStorageService,public comanySetup:CompanySetupService) { }
  country_data:any={}
  page_url:any='/'+window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
  setup:any={}
  je_tableForAdvance:any=[];

  showAvailableBudget:boolean=true;
  showAmounts:boolean=true;
  is_vendor: any = '0';
  ngOnInit() {
      //console.log(this.page_url);
    this.Enquery_showIssue(false)
    let t:any={};
    t = this.eesdesService.get('country_data',localStorage.getItem('country_data')) ? this.eesdesService.get('country_data',localStorage.getItem('country_data')) : {};
    //console.log(t);
    if(t.country_id!==''&&t.country_id!==undefined&&t.country_id!==null)
    {
      this.country_data=t;
    }

    if (this.eesdesService.get('ven_role', localStorage.getItem('ven_role')) == 'vendor') {
      this.is_vendor = '1';
    }
    if (this.tableDetails.id) {
      this.setup=this.tableDetails.setup?this.tableDetails.setup:{}
      this.setup.is_setup=this.tableDetails.is_setup?this.tableDetails.is_setup:false;

      this.commonVariableList.items = [];
      // //console.log(this.tableDetails);
      if((this.tableDetails.id=='poreport' && this.tableDetails.data.is_different_document_currency=='1') || this.tableDetails.id=='invoicereport')
      {
        this.getCurrencyList();
      }
      else
      {
        if(this.setup.is_setup)
        {
          this.setSetupData(this.setup);
        }
        else
        {
        this.GetCompanySetUpData();
        }
      }

    }
    this.companyThemeBlockColor = this._localStorageService.getCompanyTheme() ? this._localStorageService.getCompanyTheme() : "#035168";
   this.CompanyThemetextColor = this._localStorageService.getCompanyThemeColor() ? this._localStorageService.getCompanyThemeColor() : "#FFFFFF";
   console.log(this.tableDetails, 'tableDetails');
   this.setupFieldDocuments(this.tableDetails.data);

  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['tableDetails'] && changes['tableDetails'].currentValue && changes['tableDetails'].currentValue.data) {
      this.setupFieldDocuments(changes['tableDetails'].currentValue.data);
    }
  }
  GetCompanySetUpData() {
    let req = {
    }
    this.company_setup = {}
    this.stillLoading=true;
    this.company_setup.logistics_column_list = [];
    this.company_setup.invoiceJESettings=[];
    this.company_setup.vendor_direct_invoice_column_list=[];
    this.company_setup.vendor_invoice_column_list=[];
    
    this.webService.commonPostMethod("Update_company_meta/ajax_getall_bycompany", req).subscribe(
      data => {
        if (data.status){
            this.company_setup = {}
            this.company_setup = data.response ? data.response : {}
            this.company_setup.custome_name_for_total_discounted_amount_in_po_module=this.company_setup.custome_name_for_total_discounted_amount_in_po_module?this.company_setup.custome_name_for_total_discounted_amount_in_po_module:'Total Discounted Amount';
            this.company_setup.invoice_raiser_hide_tds = this.company_setup.invoice_raiser_hide_tds ? this.company_setup.invoice_raiser_hide_tds : '0';
            this.company_setup.comma_separate_currency_code = this.company_setup.comma_separate_currency_code ? this.company_setup.comma_separate_currency_code : 'IND';
          this.company_setup.is_enable_comma_separate_price = this.company_setup.is_enable_comma_separate_price ? this.company_setup.is_enable_comma_separate_price : '0';
          this.company_setup.custom_hsn_code=this.company_setup.custom_hsn_code?this.company_setup.custom_hsn_code:'HSN Code';
            if(this.page_url != '/all-invoices' && this.page_url != '/draft-invoice') {
              this.company_setup.invoice_raiser_hide_tds = '0';
            }
            this.setSetupData(data.response);
        }

        else {
          this.toasterService.pop('error', "Error", data.message);
        }
      }, error => {
        this.stillLoading=false;
        this.toasterService.pop("error", "Error", "Something Went Wrong");

      }
    )
  }
  setSetupData(data)
  {
    this.company_setup = {}
    this.stillLoading=true;
    this.company_setup.logistics_column_list = [];
    this.company_setup.invoiceJESettings=[];
      this.company_setup = data ? data : {}
      this.company_setup.is_enquire_form_item_level_visible_in_pr = this.company_setup.is_enquire_form_item_level_visible_in_pr ? this.company_setup.is_enquire_form_item_level_visible_in_pr : "0";
      this.company_setup.tot_val_visible_in_pr=this.company_setup.tot_val_visible_in_pr?this.company_setup.tot_val_visible_in_pr:'0'
      this.company_setup.grand_tot_visible_in_pr=this.company_setup.grand_tot_visible_in_pr?this.company_setup.grand_tot_visible_in_pr:'0'
      this.company_setup.preferred_vend_visible_in_pr=this.company_setup.preferred_vend_visible_in_pr?this.company_setup.preferred_vend_visible_in_pr:'0'
      this.company_setup.tot_qty_visible_in_pr=this.company_setup.tot_qty_visible_in_pr?this.company_setup.tot_qty_visible_in_pr:'0'

      this.company_setup.invoiceJESettings= this.company_setup.invoiceJESettings? this.company_setup.invoiceJESettings:[]
      this.company_setup.is_balance_po_qty_visible_in_inv=this.company_setup.is_balance_po_qty_visible_in_inv?this.company_setup.is_balance_po_qty_visible_in_inv:'0'
      this.company_setup.custom_name_balance_po_qty_in_inv=this.company_setup.custom_name_balance_po_qty_in_inv?this.company_setup.custom_name_balance_po_qty_in_inv:'Balance PO QTY'

      this.company_setup.is_boq_qty_editable_in_pr=this.company_setup.is_boq_qty_editable_in_pr?this.company_setup.is_boq_qty_editable_in_pr:'0';

      this.company_setup.custom_name_for_je_table=this.company_setup.custom_name_for_je_table?this.company_setup.custom_name_for_je_table:'JE Entry Preview'
      this.company_setup.in_invoice_custom_name_for_total_price=this.company_setup.in_invoice_custom_name_for_total_price?this.company_setup.in_invoice_custom_name_for_total_price:'Total Price';
      this.company_setup.je_table_visible_or_not=this.company_setup.je_table_visible_or_not?this.company_setup.je_table_visible_or_not:'0';
      this.company_setup.is_project_visible_in_allocate_costcenter_in_inv=this.company_setup.is_project_visible_in_allocate_costcenter_in_inv?this.company_setup.is_project_visible_in_allocate_costcenter_in_inv:'0'

      this.company_setup.default_currency_code=this.company_setup.default_currency_code?this.company_setup.default_currency_code:'INR';
      this.company_setup.custome_name_for_total_discounted_amount_in_po_module=this.company_setup.custome_name_for_total_discounted_amount_in_po_module?this.company_setup.custome_name_for_total_discounted_amount_in_po_module:'Total Discounted Amount';
      this.company_setup.logistics_column_list = this.company_setup.logistics_column_list ? this.company_setup.logistics_column_list : [];
      this.company_setup.select_pr_list = this.company_setup.select_pr_list ? this.company_setup.select_pr_list : [];
      this.company_setup.hide_invoice_tds_related_fields = this.company_setup.hide_invoice_tds_related_fields ? this.company_setup.hide_invoice_tds_related_fields : '0';
      this.company_setup.je_table_is_visible_in_adhoc_advance_payment_pages = this.company_setup.je_table_is_visible_in_adhoc_advance_payment_pages ? this.company_setup.je_table_is_visible_in_adhoc_advance_payment_pages: '0';

      this.company_setup.is_budget_selection_at_item_level_in_product_table = this.company_setup.is_budget_selection_at_item_level_in_product_table ? this.company_setup.is_budget_selection_at_item_level_in_product_table: '0';

      let temp4: any = [];
      temp4 = this.company_setup.logistics_column_list.filter((v) => { return v.id == 'add_logistics' })

      if (temp4.length != undefined && temp4.length > 0) {
        this.company_setup.logistics_column_list = [];
        this.company_setup.logistics_column_list = temp4[0].columns ? temp4[0].columns : [];
      }
      this.company_setup.invoice_raiser_visible = false;
      this.company_setup.invoice_direct_raiser_visible = false;
      this.company_setup.invoice_first_approval_visible = false;
      this.company_setup.invoice_second_approval_visible = false;
      this.company_setup.invoice_third_approval_visible = false;
      this.company_setup.invoice_fourth_approval_visible = false;
      this.company_setup.invoice_fifth_approval_visible = false;
      this.company_setup.invoice_all_approval_visible = false;

      this.company_setup.invoice_je_entry_preview_visible = this.company_setup.invoice_je_entry_preview_visible ? this.company_setup.invoice_je_entry_preview_visible : []
      if (this.company_setup.invoice_je_entry_preview_visible.length > 0) {
        this.company_setup.invoice_raiser_visible = this.company_setup.invoice_je_entry_preview_visible.some((v) => { return v.value == 'invoice_raiser'})
        this.company_setup.invoice_direct_raiser_visible = this.company_setup.invoice_je_entry_preview_visible.some((v) => { return v.value == 'direct_invoice_raiser'})
        this.company_setup.invoice_first_approval_visible = this.company_setup.invoice_je_entry_preview_visible.some((v) => { return v.value == 'invoice_first_approver'})
        this.company_setup.invoice_second_approval_visible = this.company_setup.invoice_je_entry_preview_visible.some((v) => { return v.value == 'invoice_second_approver'})
        this.company_setup.invoice_third_approval_visible = this.company_setup.invoice_je_entry_preview_visible.some((v) => { return v.value == 'invoice_third_approver'})
        this.company_setup.invoice_fourth_approval_visible = this.company_setup.invoice_je_entry_preview_visible.some((v) => { return v.value == 'invoice_fourth_approver'})
        this.company_setup.invoice_fifth_approval_visible = this.company_setup.invoice_je_entry_preview_visible.some((v) => { return v.value == 'invoice_fifth_approver'})
        this.company_setup.invoice_all_approval_visible = this.company_setup.invoice_je_entry_preview_visible.some((v) => { return v.value == 'invoice_first_approver' && v.value == 'invoice_second_approver' && v.value == 'invoice_third_approver' && v.value == 'invoice_fourth_approver' && v.value == 'invoice_fifth_approver'})

      }
      this.company_setup.is_show_open_qty_button_visible_at_raise_time = this.company_setup.is_show_open_qty_button_visible_at_raise_time ? this.company_setup.is_show_open_qty_button_visible_at_raise_time : '0';
      this.company_setup.enable_free_quantity_in_po = this.company_setup.enable_free_quantity_in_po ? this.company_setup.enable_free_quantity_in_po : '0';
      this.company_setup.enable_accepted_free_quantity_in_invoice = this.company_setup.enable_accepted_free_quantity_in_invoice ? this.company_setup.enable_accepted_free_quantity_in_invoice : '0';

      this.company_setup.generice_ui_paragraph_color_code= this.company_setup.generice_ui_paragraph_color_code? this.company_setup.generice_ui_paragraph_color_code:'#53a75c';
      this.company_setup.generice_ui_heading_color_code= this.company_setup.generice_ui_heading_color_code? this.company_setup.generice_ui_heading_color_code:'#333';

      this.company_setup.product_catalog_id = this.company_setup.product_catalog_id ? this.company_setup.product_catalog_id : '';
      if (this.company_setup.product_catalog_id != undefined && this.company_setup.product_catalog_id != '') {
        this.company_setup.product_catalog_id = '1'
      }
      this.company_setup.is_invoice_Payments_gst_deduction_visible = this.company_setup.is_invoice_Payments_gst_deduction_visible ? this.company_setup.is_invoice_Payments_gst_deduction_visible : '0';
      this.company_setup.in_invoice_custom_gst_deduction_amount_name = this.company_setup.in_invoice_custom_gst_deduction_amount_name ? this.company_setup.in_invoice_custom_gst_deduction_amount_name : 'GST Deduction';

      this.company_setup.is_invoice_Payments_retention_amount = this.company_setup.is_invoice_Payments_retention_amount ? this.company_setup.is_invoice_Payments_retention_amount : '0';
      this.company_setup.is_invoice_Payments_volume_discount = this.company_setup.is_invoice_Payments_volume_discount ? this.company_setup.is_invoice_Payments_volume_discount : '0';
      this.company_setup.is_invoice_Payments_cash_discount = this.company_setup.is_invoice_Payments_cash_discount ? this.company_setup.is_invoice_Payments_cash_discount : '0';
      this.company_setup.is_invoice_Payments_current_payable = this.company_setup.is_invoice_Payments_current_payable ? this.company_setup.is_invoice_Payments_current_payable : '0';
      this.company_setup.is_rejected_qty_visible_in_direct_invoice=  this.company_setup.is_rejected_qty_visible_in_direct_invoice?  this.company_setup.is_rejected_qty_visible_in_direct_invoice:'0'
      // this.company_setup.product_catalog_id = this.company_setup.product_catalog_id ? this.company_setup.product_catalog_id : '0';
      this.company_setup.product_catalog_id_one = this.company_setup.product_catalog_id_one ? this.company_setup.product_catalog_id_one : '0';
      this.company_setup.while_raising_a_po_prod_Desc_Visible = this.company_setup.while_raising_a_po_prod_Desc_Visible ? this.company_setup.while_raising_a_po_prod_Desc_Visible : '0';
      this.company_setup.invoice_additional_column_list = this.company_setup.invoice_additional_column_list ? this.company_setup.invoice_additional_column_list : [];
      
      this.company_setup.debit_note_amount = (this.company_setup.invoice_additional_column_list && this.company_setup.invoice_additional_column_list.length > 0) ? this.company_setup.invoice_additional_column_list.filter(v => v.key == 'debit_note_amount')[0] : {'text':'','is_visible_in_pyament_module':false,'custom_name':''};
      this.company_setup.debit_note_number =(this.company_setup.invoice_additional_column_list && this.company_setup.invoice_additional_column_list.length > 0)  ? this.company_setup.invoice_additional_column_list.filter(v => v.key == 'debit_note_number')[0] : {'text':'','is_visible_in_pyament_module':false,'custom_name':''};

      this.company_setup.is_pr_unit_price_visible = this.company_setup.is_pr_unit_price_visible ? this.company_setup.is_pr_unit_price_visible : '0'
      this.company_setup.hide_product_unit_price_ir = this.company_setup.hide_product_unit_price_ir ? this.company_setup.hide_product_unit_price_ir : '0'

      this.company_setup.is_current_stock_visible = this.company_setup.is_current_stock_visible ? this.company_setup.is_current_stock_visible : '0'
      this.company_setup.is_average_daily_consumption_visible = this.company_setup.is_average_daily_consumption_visible ? this.company_setup.is_average_daily_consumption_visible : '0'
      this.company_setup.is_inventory_in_hand_visible = this.company_setup.is_inventory_in_hand_visible ? this.company_setup.is_inventory_in_hand_visible : '0'
      this.company_setup.is_lead_time_visible = this.company_setup.is_lead_time_visible ? this.company_setup.is_lead_time_visible : '0'
      this.company_setup.is_procured_days_visible = this.company_setup.is_procured_days_visible ? this.company_setup.is_procured_days_visible : '0'
      this.company_setup.is_moq_visible = this.company_setup.is_moq_visible ? this.company_setup.is_moq_visible : '0'
      this.company_setup.merge_grn_irn = this.company_setup.merge_grn_irn ? this.company_setup.merge_grn_irn : '0';
      this.company_setup.is_product_owned_type_invoice_visible = this.company_setup.is_product_owned_type_invoice_visible ? this.company_setup.is_product_owned_type_invoice_visible : '0';
      this.company_setup.is_budget_amount_in_po = this.company_setup.is_budget_amount_in_po ? this.company_setup.is_budget_amount_in_po : '0';

      this.company_setup.average_consumption_frequency_name = this.company_setup.average_consumption_frequency_name ? this.company_setup.average_consumption_frequency_name : 'Average Monthly Consumption';
      this.company_setup.currency_icon = this.company_setup.currency_icon ? this.company_setup.currency_icon : '';

      //sales Order

      this.company_setup.sales_description_visible = this.company_setup.sales_description_visible ? this.company_setup.sales_description_visible : '0';
      this.company_setup.sales_account_name_visible = this.company_setup.sales_account_name_visible ? this.company_setup.sales_account_name_visible : '0';
      this.company_setup.sales_hsn_code_visible = this.company_setup.sales_hsn_code_visible ? this.company_setup.sales_hsn_code_visible : '0';
      this.company_setup.sales_cgst_visible = this.company_setup.sales_cgst_visible ? this.company_setup.sales_cgst_visible : '0';
      this.company_setup.sales_sgst_visible = this.company_setup.sales_sgst_visible ? this.company_setup.sales_sgst_visible : '0';
      this.company_setup.sales_igst_visible = this.company_setup.sales_igst_visible ? this.company_setup.sales_igst_visible : '0';
      this.company_setup.sales_ugst_visible = this.company_setup.sales_ugst_visible ? this.company_setup.sales_ugst_visible : '0';
      this.company_setup.sales_cess_visible = this.company_setup.sales_cess_visible ? this.company_setup.sales_cess_visible : '0';
      this.company_setup.sales_other_tax_visible = this.company_setup.sales_other_tax_visible ? this.company_setup.sales_other_tax_visible : '0';
      this.company_setup.sales_gst_visible = this.company_setup.sales_gst_visible ? this.company_setup.sales_gst_visible : '0';
      this.company_setup.is_mpr_sku_visible = this.company_setup.is_mpr_sku_visible ? this.company_setup.is_mpr_sku_visible : '0';
      this.company_setup.is_mpr_unit_type_visible = this.company_setup.is_mpr_unit_type_visible ? this.company_setup.is_mpr_unit_type_visible : '0';
      this.company_setup.is_mpr_my_boq_visible = this.company_setup.is_mpr_my_boq_visible ? this.company_setup.is_mpr_my_boq_visible : '0';
      this.company_setup.is_mpr_buffer_stock_visible = this.company_setup.is_mpr_buffer_stock_visible ? this.company_setup.is_mpr_buffer_stock_visible : '0';
      // po
      this.company_setup.is_discount_applicable_in_po = this.company_setup.is_discount_applicable_in_po ? this.company_setup.is_discount_applicable_in_po : '0'
      this.company_setup.discount_type_in_po = this.company_setup.discount_type_in_po ? this.company_setup.discount_type_in_po : ''
      this.company_setup.in_sales_invoice_is_available_stock_visible = this.company_setup.in_sales_invoice_is_available_stock_visible ? this.company_setup.in_sales_invoice_is_available_stock_visible : '0';
      this.company_setup.is_service_start_end_date_visible = this.company_setup.is_service_start_end_date_visible ? this.company_setup.is_service_start_end_date_visible : '0'
      this.company_setup.pr_procured_days_name = this.company_setup.pr_procured_days_name ? this.company_setup.pr_procured_days_name : 'No Of Months Requested For'
      this.company_setup.pr_inventory_in_hand_name = this.company_setup.pr_inventory_in_hand_name ? this.company_setup.pr_inventory_in_hand_name : 'Inventory In Hand(Months)'

      this.company_setup.is_procured_days_po_visible = this.company_setup.is_procured_days_po_visible ? this.company_setup.is_procured_days_po_visible : '0'
      this.company_setup.is_lead_time_po_visible = this.company_setup.is_lead_time_po_visible ? this.company_setup.is_lead_time_po_visible : '0'
      this.company_setup.is_inventory_in_hand_po_visible = this.company_setup.is_inventory_in_hand_po_visible ? this.company_setup.is_inventory_in_hand_po_visible : '0'
      this.company_setup.is_average_daily_consumption_po_visible = this.company_setup.is_average_daily_consumption_po_visible ? this.company_setup.is_average_daily_consumption_po_visible : '0'
      this.company_setup.is_current_stock_po_visible = this.company_setup.is_current_stock_po_visible ? this.company_setup.is_current_stock_po_visible : '0'
      this.company_setup.is_storage_location_visible_in_po = this.company_setup.is_storage_location_visible_in_po ? this.company_setup.is_storage_location_visible_in_po : '0'
      this.company_setup.po_additional_fields_column_list = this.company_setup.po_additional_fields_column_list ? this.company_setup.po_additional_fields_column_list : [];
      let poAdditionaltemp: any = [];
      poAdditionaltemp = this.company_setup.po_additional_fields_column_list.filter((v) => { return v.id == 'po_additional_fields_settings' });
      if (poAdditionaltemp.length != undefined && poAdditionaltemp.length > 0) {
        this.company_setup.po_additional_fields_column_list = [];
        this.company_setup.po_additional_fields_column_list = poAdditionaltemp[0].columns ? poAdditionaltemp[0].columns : [];
      }
      // sales
      this.company_setup.is_supply_through_e_comm_visible_in_sales_invoice =this.company_setup.is_supply_through_e_comm_visible_in_sales_invoice ?this.company_setup.is_supply_through_e_comm_visible_in_sales_invoice :'0';
      this.company_setup.is_account_code_visible_in_sales_invoice =this.company_setup.is_account_code_visible_in_sales_invoice?this.company_setup.is_account_code_visible_in_sales_invoice:'0';
      this.company_setup.is_sales_invoice_price_visible=  this.company_setup.is_sales_invoice_price_visible?  this.company_setup.is_sales_invoice_price_visible:'0'

      this.company_setup.is_merge_barcode_visible=this.company_setup.is_merge_barcode_visible?this.company_setup.is_merge_barcode_visible:'0'
      this.company_setup.average_consumption_frequency_name_in_ir = this.company_setup.average_consumption_frequency_name_in_ir ? this.company_setup.average_consumption_frequency_name_in_ir : 'Average Monthly Consumption'

      this.company_setup.is_invoice_qty_visible_in_irn = this.company_setup.is_invoice_qty_visible_in_irn ? this.company_setup.is_invoice_qty_visible_in_irn : '0'
      this.company_setup.is_invoice_unit_price_visible_in_irn = this.company_setup.is_invoice_unit_price_visible_in_irn ? this.company_setup.is_invoice_unit_price_visible_in_irn : '0'
      this.company_setup.is_invoice_upload_file_visible_in_irn = this.company_setup.is_invoice_upload_file_visible_in_irn ? this.company_setup.is_invoice_upload_file_visible_in_irn : '0'

      this.company_setup.is_correct_gst_invoice_received_visible_in_irn = this.company_setup.is_correct_gst_invoice_received_visible_in_irn ? this.company_setup.is_correct_gst_invoice_received_visible_in_irn:'0'


      this.company_setup.is_invoice_qty_visible_in_grn = this.company_setup.is_invoice_qty_visible_in_grn ? this.company_setup.is_invoice_qty_visible_in_grn:'0'
      this.company_setup.is_invoice_unit_price_visible_in_grn = this.company_setup.is_invoice_unit_price_visible_in_grn ? this.company_setup.is_invoice_unit_price_visible_in_grn:'0'
      this.company_setup.is_invoice_upload_file_visible_in_grn = this.company_setup.is_invoice_upload_file_visible_in_grn ? this.company_setup.is_invoice_upload_file_visible_in_grn:'0'
      this.company_setup.is_correct_gst_invoice_received_visible_in_grn = this.company_setup.is_correct_gst_invoice_received_visible_in_grn ? this.company_setup.is_correct_gst_invoice_received_visible_in_grn:'0'

      this.company_setup.is_invoice_qty_editable_in_grn = this.company_setup.is_invoice_qty_editable_in_grn ? this.company_setup.is_invoice_qty_editable_in_grn:'0'
      this.company_setup.is_invoice_unit_price_editable_in_grn = this.company_setup.is_invoice_unit_price_editable_in_grn ? this.company_setup.is_invoice_unit_price_editable_in_grn:'0'
      this.company_setup.is_invoice_upload_file_editable_in_grn = this.company_setup.is_invoice_upload_file_editable_in_grn ? this.company_setup.is_invoice_upload_file_editable_in_grn:'0'
      this.company_setup.is_correct_gst_invoice_received_editable_in_grn = this.company_setup.is_correct_gst_invoice_received_editable_in_grn ? this.company_setup.is_correct_gst_invoice_received_editable_in_grn:'0'

this.company_setup.custom_name_for_usable_qty = this.company_setup.custom_name_for_usable_qty ? this.company_setup.custom_name_for_usable_qty : 'Usable QTY'
this.company_setup.custom_name_for_error_size = this.company_setup.custom_name_for_error_size ? this.company_setup.custom_name_for_error_size : 'Error Size'
this.company_setup.is_total_qty_inwarded_visible = this.company_setup.is_total_qty_inwarded_visible ? this.company_setup.is_total_qty_inwarded_visible : '0'
this.company_setup.is_acceptable_rejection_percentage_visible = this.company_setup.is_acceptable_rejection_percentage_visible ? this.company_setup.is_acceptable_rejection_percentage_visible : '0'
this.company_setup.is_rejection_percentage_visible = this.company_setup.is_rejection_percentage_visible ? this.company_setup.is_rejection_percentage_visible : '0'

      this.company_setup.add_invoice_requested_by_custom_name = this.company_setup.add_invoice_requested_by_custom_name ? this.company_setup.add_invoice_requested_by_custom_name : 'GRN Approver Name'
      this.company_setup.in_invoice_grn_no_custom_name = this.company_setup.in_invoice_grn_no_custom_name ? this.company_setup.in_invoice_grn_no_custom_name : 'GRN/QA No'
      this.company_setup.in_invoice_irn_no_custom_name = this.company_setup.in_invoice_irn_no_custom_name ? this.company_setup.in_invoice_irn_no_custom_name : 'IRN No'
      this.company_setup.in_invoice_grn_date_custom_name = this.company_setup.in_invoice_grn_date_custom_name ? this.company_setup.in_invoice_grn_date_custom_name : 'GRN Date'
      this.company_setup.custom_total_gst_visible = this.company_setup.custom_total_gst_visible?this.company_setup.custom_total_gst_visible:'0';
      this.company_setup.invoice_in_summary_table_tds_amount_field_visible = this.company_setup.invoice_in_summary_table_tds_amount_field_visible?this.company_setup.invoice_in_summary_table_tds_amount_field_visible:'0';
      this.company_setup.invoice_in_summary_table_previous_tds_amount_field_visible = this.company_setup.invoice_in_summary_table_previous_tds_amount_field_visible?this.company_setup.invoice_in_summary_table_previous_tds_amount_field_visible:'0';
      this.company_setup.is_balance_budget_amount_visible_in_invoice = this.company_setup.is_balance_budget_amount_visible_in_invoice?this.company_setup.is_balance_budget_amount_visible_in_invoice:'0';
      this.company_setup.in_po_custom_name_for_discounted_unit_price = this.company_setup.in_po_custom_name_for_discounted_unit_price?this.company_setup.in_po_custom_name_for_discounted_unit_price:'Discounted Unit Price';
      this.company_setup.custome_name_for_required_by_in_po_pr_module=this.company_setup.custome_name_for_required_by_in_po_pr_module?this.company_setup.custome_name_for_required_by_in_po_pr_module:'Required By';

      this.company_setup.custom_name_haz_in_po=this.company_setup.custom_name_haz_in_po?this.company_setup.custom_name_haz_in_po:'HAZ';
      this.company_setup.custom_name_hs_code_in_po=this.company_setup.custom_name_hs_code_in_po?this.company_setup.custom_name_hs_code_in_po:'HS Code';
      this.company_setup.custom_name_un_no_in_po=this.company_setup.custom_name_un_no_in_po?this.company_setup.custom_name_un_no_in_po:'UN No';
      this.company_setup.custom_name_packaging_details_in_po=this.company_setup.custom_name_packaging_details_in_po?this.company_setup.custom_name_packaging_details_in_po:'Packaging Details';
      this.company_setup.custom_name_sample_details_in_po=this.company_setup.custom_name_sample_details_in_po?this.company_setup.custom_name_sample_details_in_po:'Sample Details';

      let temp1: any = [];
      this.company_setup.master_column_list = this.company_setup.master_column_list ? this.company_setup.master_column_list : [];
      this.company_setup.product_master_column_list = this.company_setup.product_master_column_list ? this.company_setup.product_master_column_list : [];
      temp1 = this.company_setup.master_column_list.filter((v) => { return v.id == 'product_master' })
      if (temp1.length != undefined && temp1.length > 0) {
          this.company_setup.product_master_column_list = [];
          this.company_setup.product_master_column_list = temp1[0].columns ? temp1[0].columns : [];
      };
      this.company_setup.product_master_catelogue_id_name = this.webService.getColumnName(this.company_setup.product_master_column_list, 'product_catalog_id', 'Product Catalog ID..');
      this.company_setup.budget_details_on_rfq_response_page = this.company_setup.budget_details_on_rfq_response_page ? this.company_setup.budget_details_on_rfq_response_page : '0';
      this.company_setup.allowed_digits_after_decimal_for_boq = this.company_setup.allowed_digits_after_decimal_for_boq ? this.company_setup.allowed_digits_after_decimal_for_boq : '2';
      this.company_setup.is_delivery_cc_visible_po = this.company_setup.is_delivery_cc_visible_po ? this.company_setup.is_delivery_cc_visible_po : "0";
      this.company_setup.visible_product_category_subcategory_in_pr = this.company_setup.visible_product_category_subcategory_in_pr ? this.company_setup.visible_product_category_subcategory_in_pr : "0";

      this.company_setup.is_accepted_qty_hidden = false;
      this.company_setup.is_paid_price_hidden = false;
      this.company_setup.is_total_paid_price_hidden = false;
      this.company_setup.is_difference_price_hidden = false;
      this.company_setup.is_total_difference_price_hidden = false;
      this.company_setup.is_total_price_hidden = false;
      // this.company_setup.is_product_description_hidden = false;
      this.company_setup.is_product_type_hidden = false;
      this.company_setup.is_unit_type_hidden = false;
      this.company_setup.is_remarks_hidden = false;
      this.company_setup.is_paid_cgst_hidden = false;
      this.company_setup.is_paid_sgst_hidden = false;
      this.company_setup.is_paid_igst_hidden = false;
      this.company_setup.is_total_paid_price_gst_hidden = false;
      this.company_setup.direct_invoice_columnList = this.company_setup.direct_invoice_columnList ? this.company_setup.direct_invoice_columnList : []
      if (this.company_setup.direct_invoice_columnList.length > 0) {
        this.company_setup.is_accepted_qty_hidden = this.company_setup.direct_invoice_columnList.some((v) => { return v.id == 'accepted_qty' && v.isVisible });
        this.company_setup.is_paid_price_hidden = this.company_setup.direct_invoice_columnList.some((v) => { return v.id == 'paid_price' && v.isVisible });
        this.company_setup.is_total_paid_price_hidden = this.company_setup.direct_invoice_columnList.some((v) => { return v.id == 'total_paid_price' && v.isVisible });
        this.company_setup.is_difference_price_hidden = this.company_setup.direct_invoice_columnList.some((v) => { return v.id == 'difference_price' && v.isVisible });
        this.company_setup.is_total_difference_price_hidden = this.company_setup.direct_invoice_columnList.some((v) => { return v.id == 'total_difference_price' && v.isVisible });
        this.company_setup.is_total_price_hidden = this.company_setup.direct_invoice_columnList.some((v) => { return v.id == 'total_price' && v.isVisible });
        // this.company_setup.is_product_description_hidden = this.company_setup.direct_invoice_columnList.some((v) => { return v.id == 'product_description' && v.isVisible });
        this.company_setup.is_product_type_hidden = this.company_setup.direct_invoice_columnList.some((v) => { return v.id == 'product_type' && v.isVisible });
        this.company_setup.is_unit_type_hidden = this.company_setup.direct_invoice_columnList.some((v) => { return v.id == 'unit_type' && v.isVisible });
        this.company_setup.is_remarks_hidden = this.company_setup.direct_invoice_columnList.some((v) => { return v.id == 'remarks' && v.isVisible });
        this.company_setup.is_paid_cgst_hidden = this.company_setup.direct_invoice_columnList.some((v) => { return v.id == 'paid_cgst' && v.isVisible });
        this.company_setup.is_paid_sgst_hidden = this.company_setup.direct_invoice_columnList.some((v) => { return v.id == 'paid_sgst' && v.isVisible });
        this.company_setup.is_paid_igst_hidden = this.company_setup.direct_invoice_columnList.some((v) => { return v.id == 'paid_igst' && v.isVisible });
        this.company_setup.is_total_paid_price_gst_hidden = this.company_setup.direct_invoice_columnList.some((v) => { return v.id == 'total_paid_price_gst' && v.isVisible });
        this.company_setup.show_lob_dropdown = this.company_setup.show_lob_dropdown ? this.company_setup.show_lob_dropdown : '0';
        this.company_setup.show_loc_dropdown = this.company_setup.show_loc_dropdown ? this.company_setup.show_loc_dropdown : '0';
        this.company_setup.show_dept_dropdown = this.company_setup.show_dept_dropdown ? this.company_setup.show_dept_dropdown : '0';
      }

      this.company_setup.in_add_invoice_accepted_qty_hidden = false;
      this.company_setup.in_add_invoice_paid_price_hidden = false;
      this.company_setup.in_add_invoice_total_paid_price_hidden = false;
      this.company_setup.in_add_invoice_difference_price_hidden = false;
      this.company_setup.in_add_invoice_total_difference_price_hidden = false;
      this.company_setup.in_add_invoice_total_price_hidden = false;
      this.company_setup.in_add_invoice_product_type_hidden = false;
      this.company_setup.in_add_invoice_unit_type_hidden = false;
      this.company_setup.in_add_invoice_remarks_hidden = false;
      this.company_setup.in_add_invoice_paid_cgst_hidden = false;
      this.company_setup.in_add_invoice_paid_sgst_hidden = false;
      this.company_setup.in_add_invoice_paid_igst_hidden = false;
      this.company_setup.in_add_invoice_total_paid_price_gst_hidden = false;
      this.company_setup.in_add_invoice_rejected_qty_hidden = false;

      this.company_setup.add_invoice_columnList = this.company_setup.add_invoice_columnList ? this.company_setup.add_invoice_columnList : []
      if (this.company_setup.add_invoice_columnList.length > 0) {
        this.company_setup.in_add_invoice_accepted_qty_hidden = this.company_setup.add_invoice_columnList.some((v) => { return v.id == 'accepted_qty' && v.isVisible });
        this.company_setup.in_add_invoice_paid_price_hidden = this.company_setup.add_invoice_columnList.some((v) => { return v.id == 'paid_price' && v.isVisible });
        this.company_setup.in_add_invoice_total_paid_price_hidden = this.company_setup.add_invoice_columnList.some((v) => { return v.id == 'total_paid_price' && v.isVisible });
        this.company_setup.in_add_invoice_difference_price_hidden = this.company_setup.add_invoice_columnList.some((v) => { return v.id == 'difference_price' && v.isVisible });
        this.company_setup.in_add_invoice_total_difference_price_hidden = this.company_setup.add_invoice_columnList.some((v) => { return v.id == 'total_difference_price' && v.isVisible });
        this.company_setup.in_add_invoice_total_price_hidden = this.company_setup.add_invoice_columnList.some((v) => { return v.id == 'total_price' && v.isVisible });
        this.company_setup.in_add_invoice_product_type_hidden = this.company_setup.add_invoice_columnList.some((v) => { return v.id == 'product_type' && v.isVisible });
        this.company_setup.in_add_invoice_unit_type_hidden = this.company_setup.add_invoice_columnList.some((v) => { return v.id == 'unit_type' && v.isVisible });
        this.company_setup.in_add_invoice_remarks_hidden = this.company_setup.add_invoice_columnList.some((v) => { return v.id == 'remarks' && v.isVisible });
        this.company_setup.in_add_invoice_paid_cgst_hidden = this.company_setup.add_invoice_columnList.some((v) => { return v.id == 'paid_cgst' && v.isVisible });
        this.company_setup.in_add_invoice_paid_sgst_hidden = this.company_setup.add_invoice_columnList.some((v) => { return v.id == 'paid_sgst' && v.isVisible });
        this.company_setup.in_add_invoice_paid_igst_hidden = this.company_setup.add_invoice_columnList.some((v) => { return v.id == 'paid_igst' && v.isVisible });
        this.company_setup.in_add_invoice_total_paid_price_gst_hidden = this.company_setup.add_invoice_columnList.some((v) => { return v.id == 'total_paid_price_gst' && v.isVisible });
        this.company_setup.in_add_invoice_rejected_qty_hidden = this.company_setup.add_invoice_columnList.some((v) => { return v.id == 'rejected_qty' && v.isVisible });
    }
      this.company_setup.inv_rcm_applicable_visible = this.company_setup.inv_rcm_applicable_visible ? this.company_setup.inv_rcm_applicable_visible : '0';
      this.company_setup.inv_gst_input_available_visible = this.company_setup.inv_gst_input_available_visible ? this.company_setup.inv_gst_input_available_visible : '0';
      this.company_setup.is_budget_selection_at_item_level_in_product_table = this.company_setup.is_budget_selection_at_item_level_in_product_table ? this.company_setup.is_budget_selection_at_item_level_in_product_table : '0';
      this.company_setup.rename_project = this.company_setup.rename_project ? this.company_setup.rename_project : '';          
      this.company_setup.rename_task = this.company_setup.rename_task ? this.company_setup.rename_task : '';
      this.company_setup.product_category_subcategory_visible_in_po = this.company_setup.product_category_subcategory_visible_in_po ? this.company_setup.product_category_subcategory_visible_in_po :''
      this.company_setup.other_payment_deduction = this.company_setup.other_payment_deduction ? this.company_setup.other_payment_deduction : '0';
      this.company_setup.modified_irn_to_grn = this.company_setup.modified_irn_to_grn ? this.company_setup.modified_irn_to_grn : '0';
      this.irn_to_grn = (this.company_setup.modified_irn_to_grn == 1) ? "GRN" : "IRN";

      this.company_setup.additional_field_invoice_column_list = this.company_setup.additional_field_invoice_column_list  ? this.company_setup.additional_field_invoice_column_list  :[];
      let temp = this.company_setup.additional_field_invoice_column_list.filter((v) => { return v.id == 'all_invoice_field_column' });
      if (temp.length != undefined && temp.length>0) {
        this.company_setup.additional_field_invoice_column_list = [];
        this.company_setup.additional_field_invoice_column_list = temp[0].columns ? temp[0].columns : [];
      }
      this.company_setup.amortization_type_visible=this.webService.is_column_visible(this.company_setup.additional_field_invoice_column_list,'amortization_type',false);
      this.company_setup.amortization_start_date_visible=this.webService.is_column_visible(this.company_setup.additional_field_invoice_column_list,'amortization_start_date',false);
      this.company_setup.amortization_end_date_visible=this.webService.is_column_visible(this.company_setup.additional_field_invoice_column_list,'amortization_end_date',false);
      this.company_setup.field4_visible=this.webService.is_column_visible(this.company_setup.additional_field_invoice_column_list,'field4',false);
      this.company_setup.field5_visible=this.webService.is_column_visible(this.company_setup.additional_field_invoice_column_list,'field5',false);
      this.company_setup.field6_visible=this.webService.is_column_visible(this.company_setup.additional_field_invoice_column_list,'field6',false);
      this.company_setup.remove_fc_po_from_product_table = this.company_setup.remove_fc_po_from_product_table ? this.company_setup.remove_fc_po_from_product_table : '0';
      this.company_setup.coming_from_cvppm = this.company_setup.coming_from_cvppm ? this.company_setup.coming_from_cvppm : 'Is CVPPM';
      this.company_setup.show_is_cvppm_in_po_module = this.company_setup.show_is_cvppm_in_po_module ? this.company_setup.show_is_cvppm_in_po_module : '0';
      this.company_setup.custom_ship_location_name = this.company_setup.custom_ship_location_name ? this.company_setup.custom_ship_location_name : 'Ship Location';
      this.company_setup.po_item_level_list = this.company_setup.po_item_level_list ? this.company_setup.po_item_level_list : [];
      this.company_setup.vendor_direct_invoice_column_list=this.company_setup.vendor_direct_invoice_column_list?this.company_setup.vendor_direct_invoice_column_list:[];
      this.company_setup.vendor_invoice_column_list=this.company_setup.vendor_invoice_column_list?this.company_setup.vendor_invoice_column_list:[];
      this.company_setup.po_cgst_visible = this.company_setup.po_cgst_visible ? this.company_setup.po_cgst_visible : '0';
      this.company_setup.po_sgst_visible = this.company_setup.po_sgst_visible ? this.company_setup.po_sgst_visible : '0';
      this.company_setup.po_igst_visible = this.company_setup.po_igst_visible ? this.company_setup.po_igst_visible : '0';
      this.company_setup.po_ugst_visible = this.company_setup.po_ugst_visible ? this.company_setup.po_ugst_visible : '0';
      this.company_setup.po_cess_visible = this.company_setup.po_cess_visible ? this.company_setup.po_cess_visible : '0';
      this.company_setup.po_other_tax_visible = this.company_setup.po_other_tax_visible ? this.company_setup.po_other_tax_visible : '0';
      this.company_setup.enable_po_unit_and_total_price_fields_for_normal_po = this.company_setup.enable_po_unit_and_total_price_fields_for_normal_po ? this.company_setup.enable_po_unit_and_total_price_fields_for_normal_po : '0';
      // console.log("this.company_setup.amortization_type_visible", this.company_setup.amortization_type_visible)
      this.stillLoading=false;
      this.apiCall();
  }
  getInvoiceIndex(x)
  {
    let id:any=this._localStorageService.getUserId()?this._localStorageService.getUserId():'';

    var index = x.approvals.findIndex(function(v) {
      return v.approval_by == id
    });
    // ////// //console.log(index+'11 po no'+x.po_id);
    return index?index:0;
  }
  invApproval:boolean = false;
  invRaiser:boolean=false;
    isHideApprover(x){
      let id:any=this._localStorageService.getUserId()?this._localStorageService.getUserId():'';
      let raiser_id=this.tableDetails.data.added_by?this.tableDetails.data.added_by:''
      this.invRaiser=(!this.company_setup.invoice_raiser_visible || !this.company_setup.invoice_direct_raiser_visible)?(id==raiser_id) :false;
      let index:number=this.getInvoiceIndex(x)
      let counter: number = index;
//console.log('approval no='+counter);
this.invApproval=false;
// //console.log(this.company_setup.invoice_first_approval_visible);
      if(!this.company_setup.invoice_first_approval_visible && counter == 0){
        this.invApproval = true;
      }
      if(!this.invApproval)
      {
      // if(!this.company_setup.invoice_second_approval_visible && counter == 1){
      //      this.invApproval = true;

      // }
      // if(!this.company_setup.invoice_third_approval_visible && counter == 2){

      //     this.invApproval = true;

      // }
      // if(!this.company_setup.invoice_fourth_approval_visible && counter == 3){

      //     this.invApproval = true;

      // }
      // if(!this.company_setup.invoice_fifth_approval_visible && counter == 4){

      //     this.invApproval = true;

      //  }
      this.invApproval = true;
      }
    }
  diff_json_data = {};
  old_json_data = [];
  show_difference : boolean = false;
  linkType : any = "";
  apiCall() {
    this.enquiryList=[]
    this.actionsList=[];
    this.linkType = this.tableDetails.id;
    switch (this.tableDetails.id) {
      case 'invoice_android_report':
        this.commonVariableList.columnList = [];
        this.commonVariableList.items = [];

        break;
        case 'recurring_invoicereport':
          this.commonVariableList.columnList = globalVariables.recurring_invoiceVariableList.columnList;
          this.commonVariableList.items = this.tableDetails.data.invoice_items ? this.tableDetails.data.invoice_items : [];
          let approval1={approvals:[]}
          approval1.approvals=this.tableDetails.data.approvals?this.tableDetails.data.approvals:[];
          this.isHideApprover(approval1);
  //console.log(this.invApproval)
          if (this.commonVariableList.items) {
            for (let i of this.commonVariableList.items) {

              if(this.page_url=='/auto-generated-inv')
              {
                i.invoice_cess = 0
                i.invoice_other_tax = 0
                i.invoice_ugst = 0
                i.invoice_cgst = 0
                i.invoice_sgst = 0
                i.invoice_igst = 0
                i.hsn_other_tax =  '0'
              i.hsn_ugst =  '0'
              i.hsn_cgst = '0'
              i.hsn_sgst =  '0'
              i.hsn_igst = '0'
              i.invoice_tax=0
              i.invoice_grand_total=i.invoice_total_price
              }

              i.invoice_unit_price = this.webService.convertNaN(i.invoice_unit_price)
              i.invoice_unit_price = parseFloat(i.invoice_unit_price)
              i.invoice_unit_price = this.webService.convertNaN(i.invoice_unit_price)

              i.invoice_qty = this.webService.convertNaN(i.invoice_qty)
              i.invoice_qty = parseFloat(i.invoice_qty)
              i.invoice_qty = this.webService.convertNaN(i.invoice_qty)


              i.product_unit_price = this.webService.convertNaN(i.product_unit_price)
              i.product_unit_price = parseFloat(i.product_unit_price)
              i.product_unit_price = this.webService.convertNaN(i.product_unit_price)


              i.hsn_other_tax = i.hsn_other_tax ? i.hsn_other_tax : '0'
              i.hsn_ugst = i.hsn_ugst ? i.hsn_ugst : '0'
              i.hsn_cgst = i.hsn_cgst ? i.hsn_cgst : '0'
              i.hsn_sgst = i.hsn_sgst ? i.hsn_sgst : '0'
              i.hsn_igst = i.hsn_igst ? i.hsn_igst : '0'


              // invoice
              i.invoice_cess = this.webService.convertNaN(i.invoice_cess)
              i.invoice_other_tax = this.webService.convertNaN(i.invoice_other_tax)
              i.invoice_ugst = this.webService.convertNaN(i.invoice_ugst)
              i.invoice_cgst = this.webService.convertNaN(i.invoice_cgst)
              i.invoice_sgst = this.webService.convertNaN(i.invoice_sgst)
              i.invoice_igst = this.webService.convertNaN(i.invoice_igst)


  //Start :  new code written to first convert values into number  and then convert more than two digit decimal into two


    // invoice
    i.invoice_cess = parseFloat(i.invoice_cess)
    i.invoice_other_tax = parseFloat(i.invoice_other_tax)
    i.invoice_ugst = parseFloat(i.invoice_ugst)
    i.invoice_cgst = parseFloat(i.invoice_cgst)
    i.invoice_sgst = parseFloat(i.invoice_sgst)
    i.invoice_igst = parseFloat(i.invoice_igst)



                // invoice
                i.invoice_cess = this.webService.convertNaN(i.invoice_cess)
                i.invoice_other_tax = this.webService.convertNaN(i.invoice_other_tax)
                i.invoice_ugst = this.webService.convertNaN(i.invoice_ugst)
                i.invoice_cgst = this.webService.convertNaN(i.invoice_cgst)
                i.invoice_sgst = this.webService.convertNaN(i.invoice_sgst)
                i.invoice_igst = this.webService.convertNaN(i.invoice_igst)


   //Close :  new code written to first convert values into number  and then convert more than two digit decimal into two





              // paid
              i.hsn_cess = parseFloat(i.paid_cess) <= 0 ? '0' : i.hsn_cess;
              i.hsn_other_tax = parseFloat(i.paid_other_tax) <= 0 ? '0' : i.hsn_other_tax;
              i.hsn_ugst = parseFloat(i.paid_ugst) <= 0 ? '0' : i.hsn_ugst;
              i.hsn_cgst = parseFloat(i.paid_cgst) <= 0 ? '0' : i.hsn_cgst;
              i.hsn_sgst = parseFloat(i.paid_sgst) <= 0 ? '0' : i.hsn_sgst;
              i.hsn_igst = parseFloat(i.paid_igst) <= 0 ? '0' : i.hsn_igst;

              // invoice
              i.hsn_cess = parseFloat(i.invoice_cess) <= 0 ? '0' : i.hsn_cess;
              i.hsn_other_tax = parseFloat(i.invoice_other_tax) <= 0 ? '0' : i.hsn_other_tax;
              i.hsn_ugst = parseFloat(i.invoice_ugst) <= 0 ? '0' : i.hsn_ugst;
              i.hsn_cgst = parseFloat(i.invoice_cgst) <= 0 ? '0' : i.hsn_cgst;
              i.hsn_sgst = parseFloat(i.invoice_sgst) <= 0 ? '0' : i.hsn_sgst;
              i.hsn_igst = parseFloat(i.invoice_igst) <= 0 ? '0' : i.hsn_igst;
          }

          let is_direct1: any = '0';
          is_direct1 = this.tableDetails.data.is_direct ? this.tableDetails.data.is_direct : '0'
          let is_good1:boolean = this.commonVariableList.items.some((v) => {
            return v.product_type == 'services'
          })
          if (this.commonVariableList.columnList) {

            for (let i of this.commonVariableList.columnList) {


              if(i.value == 'invoice_cgst' && this.company_setup.custom_cgst_visible == '1'){
                i.display = this.company_setup.custom_cgst_name?`Invoice ${this.company_setup.custom_cgst_name}`:'Invoice CGST';
                i.is_view = true;
              }
              if(i.value == 'invoice_sgst' && this.company_setup.custom_sgst_visible == '1' ){
                i.display = this.company_setup.custom_sgst_name?`Invoice ${this.company_setup.custom_sgst_name}`:'Invoice SGST';
                i.is_view = true;
              }
              if(i.value == 'invoice_igst' && this.company_setup.custom_igst_visible == '1'){
                i.display = this.company_setup.custom_igst_name?`Invoice ${this.company_setup.custom_igst_name}`:'Invoice IGST';
                i.is_view = true;
              }
              if(i.value == 'invoice_ugst' && this.company_setup.custom_ugst_visible == '1'){
                i.display = this.company_setup.custom_ugst_name?`Invoice ${this.company_setup.custom_ugst_name}`:'Invoice UGST';
                i.is_view = true;
              }
              if(i.value == 'invoice_cess' && this.company_setup.custom_cess_visible == '1'){
                i.display = this.company_setup.custom_cess_name?`Invoice ${this.company_setup.custom_cess_name}`:'Invoice CESS';
                i.is_view = true;
              }
              if(i.value == 'invoice_other_tax' && this.company_setup.custom_other_tax_visible == '1'){
                i.display = this.company_setup.custom_other_tax_name?`Invoice ${this.company_setup.custom_other_tax_name}`:'Invoice Other Tax';
                i.is_view = true;
              }

              if(i.value == 'invoice_tax' && this.company_setup.custom_total_gst_visible == '1'){
                i.is_view = true;
              }


              if(i.value == 'invoice_tax' && this.company_setup.custom_total_gst_visible == '0'){
                i.is_view = false;
              }

              if(i.value == 'hsn_code' && this.company_setup.is_hsn_code_visible == '1'){
                i.is_view = true;
              }
              if (i.value == 'conversion_unit_price' && this.tableDetails.data.is_different_document_currency == '0') {
                i.display = "FC (PO) Unit Price"
                i.is_view = false;
              }
              if (i.value == 'conversion_unit_price' && this.tableDetails.data.is_different_document_currency == '1') {
                i.display = "FC (PO) Unit Price" + "(" + this.tableDetails.data.currency_code + ")";
                i.is_view = true;
              }

              if (i.value == 'conversion_paid_price' && this.tableDetails.data.is_different_document_currency == '0') {
                i.display = "FC Paid Price Per Unit"
                i.is_view = false;
              }
              if (i.value == 'conversion_paid_price' && this.tableDetails.data.is_different_document_currency == '1') {
                i.display = "FC Paid Price Per Unit" + "(" + this.tableDetails.data.currency_code + ")";
                i.is_view = true;
              }

              if (i.value == 'conversion_invoice_price' && this.tableDetails.data.is_different_document_currency == '0') {
                i.display = "FC Invoice Unit Price"
                i.is_view = false;
              }
              if (i.value == 'conversion_invoice_price' && this.tableDetails.data.is_different_document_currency == '1') {
                i.display = "FC Invoice Unit Price" + "(" + this.tableDetails.data.currency_code + ")";
                i.is_view = true;
              }




              if (i.value == 'product_catalog_id' && this.company_setup.product_catalog_id == '1') {
                i.is_view = true;
              }
              if (i.value == 'product_catalog_id' && this.company_setup.product_catalog_id == '0') {
                i.is_view = false;
              }
            }

          }
          }
          this.makeData();


      break;

      case 'invoicereport':
        this.commonVariableList.columnList = globalVariables.invoiceVariableList.columnList;
        this.commonVariableList.items = this.tableDetails.data.invoice_items ? this.tableDetails.data.invoice_items : [];

        let show_multi_inv = this.tableDetails.data.show_multi_inv ? this.tableDetails.data.show_multi_inv : '0';

        this.company_setup.is_accepted_qty_hidden = this.company_setup.is_accepted_qty_hidden ? this.company_setup.is_accepted_qty_hidden : false;
        this.company_setup.is_paid_price_hidden = this.company_setup.is_paid_price_hidden ? this.company_setup.is_paid_price_hidden : false;
        this.company_setup.is_total_paid_price_hidden = this.company_setup.is_total_paid_price_hidden ? this.company_setup.is_total_paid_price_hidden : false;
        this.company_setup.is_difference_price_hidden = this.company_setup.is_difference_price_hidden ? this.company_setup.is_difference_price_hidden : false;
        this.company_setup.is_total_difference_price_hidden = this.company_setup.is_total_difference_price_hidden ? this.company_setup.is_total_difference_price_hidden : false;
        this.company_setup.is_total_price_hidden = this.company_setup.is_total_price_hidden ? this.company_setup.is_total_price_hidden : false;
        // this.company_setup.is_product_description_hidden = this.company_setup.is_product_description_hidden ? this.company_setup.is_product_description_hidden : false;
        this.company_setup.is_product_type_hidden = this.company_setup.is_product_type_hidden ? this.company_setup.is_product_type_hidden : false;
        this.company_setup.is_unit_type_hidden = this.company_setup.is_unit_type_hidden ? this.company_setup.is_unit_type_hidden : false;
        this.company_setup.is_remarks_hidden = this.company_setup.is_remarks_hidden ? this.company_setup.is_remarks_hidden : false;
        this.company_setup.is_paid_cgst_hidden = this.company_setup.is_paid_cgst_hidden ? this.company_setup.is_paid_cgst_hidden : false;
        this.company_setup.is_paid_sgst_hidden = this.company_setup.is_paid_sgst_hidden ? this.company_setup.is_paid_sgst_hidden : false;
        this.company_setup.is_paid_igst_hidden = this.company_setup.is_paid_igst_hidden ? this.company_setup.is_paid_igst_hidden : false;
        this.company_setup.is_total_paid_price_gst_hidden = this.company_setup.is_total_paid_price_gst_hidden ? this.company_setup.is_total_paid_price_gst_hidden : false;
        this.company_setup.in_invoice_date_format = this.company_setup.in_invoice_date_format ? this.company_setup.in_invoice_date_format : "dd-mm-yyyy";


        this.company_setup.in_add_invoice_accepted_qty_hidden = this.company_setup.in_add_invoice_accepted_qty_hidden ? this.company_setup.in_add_invoice_accepted_qty_hidden :  false;
        this.company_setup.in_add_invoice_paid_price_hidden =  this.company_setup.in_add_invoice_paid_price_hidden ? this.company_setup.in_add_invoice_paid_price_hidden : false;
        this.company_setup.in_add_invoice_total_paid_price_hidden = this.company_setup.in_add_invoice_total_paid_price_hidden ? this.company_setup.in_add_invoice_total_paid_price_hidden : false;
        this.company_setup.in_add_invoice_difference_price_hidden = this.company_setup.in_add_invoice_difference_price_hidden ? this.company_setup.in_add_invoice_difference_price_hidden : false;
        this.company_setup.in_add_invoice_total_difference_price_hidden = this.company_setup.in_add_invoice_total_difference_price_hidden ? this.company_setup.in_add_invoice_total_difference_price_hidden : false;
        this.company_setup.in_add_invoice_total_price_hidden = this.company_setup.in_add_invoice_total_price_hidden ? this.company_setup.in_add_invoice_total_price_hidden : false;
        this.company_setup.in_add_invoice_product_type_hidden = this.company_setup.in_add_invoice_product_type_hidden ? this.company_setup.in_add_invoice_product_type_hidden : false;
        this.company_setup.in_add_invoice_unit_type_hidden =  this.company_setup.in_add_invoice_unit_type_hidden ?  this.company_setup.in_add_invoice_unit_type_hidden : false;
        this.company_setup.in_add_invoice_remarks_hidden = this.company_setup.in_add_invoice_remarks_hidden ? this.company_setup.in_add_invoice_remarks_hidden : false;
        this.company_setup.in_add_invoice_paid_cgst_hidden = this.company_setup.in_add_invoice_paid_cgst_hidden ? this.company_setup.in_add_invoice_paid_cgst_hidden : false;
        this.company_setup.in_add_invoice_paid_sgst_hidden = this.company_setup.in_add_invoice_paid_sgst_hidden ? this.company_setup.in_add_invoice_paid_sgst_hidden : false;
        this.company_setup.in_add_invoice_paid_igst_hidden = this.company_setup.in_add_invoice_paid_igst_hidden ? this.company_setup.in_add_invoice_paid_igst_hidden : false;
        this.company_setup.in_add_invoice_total_paid_price_gst_hidden = this.company_setup.in_add_invoice_total_paid_price_gst_hidden ? this.company_setup.in_add_invoice_total_paid_price_gst_hidden : false;
        this.company_setup.is_budget_selection_at_item_level_in_product_table = this.company_setup.is_budget_selection_at_item_level_in_product_table ? this.company_setup.is_budget_selection_at_item_level_in_product_table : '0';
        this.company_setup.rename_project = this.company_setup.rename_project ? this.company_setup.rename_project : 'Project';
        this.company_setup.rename_task = this.company_setup.rename_task ? this.company_setup.rename_task : 'Task';
        this.company_setup.in_add_invoice_rejected_qty_hidden = this.company_setup.in_add_invoice_rejected_qty_hidden ? this.company_setup.in_add_invoice_rejected_qty_hidden : false;
      this.company_setup.additional_field_invoice_column_list = this.company_setup.additional_field_invoice_column_list ? this.company_setup.additional_field_invoice_column_list :[];
      this.company_setup.po_cgst_visible = this.company_setup.po_cgst_visible ? this.company_setup.po_cgst_visible : '0';
      this.company_setup.po_sgst_visible = this.company_setup.po_sgst_visible ? this.company_setup.po_sgst_visible : '0';
      this.company_setup.po_igst_visible = this.company_setup.po_igst_visible ? this.company_setup.po_igst_visible : '0';
      this.company_setup.po_ugst_visible = this.company_setup.po_ugst_visible ? this.company_setup.po_ugst_visible : '0';
      this.company_setup.po_cess_visible = this.company_setup.po_cess_visible ? this.company_setup.po_cess_visible : '0';
      this.company_setup.po_other_tax_visible = this.company_setup.po_other_tax_visible ? this.company_setup.po_other_tax_visible : '0';
      this.company_setup.channel_type_visible = this.company_setup.channel_type_visible ? this.company_setup.channel_type_visible : '0';
        let approval={approvals:[]}
        approval.approvals=this.tableDetails.data.approvals?this.tableDetails.data.approvals:[];
        this.company_setup.allowed_digits_after_decimal = this.company_setup.allowed_digits_after_decimal ? this.company_setup.allowed_digits_after_decimal : "2";
        this.company_setup.is_delivery_cc_visible_po = this.company_setup.is_delivery_cc_visible_po ? this.company_setup.is_delivery_cc_visible_po : '0';

        this.isHideApprover(approval);
//console.log(this.invApproval)
        if (this.commonVariableList.items) {
          for (let i of this.commonVariableList.items) {
            i.tds_section_name=i.tds_section_name?i.tds_section_name:i.vendor_tds_code;

            if ( this.tableDetails.data.is_custom_ship_to_location == '1') {
              i.location=this.tableDetails.data.custom_ship_to_location

            }
            i.po_qty = this.webService.convertNaN(i.po_qty, this.company_setup.allowed_digits_after_decimal)
            i.po_qty = parseFloat(i.po_qty)
            i.po_qty = this.webService.convertNaN(i.po_qty, this.company_setup.allowed_digits_after_decimal)


            i.total_required_qty = this.webService.convertNaN(i.total_required_qty, this.company_setup.allowed_digits_after_decimal)
            i.total_required_qty = parseFloat(i.total_required_qty)
            i.total_required_qty = this.webService.convertNaN(i.total_required_qty, this.company_setup.allowed_digits_after_decimal)


            i.budget_amount = i.budget_amount ? i.budget_amount : "0"
            i.rejected_qty = this.webService.convertNaN(i.rejected_qty, this.company_setup.allowed_digits_after_decimal)
            i.rejected_qty = parseFloat(i.rejected_qty)
            i.rejected_qty = this.webService.convertNaN(i.rejected_qty, this.company_setup.allowed_digits_after_decimal)



            i.po_unit_price = this.webService.convertNaN(i.po_unit_price, this.company_setup.allowed_digits_after_decimal)
            i.po_unit_price = parseFloat(i.po_unit_price)
            i.po_unit_price = this.webService.convertNaN(i.po_unit_price, this.company_setup.allowed_digits_after_decimal)


            i.invoice_unit_price = this.webService.convertNaN(i.invoice_unit_price, this.company_setup.allowed_digits_after_decimal)
            i.invoice_unit_price = parseFloat(i.invoice_unit_price)
            i.invoice_unit_price = this.webService.convertNaN(i.invoice_unit_price, this.company_setup.allowed_digits_after_decimal)

            i.invoice_qty = this.webService.convertNaN(i.invoice_qty, this.company_setup.allowed_digits_after_decimal)
            i.invoice_qty = parseFloat(i.invoice_qty)
            i.invoice_qty = this.webService.convertNaN(i.invoice_qty, this.company_setup.allowed_digits_after_decimal)

            i.accepted_qty = this.webService.convertNaN(i.accepted_qty, this.company_setup.allowed_digits_after_decimal)
            i.accepted_qty = parseFloat(i.accepted_qty)
            i.accepted_qty = this.webService.convertNaN(i.accepted_qty, this.company_setup.allowed_digits_after_decimal)

            i.product_unit_price = this.webService.convertNaN(i.product_unit_price, this.company_setup.allowed_digits_after_decimal)
            i.product_unit_price = parseFloat(i.product_unit_price)
            i.product_unit_price = this.webService.convertNaN(i.product_unit_price, this.company_setup.allowed_digits_after_decimal)
            i.grn_date = this.webService.formatDateAccordingToSetup(i.grn_date,this.company_setup.in_invoice_date_format)
            i.po_date = this.webService.formatDateAccordingToSetup(i.po_date,this.company_setup.in_invoice_date_format)
            i.irn_date = this.webService.formatDateAccordingToSetup(i.irn_date,this.company_setup.in_invoice_date_format)
            i.hsn_other_tax = i.hsn_other_tax ? i.hsn_other_tax : '0'
            i.hsn_ugst = i.hsn_ugst ? i.hsn_ugst : '0'
            i.hsn_cgst = i.hsn_cgst ? i.hsn_cgst : '0'
            i.hsn_sgst = i.hsn_sgst ? i.hsn_sgst : '0'
            i.hsn_igst = i.hsn_igst ? i.hsn_igst : '0'

            // paid
            i.paid_cess = this.webService.convertNaN(i.paid_cess)
            i.paid_other_tax = this.webService.convertNaN(i.paid_other_tax)
            i.paid_ugst = this.webService.convertNaN(i.paid_ugst)
            i.paid_cgst = this.webService.convertNaN(i.paid_cgst)
            i.paid_sgst = this.webService.convertNaN(i.paid_sgst)
            i.paid_igst = this.webService.convertNaN(i.paid_igst)

            // invoice
            i.invoice_cess = this.webService.convertNaN(i.invoice_cess)
            i.invoice_other_tax = this.webService.convertNaN(i.invoice_other_tax)
            i.invoice_ugst = this.webService.convertNaN(i.invoice_ugst)
            i.invoice_cgst = this.webService.convertNaN(i.invoice_cgst)
            i.invoice_sgst = this.webService.convertNaN(i.invoice_sgst)
            i.invoice_igst = this.webService.convertNaN(i.invoice_igst)


//Start :  new code written to first convert values into number  and then convert more than two digit decimal into two
  // paid
  i.paid_cess = parseFloat(i.paid_cess)
  i.paid_other_tax = parseFloat(i.paid_other_tax)
  i.paid_ugst = parseFloat(i.paid_ugst)
  i.paid_cgst = parseFloat(i.paid_cgst)
  i.paid_sgst = parseFloat(i.paid_sgst)
  i.paid_igst = parseFloat(i.paid_igst)

  // invoice
  i.invoice_cess = parseFloat(i.invoice_cess)
  i.invoice_other_tax = parseFloat(i.invoice_other_tax)
  i.invoice_ugst = parseFloat(i.invoice_ugst)
  i.invoice_cgst = parseFloat(i.invoice_cgst)
  i.invoice_sgst = parseFloat(i.invoice_sgst)
  i.invoice_igst = parseFloat(i.invoice_igst)



              // paid
              i.paid_cess = this.webService.convertNaN(i.paid_cess)
              i.paid_other_tax = this.webService.convertNaN(i.paid_other_tax)
              i.paid_ugst = this.webService.convertNaN(i.paid_ugst)
              i.paid_cgst = this.webService.convertNaN(i.paid_cgst)
              i.paid_sgst = this.webService.convertNaN(i.paid_sgst)
              i.paid_igst = this.webService.convertNaN(i.paid_igst)

              // invoice
              i.invoice_cess = this.webService.convertNaN(i.invoice_cess)
              i.invoice_other_tax = this.webService.convertNaN(i.invoice_other_tax)
              i.invoice_ugst = this.webService.convertNaN(i.invoice_ugst)
              i.invoice_cgst = this.webService.convertNaN(i.invoice_cgst)
              i.invoice_sgst = this.webService.convertNaN(i.invoice_sgst)
              i.invoice_igst = this.webService.convertNaN(i.invoice_igst)


 //Close :  new code written to first convert values into number  and then convert more than two digit decimal into two





            // paid
            i.hsn_cess = parseFloat(i.paid_cess) <= 0 ? '0' : i.hsn_cess;
            i.hsn_other_tax = parseFloat(i.paid_other_tax) <= 0 ? '0' : i.hsn_other_tax;
            i.hsn_ugst = parseFloat(i.paid_ugst) <= 0 ? '0' : i.hsn_ugst;
            i.hsn_cgst = parseFloat(i.paid_cgst) <= 0 ? '0' : i.hsn_cgst;
            i.hsn_sgst = parseFloat(i.paid_sgst) <= 0 ? '0' : i.hsn_sgst;
            i.hsn_igst = parseFloat(i.paid_igst) <= 0 ? '0' : i.hsn_igst;

            // invoice
            i.hsn_cess = parseFloat(i.invoice_cess) <= 0 ? '0' : i.hsn_cess;
            i.hsn_other_tax = parseFloat(i.invoice_other_tax) <= 0 ? '0' : i.hsn_other_tax;
            i.hsn_ugst = parseFloat(i.invoice_ugst) <= 0 ? '0' : i.hsn_ugst;
            i.hsn_cgst = parseFloat(i.invoice_cgst) <= 0 ? '0' : i.hsn_cgst;
            i.hsn_sgst = parseFloat(i.invoice_sgst) <= 0 ? '0' : i.hsn_sgst;
            i.hsn_igst = parseFloat(i.invoice_igst) <= 0 ? '0' : i.hsn_igst;

            i.rejected_qty = this.webService.convertNaN(i.rejected_qty, this.company_setup.allowed_digits_after_decimal)
            i.rejected_qty = parseFloat(i.rejected_qty)

            i.rejected_qty = this.webService.convertNaN(i.rejected_qty, this.company_setup.allowed_digits_after_decimal)

            i.gst_not_applicable = i.gst_not_applicable == '1' ? 'No': 'Yes';
            i.rcm_applicable = i.rcm_applicable == '1' ? 'Yes': 'No'
            i.project_name = i.project_name ? i.project_name : '';
            i.task_name = i.task_name ? i.task_name : '';

            i.invoice_no = i.invoice_no ? i.invoice_no : '';
            i.vendor_invoice_date = i.vendor_invoice_date ? i.vendor_invoice_date : '';
            let vendor_invoice_date = "";
            if(i.vendor_invoice_date != "" && i.vendor_invoice_date != null && i.vendor_invoice_date != undefined) {
              i.vendor_invoice_date = this.webService.formatDateAccordingToSetup(this.webService.getLocalDate(i.vendor_invoice_date),this.company_setup.in_invoice_date_format)
            }
            i.invoice_due_date = i.invoice_due_date ? i.invoice_due_date : '';
            if(i.invoice_due_date != "" && i.invoice_due_date != null && i.invoice_due_date != undefined) {
              i.invoice_due_date = this.webService.formatDateAccordingToSetup(this.webService.getLocalDate(i.invoice_due_date),this.company_setup.in_invoice_date_format)
            }
            i.ship_location_nickname_9_digit = i.ship_location_nickname_9_digit ? i.ship_location_nickname_9_digit : '';
            i.ship_location_code_9_digit = i.ship_location_code_9_digit ? i.ship_location_code_9_digit : '';
            i.ship_location_name = i.ship_location_nickname_9_digit + " (" + i.ship_location_code_9_digit + ")";
            i.to_from_loc_period = i.to_from_loc_period ? i.to_from_loc_period : '';
            i.miscellaneous = i.miscellaneous ? i.miscellaneous : '';
            i.shipping_bill_of_export_no = i.shipping_bill_of_export_no ? i.shipping_bill_of_export_no : '';
            i.delivery_cc_name = i.delivery_cc_name ? i.delivery_cc_name : '';
            i.po_cgst = i.po_cgst ? i.po_cgst : '';
            i.po_sgst = i.po_sgst ? i.po_sgst : '';
            i.po_igst = i.po_igst ? i.po_igst : '';
            i.po_ugst = i.po_ugst ? i.po_ugst : '';
            i.po_cess = i.po_cess ? i.po_cess : '';
            i.po_other_tax = i.po_other_tax ? i.po_other_tax : '';

            i.po_hsn_cgst = i.po_hsn_cgst ? i.po_hsn_cgst : '';
            i.po_hsn_sgst = i.po_hsn_sgst ? i.po_hsn_sgst : '';
            i.po_hsn_igst = i.po_hsn_igst ? i.po_hsn_igst : '';
            i.po_hsn_ugst = i.po_hsn_ugst ? i.po_hsn_ugst : '';
            i.po_hsn_cess = i.po_hsn_cess ? i.po_hsn_cess : '';
            i.po_hsn_other_tax = i.po_hsn_other_tax ? i.po_hsn_other_tax : '';

            i.po_hsn_cgst = i.po_cgst ? i.po_cgst != "" && i.po_cgst > 0 ? i.po_hsn_cgst : 0 : 0;
            i.po_hsn_sgst = i.po_sgst ? i.po_sgst != "" && i.po_sgst > 0 ? i.po_hsn_sgst : 0 : 0;
            i.po_hsn_igst = i.po_igst ? i.po_igst != "" && i.po_igst > 0 ? i.po_hsn_igst : 0 : 0;
            i.po_hsn_ugst = i.po_ugst ? i.po_ugst != "" && i.po_ugst > 0 ? i.po_hsn_ugst : 0 : 0;
            i.po_hsn_cess = i.po_cess ? i.po_cess != "" && i.po_cess > 0 ? i.po_hsn_cess : 0 : 0;
            i.po_hsn_other_tax = i.po_other_tax ? i.po_other_tax != "" && i.po_other_tax > 0 ? i.po_hsn_other_tax : 0 : 0;
          }
        }

        let showPaidUgst = this.tableDetails.data.showPaidUgst ? this.tableDetails.data.showPaidUgst : false;
        this.tableDetails.data.total_paid_ugst = this.tableDetails.data.total_paid_ugst ? this.tableDetails.data.total_paid_ugst : "0";
        if(parseFloat(this.webService.convertNaN(this.tableDetails.data.total_paid_ugst)) > 0) {
          showPaidUgst = true;
        }

        let showPaidCess = this.tableDetails.data.showPaidCess ? this.tableDetails.data.showPaidCess : false;
        this.tableDetails.data.total_paid_cess = this.tableDetails.data.total_paid_cess ? this.tableDetails.data.total_paid_cess : "0";
        if(parseFloat(this.webService.convertNaN(this.tableDetails.data.total_paid_cess)) > 0) {
          showPaidCess = true;
        }

        let showPaidOtherTax = this.tableDetails.data.showPaidOtherTax ? this.tableDetails.data.showshowPaidOtherTaxPaidUgst : false;
        this.tableDetails.data.total_paid_other_tax = this.tableDetails.data.total_paid_other_tax ? this.tableDetails.data.total_paid_other_tax : "0";
        if(parseFloat(this.webService.convertNaN(this.tableDetails.data.total_paid_other_tax)) > 0) {
          showPaidOtherTax = true;
        }

        let showInvoiceUgst = this.tableDetails.data.showInvoiceUgst ? this.tableDetails.data.showInvoiceUgst : false;
        this.tableDetails.data.total_invoice_ugst = this.tableDetails.data.total_invoice_ugst ? this.tableDetails.data.total_invoice_ugst : "0";
        if(parseFloat(this.webService.convertNaN(this.tableDetails.data.total_invoice_ugst)) > 0) {
          showInvoiceUgst = true;
        }

        let showInvoiceCESS = this.tableDetails.data.showInvoiceCESS ? this.tableDetails.data.showInvoiceCESS : false;
        this.tableDetails.data.total_invoice_cess = this.tableDetails.data.total_invoice_cess ? this.tableDetails.data.total_invoice_cess : "0";
        if(parseFloat(this.webService.convertNaN(this.tableDetails.data.total_invoice_cess)) > 0) {
          showInvoiceCESS = true;
        }

        let showInvoiceOtherTax = this.tableDetails.data.showInvoiceOtherTax ? this.tableDetails.data.showInvoiceOtherTax : false;
        this.tableDetails.data.total_invoice_other_tax = this.tableDetails.data.total_invoice_other_tax ? this.tableDetails.data.total_invoice_other_tax : "0";
        if(parseFloat(this.webService.convertNaN(this.tableDetails.data.total_invoice_other_tax)) > 0) {
          showInvoiceOtherTax = true;
        }


        let is_direct: any = '0';
        is_direct = this.tableDetails.data.is_direct ? this.tableDetails.data.is_direct : '0'
        let isMixedInv = this.tableDetails.data.isMixedInv ? this.tableDetails.data.isMixedInv : false;

        let is_good:boolean = this.commonVariableList.items.some((v) => {
          return v.product_type == 'services'
        })
        if (this.commonVariableList.columnList) {

          for (let i of this.commonVariableList.columnList) {

            if (i.value == 'balance_po_qty' && this.company_setup.is_balance_po_qty_visible_in_inv=='0') {
              i.is_view = false;
            }
            if (i.value == 'balance_po_qty' && this.company_setup.is_balance_po_qty_visible_in_inv=='1') {
              i.is_view = true;
            }
            if(i.value == 'balance_po_qty' &&  is_direct=='1')
            {
              i.is_view=false;
            }

            if (i.value == 'tds_section_name' && !is_good) {
              i.is_view = false;
            }
            if (i.value == 'tds_section_name' && is_good) {
              i.is_view = true;
            }

            if(!is_good)
            {
              // if (i.value == 'tds_section_name' && this.country_data.country!=='101') {
              //   i.is_view = false;
              // }
              // if (i.value == 'tds_section_name' && this.country_data.country=='101') {
              //   i.is_view = true;
              // }
            }
            if (i.value == 'tds_rate' && !is_good) {
              i.is_view = false;
            }
            if (i.value == 'tds_rate' && is_good) {
              i.is_view = true;
            }

            if(!is_good)
            {
              // if (i.value == 'tds_rate' && this.country_data.country!=='101') {
              //   i.is_view = false;
              // }
              // if (i.value == 'tds_rate' && this.country_data.country=='101') {
              //   i.is_view = true;
              // }
            }

            if(i.value == 'paid_cgst' && this.company_setup.custom_cgst_visible == '1'){
              i.display = this.company_setup.custom_cgst_name?`Paid ${this.company_setup.custom_cgst_name}`:'Paid CGST';
              i.is_view = true;
            }
            if(i.value == 'paid_sgst' && this.company_setup.custom_sgst_visible == '1'){
              i.display = this.company_setup.custom_sgst_name?`Paid ${this.company_setup.custom_sgst_name}`:'Paid SGST';
              i.is_view = true;
            }
            if(i.value == 'paid_igst' && this.company_setup.custom_igst_visible == '1'){
              i.display = this.company_setup.custom_igst_name?`Paid ${this.company_setup.custom_igst_name}`:'Paid IGST';
              i.is_view = true;
            }
            if(i.value == 'paid_ugst'){
              i.display = this.company_setup.custom_ugst_name?`Paid ${this.company_setup.custom_ugst_name}`:'Paid UGST';
              if(this.company_setup.custom_ugst_visible == '1' && showPaidUgst){
                i.is_view = true;
              }else{
                i.is_view = false;
              }
            }
            if(i.value == 'paid_cess'){
              i.display = this.company_setup.custom_cess_name?`Paid ${this.company_setup.custom_cess_name}`:'Paid CESS';
              if(this.company_setup.custom_cess_visible == '1' && showPaidCess){
                i.is_view = true;
              }else{
                i.is_view = false;
              }
            }
            if(i.value == 'paid_other_tax'){
              i.display = this.company_setup.custom_other_tax_name?`Paid ${this.company_setup.custom_other_tax_name}`:'Paid Other Tax';
              if(this.company_setup.custom_other_tax_visible == '1' && showPaidOtherTax){
                i.is_view = true;
              }else{
                i.is_view = false;
              }
            }

            if(i.value == 'invoice_cgst' && this.company_setup.custom_cgst_visible == '1'){
              i.display = this.company_setup.custom_cgst_name?`Invoice ${this.company_setup.custom_cgst_name}`:'Invoice CGST';
              i.is_view = true;
            }
            if(i.value == 'invoice_sgst' && this.company_setup.custom_sgst_visible == '1'){
              i.display = this.company_setup.custom_sgst_name?`Invoice ${this.company_setup.custom_sgst_name}`:'Invoice SGST';
              i.is_view = true;
            }
            if(i.value == 'invoice_igst' && this.company_setup.custom_igst_visible == '1'){
              i.display = this.company_setup.custom_igst_name?`Invoice ${this.company_setup.custom_igst_name}`:'Invoice IGST';
              i.is_view = true;
            }
            if(i.value == 'invoice_ugst'){
              i.display = this.company_setup.custom_ugst_name?`Invoice ${this.company_setup.custom_ugst_name}`:'Invoice UGST';
              if(this.company_setup.custom_ugst_visible == '1' && showInvoiceUgst){
                i.is_view = true;
              }else{
                i.is_view = false;
              }
            }
            if(i.value == 'invoice_cess'){
              i.display = this.company_setup.custom_cess_name?`Invoice ${this.company_setup.custom_cess_name}`:'Invoice CESS';
              if(this.company_setup.custom_cess_visible == '1' && showInvoiceCESS){
                i.is_view = true;
              }else{
                i.is_view = false;
              }
            }
            if(i.value == 'invoice_other_tax'){
              i.display = this.company_setup.custom_other_tax_name?`Invoice ${this.company_setup.custom_other_tax_name}`:'Invoice Other Tax';
              if(this.company_setup.custom_other_tax_visible == '1' && showInvoiceOtherTax){
                i.is_view = true;
              }else
              i.is_view = false;
            }

            if(i.value == 'paid_tax' && this.company_setup.custom_total_gst_visible == '1'){
              i.is_view = true;
            }
            if(i.value == 'invoice_tax' && this.company_setup.custom_total_gst_visible == '1'){
              i.is_view = true;
            }

            if(i.value == 'paid_tax' && this.company_setup.custom_total_gst_visible == '0'){
              i.is_view = false;
            }
            if(i.value == 'invoice_tax' && this.company_setup.custom_total_gst_visible == '0'){
              i.is_view = false;
            }

            if(i.value == 'hsn_code' && this.company_setup.is_hsn_code_visible == '1'){
              i.display =this.company_setup.custom_hsn_code;
              i.is_view = true;
            }
            if(i.value == 'gst_not_applicable' && this.company_setup.inv_rcm_applicable_visible == '1'){
              i.display = "GST Not Applicable";
              i.is_view = true;
            }

            if(i.value == 'gst_not_applicable' && this.is_vendor == '1'){
              // Check if this specific invoice data has GST columns visible
              if (this.tableDetails.data.is_direct == '1') {
                // For direct invoice data - check if GST columns are visible in this data
                i.is_view = this.isDirectInvoiceVisibled('gst_input_applicable');
                i.display = "GST Input Applicable";
              } else {
                // For regular invoice data - check if GST columns are visible in this data  
                i.is_view = this.isAddinvoiceVisibled('gst_input_applicable');
                i.display = "GST Input Applicable";
              }
            }
            if(i.value == 'rcm_applicable' && this.company_setup.inv_gst_input_available_visible == '1'){
              i.display = "RCM Applicable";
              i.is_view = true;
            }
            if(i.value == 'rcm_applicable'&& this.is_vendor == '1'){
              // Check if this specific invoice data has RCM columns visible
              if (this.tableDetails.data.is_direct == '1') {
                // For direct invoice data - check if RCM columns are visible in this data
                i.is_view = this.isDirectInvoiceVisibled('rcm_applicable');
                // i.display = "RCM Applicable"
              } else {
                // For regular invoice data - check if RCM columns are visible in this data
                i.is_view = this.isAddinvoiceVisibled('rcm_applicable');
                // i.display = "RCM Applicable"
              }
            }

            
            if(i.value == 'po_cgst' && this.company_setup.po_cgst_visible == '1' && is_direct != '1'){
              i.display = 'PO CGST';
              i.is_view = true;
            }
            if(i.value == 'po_cgst' && (this.company_setup.po_cgst_visible != '1' || is_direct == '1')){
              i.is_view = false;
            }
            if(i.value == 'po_sgst' && this.company_setup.po_sgst_visible == '1' && is_direct != '1'){
              i.display = 'PO SGST';
              i.is_view = true;
            }
            if(i.value == 'po_sgst' && (this.company_setup.po_sgst_visible != '1' || is_direct == '1')){
              i.is_view = false;
            }
            if(i.value == 'po_igst' && this.company_setup.po_igst_visible == '1' && is_direct != '1'){
              i.display = 'PO IGST';
              i.is_view = true;
            }
            if(i.value == 'po_igst' && (this.company_setup.po_igst_visible != '1' || is_direct == '1')){
              i.is_view = false;
            }
            if(i.value == 'po_ugst' && this.company_setup.po_ugst_visible == '1' && is_direct != '1'){
              i.display = 'PO UGST';
              i.is_view = true;
            }
            if(i.value == 'po_ugst' && (this.company_setup.po_ugst_visible != '1' || is_direct == '1')){
              i.is_view = false;
            }
            if(i.value == 'po_cess' && this.company_setup.po_cess_visible == '1' && is_direct != '1'){
              i.display = 'PO CESS';
              i.is_view = true;
            }
            if(i.value == 'po_cess' && (this.company_setup.po_cess_visible != '1' || is_direct == '1')){
              i.is_view = false;
            }
            if(i.value == 'po_other_tax' && this.company_setup.po_other_tax_visible == '1' && is_direct != '1'){
              i.display = 'PO Other Tax';
              i.is_view = true;
            }
            if(i.value == 'po_other_tax' && (this.company_setup.po_other_tax_visible != '1' || is_direct == '1')){
              i.is_view = false;
            }
            
            // PO Unit Price - only show for PO-based invoices
            if(i.value == 'po_unit_price' && is_direct != '1'){
              i.is_view = true;
            }
            if(i.value == 'po_unit_price' && is_direct == '1'){
              i.is_view = false;
            }
            if (i.value == 'po_no' && this.tableDetails.data.is_multi_grn_invoice == '0') {
              i.display = "PO No"
              i.is_view = false;
            }
            if (i.value == 'po_no' && this.tableDetails.data.is_multi_grn_invoice == '1') {
              i.display = "PO No";
              i.is_view = true;
            }

            if (i.value == 'po_date' && this.tableDetails.data.is_multi_grn_invoice == '0') {
              i.display = "PO Date"
              i.is_view = false;
            }
            if (i.value == 'po_date' && this.tableDetails.data.is_multi_grn_invoice == '1') {
              i.display = "PO Date";
              i.is_view = true;
            }

            if (i.value == 'irn_cs_id' && this.tableDetails.data.is_multi_grn_invoice == '0') {
              i.display =this.company_setup.in_invoice_irn_no_custom_name;
              i.is_view = false;
            }
            if (i.value == 'irn_cs_id' && this.tableDetails.data.is_multi_grn_invoice == '1') {
              i.display = this.company_setup.in_invoice_irn_no_custom_name;
              i.is_view = true;
            }

            if (i.value == 'irn_date' && this.tableDetails.data.is_multi_grn_invoice == '0') {
              i.display = this.irn_to_grn + " Date";

              i.is_view = false;
            }
            if (i.value == 'irn_date' && this.tableDetails.data.is_multi_grn_invoice == '1') {
              i.display = this.irn_to_grn + " Date";
              i.is_view = true;
            }

            if (i.value == 'grn_cs_id' && this.tableDetails.data.is_multi_grn_invoice == '0') {
              i.display = this.company_setup.in_invoice_grn_no_custom_name
              i.is_view = false;
            }
            if (i.value == 'grn_cs_id' && this.tableDetails.data.is_multi_grn_invoice == '1') {
              i.display =this.company_setup.in_invoice_grn_no_custom_name
              i.is_view = true;
            }

            if (i.value == 'grn_date' && this.tableDetails.data.is_multi_grn_invoice == '0') {
              i.display = this.company_setup.grn_date_custom_name
              i.is_view = false;
            }
            if (i.value == 'grn_date' && this.tableDetails.data.is_multi_grn_invoice == '1') {
              i.display = this.company_setup.grn_date_custom_name;
              i.is_view = true;
            }



            if (i.value == 'conversion_unit_price' && this.tableDetails.data.is_different_document_currency == '0') {
              i.display = "FC (PO) Unit Price"
              i.is_view = false;
            }
            if (i.value == 'conversion_unit_price' && this.tableDetails.data.is_different_document_currency == '1') {
              i.display = "FC (PO) Unit Price" + "(" + this.tableDetails.data.currency_code + ")";
              if(this.company_setup.remove_fc_po_from_product_table == '1' && this.tableDetails.data.is_direct == '1'){
                i.is_view = false;
              }else{
                i.is_view = true;
              }
            }

            if (i.value == 'conversion_paid_price' && this.tableDetails.data.is_different_document_currency == '0') {
              i.display = "FC Paid Price Per Unit"
              i.is_view = false;
            }
            if (i.value == 'conversion_paid_price' && this.tableDetails.data.is_different_document_currency == '1') {
              i.display = "FC Paid Price Per Unit" + "(" + this.tableDetails.data.currency_code + ")";
              i.is_view = true;
            }

            if (i.value == 'conversion_invoice_price' && this.tableDetails.data.is_different_document_currency == '0') {
              i.display = "FC Invoice Unit Price"
              i.is_view = false;
            }
            if (i.value == 'conversion_invoice_price' && this.tableDetails.data.is_different_document_currency == '1') {
              i.display = "FC Invoice Unit Price" + "(" + this.tableDetails.data.currency_code + ")";
              i.is_view = true;
            }

            if (i.value == 'total_required_qty' && this.tableDetails.data.is_direct == '1') {
              i.is_view = false;
            }
            if (i.value == 'total_required_qty' && this.tableDetails.data.is_direct == '0') {
              i.is_view = true;
            }


            if (i.value == 'product_catalog_id' && this.company_setup.product_catalog_id == '1') {
              i.is_view = true;
            }
            if (i.value == 'product_catalog_id' && this.company_setup.product_catalog_id == '0') {
              i.is_view = false;
            }
            
            if (i.value == 'product_description' && this.company_setup.while_raising_a_invoice_prod_Desc_Visible == '1') {
              i.is_view = true;
            }
            if (i.value == 'product_description' && this.company_setup.while_raising_a_invoice_prod_Desc_Visible == '0') {
              i.is_view = false;
            }

            // Hide Product Description column using the same pattern
            if(i.value == 'product_description' && this.is_vendor == '1'){
              if (this.tableDetails.data.is_direct == '1') {
                // For direct invoice - check if product description is visible
                i.is_view = this.isDirectInvoiceVisibled('product_description');
              } else {
                // For regular invoice - check if product description is visible
                i.is_view = this.isAddinvoiceVisibled('product_description');
              }
            }
            

            // if (i.value == 'rejected_qty' && is_direct == '0') {
            //   i.is_view = true;
            // }
            if (i.value == 'rejected_qty' && is_direct == '1') {

              if (this.company_setup.is_rejected_qty_visible_in_direct_invoice=='1') {
                i.is_view = true;
              }
              if (this.company_setup.is_rejected_qty_visible_in_direct_invoice=='0') {
                i.is_view = false;
              }
            }
            if (i.value == 'rejected_qty' && is_direct == '0') {
              if (this.company_setup.in_add_invoice_rejected_qty_hidden=='1') {
                i.is_view = false;
              }

              if (this.company_setup.in_add_invoice_rejected_qty_hidden=='0') {
                i.is_view = true;
              }
            }
            // if (i.value == 'rejected_qty' && is_direct == '0' && this.company_setup.in_add_invoice_rejected_qty_hidden =='1') {
            //   i.is_view = true;
            // }

            // && this.page_url == '/all-invoices'
            if (i.value == 'accepted_qty' && is_direct == '1' && this.company_setup.is_accepted_qty_hidden && !isMixedInv) {
              i.is_view = false;
            } else if(i.value == 'accepted_qty' && is_direct == '0' && this.company_setup.in_add_invoice_accepted_qty_hidden && !isMixedInv) {
              i.is_view = false;
            } else if(i.value == 'accepted_qty' && this.company_setup.in_add_invoice_accepted_qty_hidden && isMixedInv) {
              i.is_view = false;
            } else if(i.value == 'accepted_qty') {
              i.is_view = true;
            }

            // Accepted Free Qty column — invoice module only (not PO/IRN/GRN).
            // Keep logic based on report type (id) instead of display text to avoid label mismatches.
            if (i.value == 'free_qty' && (this.tableDetails.id == 'invoicereport' || this.tableDetails.id == 'recurring_invoicereport')) {
              i.is_view = (this.company_setup.enable_accepted_free_quantity_in_invoice == '1');
            }

            if (i.value == 'unit_type_name' && is_direct == '1' && this.company_setup.is_unit_type_hidden && !isMixedInv) {
              i.is_view = false;
            } else if(i.value == 'unit_type_name' && is_direct == '0' && this.company_setup.in_add_invoice_unit_type_hidden && !isMixedInv){
              i.is_view = false;
            } else if(i.value == 'unit_type_name'  && this.company_setup.in_add_invoice_unit_type_hidden && isMixedInv){
              i.is_view = false;
            } else if(i.value == 'unit_type_name') {
              i.is_view = true;
            }

            if (i.value == 'remarks' && is_direct == '1' && this.company_setup.is_remarks_hidden && !isMixedInv) {
              i.is_view = false;
            } else if(i.value == 'remarks' && is_direct == '0' && this.company_setup.in_add_invoice_remarks_hidden && !isMixedInv){
              i.is_view = false;
            } else if(i.value == 'remarks'  && this.company_setup.in_add_invoice_remarks_hidden && isMixedInv){
              i.is_view = false;
            } else if(i.value == 'remarks') {
              i.is_view = true;
            }
            
            if (i.value == 'product_type' && is_direct == '1' && this.company_setup.is_product_type_hidden && !isMixedInv) {
              i.is_view = false;
            } else if(i.value == 'product_type' && is_direct == '0' && this.company_setup.in_add_invoice_product_type_hidden && !isMixedInv){
              i.is_view = false;
            } else if(i.value == 'product_type'  && this.company_setup.in_add_invoice_product_type_hidden && isMixedInv){
              i.is_view = false;
            } else if(i.value == 'product_type') {
              i.is_view = true;
            }
            // if (i.value == 'product_description' && is_direct == '1' && this.company_setup.is_product_description_hidden && !isMixedInv) {
            //   i.is_view = false;
            // } else if(i.value == 'product_description') {
            //   i.is_view = true;
            // }
            if (i.value == 'paid_unit_price' && is_direct == '1' && this.company_setup.is_paid_price_hidden && !isMixedInv) {
              i.is_view = false;
            } else if(i.value == 'paid_unit_price' && is_direct == '0' && this.company_setup.in_add_invoice_paid_price_hidden && !isMixedInv){
              i.is_view = false;
            } else if(i.value == 'paid_unit_price'  && this.company_setup.in_add_invoice_paid_price_hidden && isMixedInv){
              i.is_view = false;
            } else if(i.value == 'paid_unit_price') {
              i.is_view = true;
            }

            if (i.value == 'paid_total_price' && is_direct == '1' && this.company_setup.is_total_paid_price_hidden && !isMixedInv) {
              i.is_view = false;
            } else if(i.value == 'paid_total_price' && is_direct == '0' && this.company_setup.in_add_invoice_total_paid_price_hidden && !isMixedInv){
              i.is_view = false;
            } else if(i.value == 'paid_total_price'  && this.company_setup.in_add_invoice_total_paid_price_hidden && isMixedInv){
              i.is_view = false;
            } else if(i.value == 'paid_total_price') {
              i.is_view = true;
            }

            if (i.value == 'difference_unit_price' && is_direct == '1' && this.company_setup.is_difference_price_hidden && !isMixedInv) {
              i.is_view = false;
            } else if(i.value == 'difference_unit_price' && is_direct == '0' && this.company_setup.in_add_invoice_difference_price_hidden && !isMixedInv){
              i.is_view = false;
            } else if(i.value == 'difference_unit_price'  && this.company_setup.in_add_invoice_difference_price_hidden && isMixedInv){
              i.is_view = false;
            } else if(i.value == 'difference_unit_price') {
              i.is_view = true;
            }

            if (i.value == 'difference_total_price' && is_direct == '1' && this.company_setup.is_total_difference_price_hidden && !isMixedInv) {
              i.is_view = false;
            } else if(i.value == 'difference_total_price' && is_direct == '0' && this.company_setup.in_add_invoice_total_difference_price_hidden && !isMixedInv){
              i.is_view = false;
            } else if(i.value == 'difference_total_price'  && this.company_setup.in_add_invoice_total_difference_price_hidden && isMixedInv){
              i.is_view = false;
            } else if(i.value == 'difference_total_price') {
              i.is_view = true;
            }

            if (i.value == 'paid_grand_total' && is_direct == '1' && this.company_setup.is_total_price_hidden && !isMixedInv) {
              i.is_view = false;
            } else if(i.value == 'paid_grand_total' && is_direct == '0' && this.company_setup.in_add_invoice_total_price_hidden && !isMixedInv){
              i.is_view = false;
            } else if(i.value == 'paid_grand_total'  && this.company_setup.in_add_invoice_total_price_hidden && isMixedInv){
              i.is_view = false;
            } else if(i.value == 'paid_grand_total') {
              i.is_view = true;
            }

            if(i.value == 'location'){
               i.display = this.company_setup.custom_ship_location_name ? this.company_setup.custom_ship_location_name : 'Ship Location';
               this.company_setup.show_loc_dropdown = this.company_setup.show_loc_dropdown ? this.company_setup.show_loc_dropdown : '0';
              //  this.company_setup.show_loc_dropdown = is_direct == '1' ? this.company_setup.show_loc_dropdown : '0';
               i.is_view = this.company_setup.show_loc_dropdown == '1' ? false : true;
            }
            if(i.value == 'paid_grand_total'){
              i.display = this.company_setup.in_invoice_custom_name_for_total_price ? this.company_setup.in_invoice_custom_name_for_total_price : 'Total Price';
             }

            if (i.value == 'total_required_qty' && is_direct == '0') {
              i.is_view = true;
            }
            if (i.value == 'total_required_qty' && is_direct == '1') {
              i.is_view = false;
            }

            if (i.value == 'budget_amount' && this.company_setup.is_balance_budget_amount_visible_in_invoice == '1') {
              i.is_view = true;
            }
            if (i.value == 'budget_amount' && this.company_setup.is_balance_budget_amount_visible_in_invoice == '0') {
              i.is_view = false;
            }
            if (i.value == 'paid_cgst' && is_direct == '1' && this.company_setup.is_paid_cgst_hidden && !isMixedInv) {
              i.is_view = false;
            } else if(i.value == 'paid_cgst' && is_direct == '0' && this.company_setup.in_add_invoice_paid_cgst_hidden && !isMixedInv){
              i.is_view = false;
            } else if(i.value == 'paid_cgst'  && this.company_setup.in_add_invoice_paid_cgst_hidden && isMixedInv){
              i.is_view = false;
            } else if(i.value == 'paid_cgst') {
              i.is_view = true;
            }

            if (i.value == 'paid_sgst' && is_direct == '1' && this.company_setup.is_paid_sgst_hidden && !isMixedInv) {
              i.is_view = false;
            } else if(i.value == 'paid_sgst' && is_direct == '0' && this.company_setup.in_add_invoice_paid_sgst_hidden && !isMixedInv){
              i.is_view = false;
            } else if(i.value == 'paid_sgst'  && this.company_setup.in_add_invoice_paid_sgst_hidden && isMixedInv){
              i.is_view = false;
            } else if(i.value == 'paid_sgst') {
              i.is_view = true;
            }

            if (i.value == 'paid_igst' && is_direct == '1' && this.company_setup.is_paid_igst_hidden && !isMixedInv) {
              i.is_view = false;
            } else if(i.value == 'paid_igst' && is_direct == '0' && this.company_setup.in_add_invoice_paid_igst_hidden && !isMixedInv){
              i.is_view = false;
            } else if(i.value == 'paid_igst'  && this.company_setup.in_add_invoice_paid_igst_hidden && isMixedInv){
              i.is_view = false;
            } else if(i.value == 'paid_igst') {
              i.is_view = true;
            }

            if (i.value == 'paid_tax' && is_direct == '1' && this.company_setup.is_total_paid_price_gst_hidden && !isMixedInv) {
              i.is_view = false;
            } else if(i.value == 'paid_tax' && is_direct == '0' && this.company_setup.in_add_invoice_total_paid_price_gst_hidden && !isMixedInv){
              i.is_view = false;
            } else if(i.value == 'paid_tax'  && this.company_setup.in_add_invoice_total_paid_price_gst_hidden && isMixedInv){
              i.is_view = false;
            } else if(i.value == 'paid_tax') {
              i.is_view = true;
            }
            
            let arr = ["tds_section_name", "tds_rate"]
            if (arr.includes(i.value) && (this.company_setup.hide_invoice_tds_related_fields == '1' || this.company_setup.invoice_raiser_hide_tds=='1')) {
              i.is_view = false;
            }
            if(i.value=='project_name') {
              i.display = this.company_setup.rename_project;
              if((show_multi_inv=='1' && this.company_setup.is_project_visible_in_invoice == '1') || this.company_setup.is_budget_selection_at_item_level_in_product_table == '1') {
                i.is_view = true;
              } else {
                i.is_view = false;
              }
            }
            if(i.value=='task_name') {
              i.display = this.company_setup.rename_task;
              if((show_multi_inv=='1' && this.company_setup.is_task_visible_in_invoice == '1') || this.company_setup.is_budget_selection_at_item_level_in_product_table == '1') {
                i.is_view = true;
              } else {
                i.is_view = false;
              }
            }
            if(i.value == 'amortization_type') {
              i.display = this.getColumnName(this.company_setup.additional_field_invoice_column_list,'amortization_type','Amortization Type');
              i.is_view = this.company_setup.amortization_type_visible;
            }
            if(i.value == 'amortization_start_date') {
              i.display = this.getColumnName(this.company_setup.additional_field_invoice_column_list,'amortization_start_date','Amortization Start Date');
              i.is_view = this.company_setup.amortization_start_date_visible;
            }
            if(i.value == 'amortization_end_date') {
              i.display = this.getColumnName(this.company_setup.additional_field_invoice_column_list,'amortization_end_date','Amortization End Date');
              i.is_view = this.company_setup.amortization_end_date_visible;
            }
            if(i.value == 'field4') {
              i.display = this.getColumnName(this.company_setup.additional_field_invoice_column_list,'field4','Field 4');
              i.is_view = this.company_setup.field4_visible;
            }
            if(i.value == 'field5') {
              i.display = this.getColumnName(this.company_setup.additional_field_invoice_column_list,'field5','Field 5');
              i.is_view = this.company_setup.field5_visible;
            }
            if(i.value == 'field6') {
              i.display = this.getColumnName(this.company_setup.additional_field_invoice_column_list,'field6','Field 6');
              i.is_view = this.company_setup.field6_visible;
            }
            if (i.value == 'channel_type_name') {
              i.display = this.getColumnName(this.company_setup.additional_field_invoice_column_list, 'channel_type', 'Channel Type');
              i.is_view = this.company_setup.channel_type_visible;
            }
            if(i.value == 'invoice_no') {
              if(show_multi_inv=='1') {
                i.is_view = true;
              } else {
                i.is_view = false;
              }
            }
            if(i.value == 'vendor_invoice_date') {
              if(show_multi_inv=='1') {
                i.is_view = true;
              } else {
                i.is_view = false;
              }
            }
            if(i.value == 'invoice_due_date') {
              if(show_multi_inv=='1') {
                i.is_view = true;
              } else {
                i.is_view = false;
              }
            }
            if(i.value == 'ship_location_name') {
              i.display = this.company_setup.custom_ship_location_name ? this.company_setup.custom_ship_location_name : 'Ship Location';
              if(show_multi_inv=='1') {
                i.is_view = true;
              } else {
                i.is_view = false;
              }
            }
            if(i.value == 'to_from_loc_period') {
              console.log("this.company_setup.in_invoice_period_is_visible", this.company_setup.in_invoice_period_is_visible)
              i.display = this.company_setup.in_invoice_custom_name_for_period ? this.company_setup.in_invoice_custom_name_for_period : 'Period';
              if(show_multi_inv=='1' && this.company_setup.in_invoice_period_is_visible == '1') {
                i.is_view = true;
              } else {
                i.is_view = false;
              }
            }
            if(i.value == 'miscellaneous') {
              if(show_multi_inv=='1' && this.company_setup.in_invoice_miscellaneous_is_visible == '1') {
                i.is_view = true;
              } else {
                i.is_view = false;
              }
            }
            if(i.value == 'shipping_bill_of_export_no') {
              if(show_multi_inv=='1' && this.company_setup.in_invoice_shipping_bill_and_bill_of_export_no_is_visible == '1') {
                i.is_view = true;
              } else {
                i.is_view = false;
              }
            }
            if (i.value == 'delivery_cc_name') {
              if (this.company_setup.is_delivery_cc_visible_po == '1' && is_direct == '0') {
                i.is_view = true;
              } else if (this.company_setup.is_delivery_cc_visible_po == '0' || is_direct == '1') {
                i.is_view = false;
              }
            }
          }
        }
        this.je_table=this.tableDetails.data.je_table?this.tableDetails.data.je_table:[]
        if(this.je_table)
        {
          for(let  i of this.je_table)
          {
            i.jeDetails=i.jeDetails?i.jeDetails:[]
          }
        }
        this.makeData();


        break;
        case 'dcnotereport':
          this.commonVariableList.columnList = globalVariables.dcNoteVariableList.columnList;
          this.commonVariableList.items = this.tableDetails.data.items ? this.tableDetails.data.items : [];
          this.tableDetails.data.currency_code = this.tableDetails.data.currency_code ? this.tableDetails.data.currency_code : '';
          this.company_setup.default_currency_code = this.company_setup.default_currency_code ? this.company_setup.default_currency_code : 'INR';
          if(this.commonVariableList.columnList) {
            for(let x  of this.commonVariableList.columnList) {

              if(x.value=='cgst' && this.company_setup.custom_cgst_visible=='1'){
                x.is_view = true;
              }
              if(x.value=='cgst'&& this.company_setup.custom_cgst_visible=='0'){
                x.is_view = false;
              }
              if(x.value=='sgst' && this.company_setup.custom_sgst_visible=='1'){
                x.is_view = true;
              }
              if(x.value=='sgst'&& this.company_setup.custom_sgst_visible=='0'){
                x.is_view = false;
              }
              if(x.value=='igst' && this.company_setup.custom_igst_visible=='1'){
                x.is_view = true;
              }
              if(x.value=='igst'&& this.company_setup.custom_igst_visible=='0'){
                x.is_view = false;
              }
              if(x.value=='ugst' && this.company_setup.custom_ugst_visible=='1'){
                x.is_view = true;
              }
              if(x.value=='ugst'&& this.company_setup.custom_ugst_visible=='0'){
                x.is_view = false;
              }
              if(x.value=='cess' && this.company_setup.custom_cess_visible=='1'){
                x.is_view = true;
              }
              if(x.value=='cess'&& this.company_setup.custom_cess_visible=='0'){
                x.is_view = false;
              }
              if(x.value=='other_tax' && this.company_setup.custom_other_tax_visible=='1'){
                x.is_view = true;
              }
              if(x.value=='other_tax'&& this.company_setup.custom_other_tax_visible=='0'){
                x.is_view = false;
              }
              if (x.value == 'cgst' && this.company_setup.custom_cgst_visible == '1') {
                x.display = this.company_setup.custom_cgst_name + (this.tableDetails.data.is_different_document_currency == '1' ? ' ('+this.company_setup.default_currency_code+')' : '');
            }
            if (x.value == 'sgst' && this.company_setup.custom_sgst_visible == '1') {
                x.display = this.company_setup.custom_sgst_name + (this.tableDetails.data.is_different_document_currency == '1' ? ' ('+this.company_setup.default_currency_code+')' : '');
            }
            if (x.value == 'igst' && this.company_setup.custom_igst_visible == '1') {
                x.display = this.company_setup.custom_igst_name + (this.tableDetails.data.is_different_document_currency == '1' ? ' ('+this.company_setup.default_currency_code+')' : '');
            }
            if (x.value == 'ugst' && this.company_setup.custom_ugst_visible == '1') {
                x.display = this.company_setup.custom_ugst_name + (this.tableDetails.data.is_different_document_currency == '1' ? ' ('+this.company_setup.default_currency_code+')' : '');
            }
            if (x.value == 'cess' && this.company_setup.custom_cess_visible == '1') {
                x.display = this.company_setup.custom_cess_name + (this.tableDetails.data.is_different_document_currency == '1' ? ' ('+this.company_setup.default_currency_code+')' : '');
            }
            if (x.value == 'amount') {
              x.display = 'Amount ' + (this.tableDetails.data.is_different_document_currency == '1' ? ' ('+this.company_setup.default_currency_code+')' : '');
            }
            if (x.value == 'total_gst') {
              x.display = 'Total GST ' + (this.tableDetails.data.is_different_document_currency == '1' ? ' ('+this.company_setup.default_currency_code+')' : '');
            }
            if (x.value == 'total_amount') {
              x.display = 'Total Amount ' + (this.tableDetails.data.is_different_document_currency == '1' ? ' ('+this.company_setup.default_currency_code+')' : '');
            }
             if (x.value == 'other_tax' && this.company_setup.custom_other_tax_visible == '1') {
                x.display = this.company_setup.custom_other_tax_name +  (this.tableDetails.data.is_different_document_currency == '1' ? '('+this.company_setup.default_currency_code+')':'');
            }
            
              // if (x.value == 'other_tax' && this.company_setup.custom_other_tax_visible == '1') {
              //   x.display = this.company_setup.custom_other_tax_name && this.company_setup.default_currency_code;
              // }
              if (x.value == 'ddc_amount' && this.tableDetails.data.is_different_document_currency == '1' && (this.tableDetails.data.note_type=='2' ||this.tableDetails.data.note_type=='1')) {
                x.display = "Amount (" + this.tableDetails.data.currency_code + ")";
                x.is_view=true;
              }
             


            }
          }
          if (this.commonVariableList.items) {
            for (let d of this.commonVariableList.items) {
              d.hsn_other_tax = d.hsn_other_tax ? d.hsn_other_tax : '0'
              d.hsn_ugst = d.hsn_ugst ? d.hsn_ugst : '0'
              d.hsn_cgst = d.hsn_cgst ? d.hsn_cgst : '0'
              d.hsn_sgst = d.hsn_sgst ? d.hsn_sgst : '0'
              d.hsn_igst = d.hsn_igst ? d.hsn_igst : '0'

              d.cess = this.webService.convertNaN(d.cess)
              d.other_tax = this.webService.convertNaN(d.other_tax)
              d.ugst = this.webService.convertNaN(d.ugst)
              d.cgst = this.webService.convertNaN(d.cgst)
              d.sgst = this.webService.convertNaN(d.sgst)
              d.igst = this.webService.convertNaN(d.igst)

              d.cess = parseFloat(d.cess)
              d.other_tax = parseFloat(d.other_tax)
              d.ugst = parseFloat(d.ugst)
              d.cgst = parseFloat(d.cgst)
              d.sgst = parseFloat(d.sgst)
              d.igst = parseFloat(d.igst)


              d.cgst=this.webService.convertNaN(d.cgst)
              d.sgst=this.webService.convertNaN(d.sgst)
              d.igst=this.webService.convertNaN(d.igst)
              d.ugst=this.webService.convertNaN(d.ugst)
              d.cess=this.webService.convertNaN(d.cess)
              d.other_tax=this.webService.convertNaN(d.other_tax)


              d.hsn_cess = parseFloat(d.cess) <= 0 ? '' : d.hsn_cess;
              d.hsn_other_tax = parseFloat(d.other_tax) <= 0 ? '' : d.hsn_other_tax;
              d.hsn_ugst = parseFloat(d.ugst) <= 0 ? '' : d.hsn_ugst;
              d.hsn_cgst = parseFloat(d.cgst) <= 0 ? '' : d.hsn_cgst;
              d.hsn_sgst = parseFloat(d.sgst) <= 0 ? '' : d.hsn_sgst;
              d.hsn_igst = parseFloat(d.igst) <= 0 ? '' : d.hsn_igst;
            }
          }

          this.je_table=this.tableDetails.data.je_table?this.tableDetails.data.je_table:[]
          if(this.je_table)
          {
            for(let  i of this.je_table)
            {
              i.jeDetails=i.jeDetails?i.jeDetails:[]
            }
          }
          this.makeData();

          break;
      case 'creditnotereport':
        this.commonVariableList.columnList = globalVariables.creditNoteVariableList.columnList;
        this.commonVariableList.items = this.tableDetails.data.items ? this.tableDetails.data.items : [];
        this.tableDetails.data.currency_code = this.tableDetails.data.currency_code ? this.tableDetails.data.currency_code : '';
        this.company_setup.default_currency_code = this.company_setup.default_currency_code ? this.company_setup.default_currency_code : 'INR';
        if (this.commonVariableList.columnList) {
          for (let x of this.commonVariableList.columnList) {

            if (x.value == 'cgst' && this.company_setup.custom_cgst_visible == '1') {
              x.is_view = true;
            }
            if (x.value == 'cgst' && this.company_setup.custom_cgst_visible == '0') {
              x.is_view = false;
            }
            if (x.value == 'sgst' && this.company_setup.custom_sgst_visible == '1') {
              x.is_view = true;
            }
            if (x.value == 'sgst' && this.company_setup.custom_sgst_visible == '0') {
              x.is_view = false;
            }
            if (x.value == 'igst' && this.company_setup.custom_igst_visible == '1') {
              x.is_view = true;
            }
            if (x.value == 'igst' && this.company_setup.custom_igst_visible == '0') {
              x.is_view = false;
            }
            if (x.value == 'ugst' && this.company_setup.custom_ugst_visible == '1') {
              x.is_view = true;
            }
            if (x.value == 'ugst' && this.company_setup.custom_ugst_visible == '0') {
              x.is_view = false;
            }
            if (x.value == 'cess' && this.company_setup.custom_cess_visible == '1') {
              x.is_view = true;
            }
            if (x.value == 'cess' && this.company_setup.custom_cess_visible == '0') {
              x.is_view = false;
            }
            if (x.value == 'other_tax' && this.company_setup.custom_other_tax_visible == '1') {
              x.is_view = true;
            }
            if (x.value == 'other_tax' && this.company_setup.custom_other_tax_visible == '0') {
              x.is_view = false;
            }
            if (x.value == 'cgst' && this.company_setup.custom_cgst_visible == '1') {
              x.display = this.company_setup.custom_cgst_name + (this.tableDetails.data.is_different_document_currency == '1' ? ' (' + this.company_setup.default_currency_code + ')' : '');
            }
            if (x.value == 'sgst' && this.company_setup.custom_sgst_visible == '1') {
              x.display = this.company_setup.custom_sgst_name + (this.tableDetails.data.is_different_document_currency == '1' ? ' (' + this.company_setup.default_currency_code + ')' : '');
            }
            if (x.value == 'igst' && this.company_setup.custom_igst_visible == '1') {
              x.display = this.company_setup.custom_igst_name + (this.tableDetails.data.is_different_document_currency == '1' ? ' (' + this.company_setup.default_currency_code + ')' : '');
            }
            if (x.value == 'ugst' && this.company_setup.custom_ugst_visible == '1') {
              x.display = this.company_setup.custom_ugst_name + (this.tableDetails.data.is_different_document_currency == '1' ? ' (' + this.company_setup.default_currency_code + ')' : '');
            }
            if (x.value == 'cess' && this.company_setup.custom_cess_visible == '1') {
              x.display = this.company_setup.custom_cess_name + (this.tableDetails.data.is_different_document_currency == '1' ? ' (' + this.company_setup.default_currency_code + ')' : '');
            }
            if (x.value == 'amount') {
              x.display = 'Amount ' + (this.tableDetails.data.is_different_document_currency == '1' ? ' (' + this.company_setup.default_currency_code + ')' : '');
            }
            if (x.value == 'total_gst') {
              x.display = 'Total GST ' + (this.tableDetails.data.is_different_document_currency == '1' ? ' (' + this.company_setup.default_currency_code + ')' : '');
            }
            if (x.value == 'total_amount') {
              x.display = 'Total Amount ' + (this.tableDetails.data.is_different_document_currency == '1' ? ' (' + this.company_setup.default_currency_code + ')' : '');
            }
            if (x.value == 'other_tax' && this.company_setup.custom_other_tax_visible == '1') {
              x.display = this.company_setup.custom_other_tax_name + (this.tableDetails.data.is_different_document_currency == '1' ? '(' + this.company_setup.default_currency_code + ')' : '');
            }
            if (x.value == 'ddc_amount' && this.tableDetails.data.is_different_document_currency == '1' && (this.tableDetails.data.note_type == '2' || this.tableDetails.data.note_type == '1')) {
              x.display = "Amount (" + this.tableDetails.data.currency_code + ")";
              x.is_view = true;
            }
          }
        }
        if (this.commonVariableList.items) {
          for (let d of this.commonVariableList.items) {
            d.hsn_other_tax = d.hsn_other_tax ? d.hsn_other_tax : '0'
            d.hsn_ugst = d.hsn_ugst ? d.hsn_ugst : '0'
            d.hsn_cgst = d.hsn_cgst ? d.hsn_cgst : '0'
            d.hsn_sgst = d.hsn_sgst ? d.hsn_sgst : '0'
            d.hsn_igst = d.hsn_igst ? d.hsn_igst : '0'

            d.cess = this.webService.convertNaN(d.cess)
            d.other_tax = this.webService.convertNaN(d.other_tax)
            d.ugst = this.webService.convertNaN(d.ugst)
            d.cgst = this.webService.convertNaN(d.cgst)
            d.sgst = this.webService.convertNaN(d.sgst)
            d.igst = this.webService.convertNaN(d.igst)

            d.cess = parseFloat(d.cess)
            d.other_tax = parseFloat(d.other_tax)
            d.ugst = parseFloat(d.ugst)
            d.cgst = parseFloat(d.cgst)
            d.sgst = parseFloat(d.sgst)
            d.igst = parseFloat(d.igst)


            d.cgst = this.webService.convertNaN(d.cgst)
            d.sgst = this.webService.convertNaN(d.sgst)
            d.igst = this.webService.convertNaN(d.igst)
            d.ugst = this.webService.convertNaN(d.ugst)
            d.cess = this.webService.convertNaN(d.cess)
            d.other_tax = this.webService.convertNaN(d.other_tax)


            d.hsn_cess = parseFloat(d.cess) <= 0 ? '' : d.hsn_cess;
            d.hsn_other_tax = parseFloat(d.other_tax) <= 0 ? '' : d.hsn_other_tax;
            d.hsn_ugst = parseFloat(d.ugst) <= 0 ? '' : d.hsn_ugst;
            d.hsn_cgst = parseFloat(d.cgst) <= 0 ? '' : d.hsn_cgst;
            d.hsn_sgst = parseFloat(d.sgst) <= 0 ? '' : d.hsn_sgst;
            d.hsn_igst = parseFloat(d.igst) <= 0 ? '' : d.hsn_igst;
          }
        }
        this.makeData();

        break;
      case 'grnreport':
        this.commonVariableList.columnList = globalVariables.grnVariableList.columnList;
        this.commonVariableList.items = this.tableDetails.data.grn_items ? this.tableDetails.data.grn_items : [];
        this.company_setup.grn_unit_type_visible = this.company_setup.grn_unit_type_visible ? this.company_setup.grn_unit_type_visible : '0';
this.company_setup.product_description_grn=this.company_setup.product_description_grn?this.company_setup.product_description_grn:'0';
        

        this.company_setup.grn_action_visible = this.company_setup.grn_action_visible ? this.company_setup.grn_action_visible : '0';
        this.company_setup.grn_subcategory_visible = this.company_setup.grn_subcategory_visible ? this.company_setup.grn_subcategory_visible : '0';
        this.company_setup.grn_category_visible = this.company_setup.grn_category_visible ? this.company_setup.grn_category_visible : '0';
        this.company_setup.grn_catalog_visible = this.company_setup.grn_catalog_visible ? this.company_setup.grn_catalog_visible : '0';
        this.company_setup.grn_requested_by_visible = this.company_setup.grn_requested_by_visible ? this.company_setup.grn_requested_by_visible : '0';
        this.company_setup.is_budget_selection_at_item_level_in_product_table = this.company_setup.is_budget_selection_at_item_level_in_product_table ? this.company_setup.is_budget_selection_at_item_level_in_product_table: '0';
        this.company_setup.allowed_digits_after_decimal = this.company_setup.allowed_digits_after_decimal ? this.company_setup.allowed_digits_after_decimal : "2";
        this.company_setup.is_delivery_cc_visible_po = this.company_setup.is_delivery_cc_visible_po ? this.company_setup.is_delivery_cc_visible_po : '0';
        
        if (this.commonVariableList.items) {
          for (let i of this.commonVariableList.items) {

            i.accepted_qty = this.webService.convertNaN(i.accepted_qty, this.company_setup.allowed_digits_after_decimal)
            i.accepted_qty = parseFloat(i.accepted_qty)
            i.accepted_qty = this.webService.convertNaN(i.accepted_qty, this.company_setup.allowed_digits_after_decimal)


            i.rejected_qty = this.webService.convertNaN(i.rejected_qty, this.company_setup.allowed_digits_after_decimal)
            i.rejected_qty =parseFloat(i.rejected_qty)
            i.rejected_qty = this.webService.convertNaN(i.rejected_qty, this.company_setup.allowed_digits_after_decimal)


            i.qty = this.webService.convertNaN(i.qty, this.company_setup.allowed_digits_after_decimal)
            i.qty = parseFloat(i.qty)
            i.qty = this.webService.convertNaN(i.qty, this.company_setup.allowed_digits_after_decimal)


            i.total_required_qty = this.webService.convertNaN(i.total_required_qty, this.company_setup.allowed_digits_after_decimal)
            i.total_required_qty = parseFloat(i.total_required_qty)
            i.total_required_qty = this.webService.convertNaN(i.total_required_qty, this.company_setup.allowed_digits_after_decimal)


            i.received_qty = this.webService.convertNaN(i.received_qty, this.company_setup.allowed_digits_after_decimal)
            i.received_qty = parseFloat(i.received_qty)
            i.received_qty = this.webService.convertNaN(i.received_qty, this.company_setup.allowed_digits_after_decimal)


            i.current_required_qty = this.webService.convertNaN(i.current_required_qty, this.company_setup.allowed_digits_after_decimal)
            i.current_required_qty = parseFloat(i.current_required_qty)
            i.current_required_qty = this.webService.convertNaN(i.current_required_qty, this.company_setup.allowed_digits_after_decimal)


            i.product_owned_type_name = '';

            switch (i.product_owned_type) {
              case '1':
                i.product_owned_type_name = 'New Owned';
                break;
              case '2':
                i.product_owned_type_name = 'New Leased';
                break;
              case '3':
                i.product_owned_type_name = 'Old Owned';
                break;
              case '4':
                i.product_owned_type_name = 'Old Leased';
                break;
              case '5':
                i.product_owned_type_name = 'Consignement';
                break;
              case '6':
                i.product_owned_type_name = 'Damaged but Usable';
                break;
              case '7':
                i.product_owned_type_name = 'Damaged and Not Usable';
                break;
              default:
                i.product_owned_type_name = '';
            }

            i.grn_checked_type_name = '';

            switch (i.grn_checked_type) {
              case '1':
                i.grn_checked_type_name = 'Sample Checked';
                break;
              case '2':
                i.grn_checked_type_name = 'Entire Quantity Checked';
                break;
              case '3':
                i.grn_checked_type_name = 'None';
                break;
                case '0':
                  i.grn_checked_type_name = 'None';
                  break;
              default:
                i.grn_checked_type_name = '';
            }

            i.project_name = i.project_name ? i.project_name : '';
            i.task_name = i.task_name ? i.task_name : '';
          }
        }

        // GRN footer total: show Grand Total Price under QC column.
        this.grnGrandTotalPrice = '';
        if (this.company_setup.enable_po_unit_and_total_price_fields_for_normal_po == '1') {
          let sum: number = 0;
          for (let row of this.commonVariableList.items) {
            let value: any = (row && row.total_grn_value_po_price != undefined && row.total_grn_value_po_price !== '' && row.total_grn_value_po_price !== null)
              ? row.total_grn_value_po_price
              : (row && row.po_total_price != undefined && row.po_total_price !== null ? row.po_total_price : 0);
            sum += parseFloat(this.webService.convertNaN(value));
          }
          this.grnGrandTotalPrice = this.webService.convertNaN(sum, this.company_setup.allowed_digits_after_decimal);
        }

        this.company_setup.barcode_code = this.company_setup.barcode_code ? this.company_setup.barcode_code : '0'
        this.company_setup.qr_code = this.company_setup.qr_code ? this.company_setup.qr_code : '0'
        this.company_setup.send_damage_mail = this.company_setup.send_damage_mail ? this.company_setup.send_damage_mail : '0';
        this.company_setup.grn_checked_type = this.company_setup.grn_checked_type ? this.company_setup.grn_checked_type : '0';
        this.company_setup.grn_sample_size = this.company_setup.grn_sample_size ? this.company_setup.grn_sample_size : '0';
        this.company_setup.grn_error_size = this.company_setup.grn_error_size ? this.company_setup.grn_error_size : '0';
        this.company_setup.grn_is_closed = this.company_setup.grn_is_closed ? this.company_setup.grn_is_closed : '0';
        this.company_setup.grn_product_owned_type = this.company_setup.grn_product_owned_type ? this.company_setup.grn_product_owned_type : '0';
        this.company_setup.is_allocated_rack_visible_in_grn = this.company_setup.is_allocated_rack_visible_in_grn ? this.company_setup.is_allocated_rack_visible_in_grn : '0';
        this.company_setup.is_damaged_qty_visible = this.company_setup.is_damaged_qty_visible ? this.company_setup.is_damaged_qty_visible : '0';
        this.company_setup.is_damaged_remarks_visible = this.company_setup.is_damaged_remarks_visible ? this.company_setup.is_damaged_remarks_visible : '0';
        this.company_setup.is_barcode_visible_grn_summary = this.company_setup.is_barcode_visible_grn_summary ? this.company_setup.is_barcode_visible_grn_summary : '0';
        this.company_setup.is_qrcode_visible_grn_summary = this.company_setup.is_qrcode_visible_grn_summary ? this.company_setup.is_qrcode_visible_grn_summary : '0';
        this.company_setup.is_barcode_and_qrcode_visible_grn_summary = this.company_setup.is_barcode_and_qrcode_visible_grn_summary ? this.company_setup.is_barcode_and_qrcode_visible_grn_summary : '0';
        this.company_setup.enable_po_unit_and_total_price_fields = this.company_setup.enable_po_unit_and_total_price_fields ? this.company_setup.enable_po_unit_and_total_price_fields : '0';
        let is_closed: boolean = true;
        let send_damage_mail: boolean = true;
        let is_rack_dimension: boolean = false;
        let is_bar_qr_visible: boolean = false;

        is_bar_qr_visible = this.tableDetails.data.is_fully_approved=='1'?true:false;

        is_closed = this.commonVariableList.items.some((v) => {
          return v.is_closed
        })
        send_damage_mail = this.commonVariableList.items.some((v) => {
          return v.send_damage_mail
        })
        is_rack_dimension = this.commonVariableList.items.some((v) => {
          return v.rack_dimension_name != '' && v.rack_dimension_name != undefined && v.rack_dimension_name != null
        })

        if (this.commonVariableList.columnList) {
          for (let i of this.commonVariableList.columnList) {
            if (i.value == 'error_size') {
              i.display = this.company_setup.custom_name_for_error_size;
            }
            if (i.value == 'damaged_qty') {
              i.display = this.company_setup.custom_name_for_usable_qty;
            }

            if (i.value == 'merge_barcode' && this.company_setup.is_merge_barcode_visible == '1') {
              i.is_view = true;
            }
            if (i.value == 'merge_barcode' && this.company_setup.is_merge_barcode_visible == '0') {
              i.is_view = false;
            }

            if (i.value == 'category_name' && this.company_setup.grn_category_visible == '1') {
              i.is_view = true;
            }
            if (i.value == 'category_name' && this.company_setup.grn_category_visible == '0') {
              i.is_view = false;
            }
            if (i.value == 'subcategory_name' && this.company_setup.grn_subcategory_visible == '1') {
              i.is_view = true;
            }
            if (i.value == 'subcategory_name' && this.company_setup.grn_subcategory_visible == '0') {
              i.is_view = false;
            }


            if (i.value == 'unit_type_name' && this.company_setup.grn_unit_type_visible == '1') {
              i.is_view = true;
            }
            if (i.value == 'unit_type_name' && this.company_setup.grn_unit_type_visible == '0') {
              i.is_view = false;
            }


            if (i.value == 'product_catalog_id' && this.company_setup.product_catalog_id == '1' && this.company_setup.grn_catalog_visible == '1') {
              i.is_view = true;
            }
            if (i.value == 'product_catalog_id' && this.company_setup.product_catalog_id == '0' && this.company_setup.grn_catalog_visible == '0') {
              i.is_view = false;
            }
            if (i.value == 'rack_dimension_name' && is_rack_dimension) {
              i.is_view = true;
            }
            if (i.value == 'rack_dimension_name' && !is_rack_dimension) {
              i.is_view = false;
            }
            if (i.value == 'grn_checked_type_name' && this.company_setup.grn_checked_type == '0') {
              i.is_view = false;
            }
            if (i.value == 'sample_size' && this.company_setup.grn_sample_size == '0') {
              i.is_view = false;
            }

            if (i.value == 'error_size' && this.company_setup.grn_error_size == '0') {
              i.is_view = false;
            }

            if (i.value == 'product_owned_type_name' && this.company_setup.grn_product_owned_type == '0') {
              i.is_view = false;
            }
            if (i.value == 'allocated_rack_code' && this.company_setup.is_allocated_rack_visible_in_grn == '0') {
              i.is_view = false;
            }
            if (i.value == 'product_description' && this.company_setup.product_description_grn == '1') {
              i.is_view = true;
            }

            if (i.value == 'damaged_qty' && this.company_setup.is_damaged_remarks_visible == '1') {
              i.is_view = true;
            }

            if (i.value == 'damaged_remarks' && this.company_setup.is_damaged_qty_visible == '1') {
              i.is_view = true;
            }

            if (i.value == 'is_closed' && is_closed) {
              i.is_view = true;
            }
            if (i.value == 'send_damage_mail' && send_damage_mail) {
              i.is_view = true;
            }
            if (i.value == 'qrcode_file_url' && (this.company_setup.is_qrcode_visible_grn_summary  == '0' || this.company_setup.is_barcode_and_qrcode_visible_grn_summary=='0')) {
              i.is_view = false;
            }
            if (i.value == 'barcode_file_url' && (this.company_setup.is_barcode_visible_grn_summary  == '0' || this.company_setup.is_barcode_and_qrcode_visible_grn_summary=='0')) {
              i.is_view = false;
            }

            if (i.value == 'invoice_qty' && this.company_setup.is_invoice_qty_visible_in_grn == '0') {
              i.is_view = false;
            }
            if (i.value == 'invoice_qty'  && this.company_setup.is_invoice_qty_visible_in_grn == '1') {
              i.is_view = true;
            }

            if (i.value == 'invoice_unit_price'  && this.company_setup.is_invoice_unit_price_visible_in_grn == '0') {
              i.is_view = false;
            }
            if (i.value == 'invoice_unit_price'  && this.company_setup.is_invoice_unit_price_visible_in_grn == '1') {
              i.is_view = true;
            }
            if (i.value == 'total_inward_qty'  && this.company_setup.is_total_qty_inwarded_visible == '0') {
              i.is_view = false;
            }
            if (i.value == 'total_inward_qty'  && this.company_setup.is_total_qty_inwarded_visible == '1') {
              i.is_view = true;
            }

            if (i.value == 'qrcode_file_url' && (this.company_setup.is_qrcode_visible_grn_summary == '1' || this.company_setup.is_barcode_and_qrcode_visible_grn_summary == '1')) {
              i.is_view=true;
              // if(!is_bar_qr_visible)
              // {
              //   i.is_view=false;
              // }
            }
            if (i.value == 'barcode_file_url' && (this.company_setup.is_barcode_visible_grn_summary == '1' || this.company_setup.is_barcode_and_qrcode_visible_grn_summary == '1')) {
              i.is_view=true;
              // if(!is_bar_qr_visible)
              // {
              //   i.is_view=false;
              // }
            }

            if (i.value == 'project_name' && this.company_setup.is_budget_selection_at_item_level_in_product_table == '1') {
              i.display = this.company_setup.rename_project?this.company_setup.rename_project:'Project';
              i.is_view = true;
            }

            if (i.value == 'task_name' && this.company_setup.is_budget_selection_at_item_level_in_product_table == '1') {
              i.display = this.company_setup.rename_task?this.company_setup.rename_task:'Task';
              i.is_view = true;
            }
            if(i.po_unit_price && this.company_setup.enable_po_unit_and_total_price_fields == '1' && i.is_blanket_po == '1'){
              i.is_view = true;
            }
            if(i.po_total_price && this.company_setup.enable_po_unit_and_total_price_fields == '1' && i.is_blanket_po == '1'){
              i.is_view = true;
            }
            if (i.value == 'delivery_cc_name' && this.company_setup.is_delivery_cc_visible_po == '1') {
              i.is_view = true;
            }
            if (i.value == 'delivery_cc_name' && this.company_setup.is_delivery_cc_visible_po == '0') {
              i.is_view = false;
            }
            if(i.value == 'total_grn_value_po_price'){
             i.is_view = this.company_setup.enable_po_unit_and_total_price_fields_for_normal_po == '1' ? true : false;
            }
          }
        }

        this.makeData();

        break;
      case 'gatepassreport':
        this.commonVariableList.columnList = globalVariables.gatePassVariableList.columnList;
        this.commonVariableList.items = this.tableDetails.data.items ? this.tableDetails.data.items : [];
        this.company_setup.allowed_digits_after_decimal = this.company_setup.allowed_digits_after_decimal ? this.company_setup.allowed_digits_after_decimal : '2';
        if (this.commonVariableList.items) {
          for (let i of this.commonVariableList.items) {
            i.product_description = i.product_description ? i.product_description : (i.description ? i.description : '');
            i.unit_type_name = i.unit_type_name ? i.unit_type_name : (i.unit_type ? i.unit_type : '');
            i.current_received_qty = this.webService.convertNaN(i.current_received_qty, this.company_setup.allowed_digits_after_decimal);
            i.invoice_qty = this.webService.convertNaN(i.invoice_qty, this.company_setup.allowed_digits_after_decimal);
            i.invoice_price = this.webService.convertNaN(i.invoice_price, this.company_setup.allowed_digits_after_decimal);
          }
        }
        this.makeData();
        break;
        case 'logisticsreport':
          this.commonVariableList.columnList = globalVariables.logisticsVariableList.columnList
          this.commonVariableList.items = this.tableDetails.data.logistic_items ? this.tableDetails.data.logistic_items : [];
      //  //console.log(this.tableDetails);
          if (this.commonVariableList.items) {
            for (let i of this.commonVariableList.items) {

              i.product=i.product_name+" ("+i.productcode+")";
              i.logistic_partner=i.partner_name+" ("+i.partner_type+")";



            }
          }
          if (this.commonVariableList.columnList) {
            for (let i of this.commonVariableList.columnList) {

              if (i.value == 'po_no' && this.is_column_visible(this.company_setup.logistics_column_list,'po_no',false)) {
i.is_view=true;
}
if (i.value == 'po_no' && !this.is_column_visible(this.company_setup.logistics_column_list,'po_no',false)) {
  i.is_view=false;
  }

              if (i.value == 'location'  && this.is_column_visible(this.company_setup.logistics_column_list,'ship_location',false)) {
                i.is_view=true;
              }
              if (i.value == 'location'  && !this.is_column_visible(this.company_setup.logistics_column_list,'ship_location',false)) {
                i.is_view=false;
              }

              if (i.value == 'actual_dispatch_date'  && this.is_column_visible(this.company_setup.logistics_column_list,'actual_dispatch_date',false)) {
                i.is_view=true;
              }
              if (i.value == 'actual_dispatch_date'  && !this.is_column_visible(this.company_setup.logistics_column_list,'actual_dispatch_date',false)) {
                i.is_view=false;
              }


              if (i.value == 'tracking_id'  && this.is_column_visible(this.company_setup.logistics_column_list,'tracking_id',false)) {
                i.is_view=true;
              }
              if (i.value == 'tracking_id'  && !this.is_column_visible(this.company_setup.logistics_column_list,'tracking_id',false)) {
                i.is_view=false;
              }

              if (i.value == 'product'  && this.is_column_visible(this.company_setup.logistics_column_list,'product',false)) {
                i.is_view=true;
              }
              if (i.value == 'product'  && !this.is_column_visible(this.company_setup.logistics_column_list,'product',false)) {
                i.is_view=false;
              }
              if (i.value == 'unit_type_name'  && this.is_column_visible(this.company_setup.logistics_column_list,'unit_type',false)) {
                i.is_view=true;
              }
              if (i.value == 'unit_type_name'  && !this.is_column_visible(this.company_setup.logistics_column_list,'unit_type',false)) {
                i.is_view=false;
              }
              if (i.value == 'quantity'  && this.is_column_visible(this.company_setup.logistics_column_list,'qty',false)) {
                i.is_view=true;
              }
              if (i.value == 'quantity'  && !this.is_column_visible(this.company_setup.logistics_column_list,'qty',false)) {
                i.is_view=false;
              }
              if (i.value == 'logistic_partner'  && this.is_column_visible(this.company_setup.logistics_column_list,'logistic_partner',false)) {
                i.is_view=true;
              }
              if (i.value == 'logistic_partner'  && !this.is_column_visible(this.company_setup.logistics_column_list,'logistic_partner',false)) {
                i.is_view=false;
              }
              if (i.value == 'product_required_by'  && this.is_column_visible(this.company_setup.logistics_column_list,'required_by',false)) {
                i.is_view=true;
              }
              if (i.value == 'product_required_by'  && !this.is_column_visible(this.company_setup.logistics_column_list,'required_by',false)) {
                i.is_view=false;
              }
              if (i.value == 'delivery_date'  && this.is_column_visible(this.company_setup.logistics_column_list,'expected_delivery_date',false)) {
                i.is_view=true;
              }
              if (i.value == 'delivery_date'  && !this.is_column_visible(this.company_setup.logistics_column_list,'expected_delivery_date',false)) {
                i.is_view=false;
              }
              if (i.value == 'delivery_status'  && this.is_column_visible(this.company_setup.logistics_column_list,'delivery_status',false)) {
                i.is_view=true;
              }
              if (i.value == 'delivery_status'  && !this.is_column_visible(this.company_setup.logistics_column_list,'delivery_status',false)) {
                i.is_view=false;
              }
              if (i.value == 'vendor_contact_person_name'  && this.is_column_visible(this.company_setup.logistics_column_list,'vendor_contact_name',false)) {
                i.is_view=true;
              }
              if (i.value == 'vendor_contact_person_name'  && !this.is_column_visible(this.company_setup.logistics_column_list,'vendor_contact_name',false)) {
                i.is_view=false;
              }
              if (i.value == 'vendor_contact_person_email'  && !this.is_column_visible(this.company_setup.logistics_column_list,'vendor_contact_email',false)) {
                i.is_view=false;
              }
              if (i.value == 'vendor_contact_person_email'  && !this.is_column_visible(this.company_setup.logistics_column_list,'vendor_contact_email',false)) {
                i.is_view=false;
              }
              if (i.value == 'vendor_contact_person_contact_no'  && this.is_column_visible(this.company_setup.logistics_column_list,'vendor_contact_mobile',false)) {
                i.is_view=true;
              }
              if (i.value == 'vendor_contact_person_contact_no'  && !this.is_column_visible(this.company_setup.logistics_column_list,'vendor_contact_mobile',false)) {
                i.is_view=false;
              }
              if (i.value == 'contact_email'  && this.is_column_visible(this.company_setup.logistics_column_list,'contact_email',false)) {
                i.is_view=true;
              }
              if (i.value == 'contact_email'  && !this.is_column_visible(this.company_setup.logistics_column_list,'contact_email',false)) {
                i.is_view=false;
              }
              if (i.value == 'contact_mobile'  && this.is_column_visible(this.company_setup.logistics_column_list,'contact_mobile',false)) {
                i.is_view=true;
              }
              if (i.value == 'contact_mobile'  && !this.is_column_visible(this.company_setup.logistics_column_list,'contact_mobile',false)) {
                i.is_view=false;
              }
              if (i.value == 'remarks'  && this.is_column_visible(this.company_setup.logistics_column_list,'remarks',false)) {
                i.is_view=true;
                }
               if (i.value == 'remarks'  && !this.is_column_visible(this.company_setup.logistics_column_list,'remarks',false)) {
                i.is_view=false;
                }
              if (i.value == 'nos_of_package'  && this.is_column_visible(this.company_setup.logistics_column_list,'nos_of_package',false)) {
                i.is_view=true;
              }
              if (i.value == 'nos_of_package'  && !this.is_column_visible(this.company_setup.logistics_column_list,'nos_of_package',false)) {
                i.is_view=false;
              }

              if (i.value == 'po_no') {
                i.display = this.getColumnName(this.company_setup.logistics_column_list,'po_no',i.display)
              }
              if (i.value == 'location') {
                i.display = this.getColumnName(this.company_setup.logistics_column_list,'ship_location',i.display)
              }
              if (i.value == 'product') {
                i.display = this.getColumnName(this.company_setup.logistics_column_list,'product',i.display)
              }
              if (i.value == 'unit_type_name') {
                i.display = this.getColumnName(this.company_setup.logistics_column_list,'unit_type',i.display)
              }
              if (i.value == 'quantity') {
                i.display = this.getColumnName(this.company_setup.logistics_column_list,'qty',i.display)
              }
              if (i.value == 'logistic_partner') {
                i.display = this.getColumnName(this.company_setup.logistics_column_list,'logistic_partner',i.display)
              }
              if (i.value == 'product_required_by') {
                i.display = this.getColumnName(this.company_setup.logistics_column_list,'required_by',i.display)
              }

              if (i.value == 'delivery_date') {
                i.display = this.getColumnName(this.company_setup.logistics_column_list,'expected_delivery_date',i.display)
              }
              if (i.value == 'actual_dispatch_date') {
                i.display = this.getColumnName(this.company_setup.logistics_column_list,'actual_dispatch_date',i.display)
              }

              if (i.value == 'tracking_id') {
                i.display = this.getColumnName(this.company_setup.logistics_column_list,'tracking_id',i.display)
              }
              if (i.value == 'delivery_status') {
                i.display = this.getColumnName(this.company_setup.logistics_column_list,'delivery_status',i.display)
              }
              if (i.value == 'vendor_contact_person_name') {
                i.display = this.getColumnName(this.company_setup.logistics_column_list,'vendor_contact_name',i.display)
              }
              if (i.value == 'vendor_contact_person_email') {
                i.display = this.getColumnName(this.company_setup.logistics_column_list,'vendor_contact_email',i.display)
              }
              if (i.value == 'vendor_contact_person_contact_no') {
                i.display = this.getColumnName(this.company_setup.logistics_column_list,'vendor_contact_mobile',i.display)
              }
              if (i.value == 'contact_email') {
                i.display = this.getColumnName(this.company_setup.logistics_column_list,'contact_email',i.display)
              }
              if (i.value == 'contact_mobile') {
                i.display = this.getColumnName(this.company_setup.logistics_column_list,'contact_mobile',i.display)
              }
              if (i.value == 'remarks') {
                i.display = this.getColumnName(this.company_setup.logistics_column_list,'remarks',i.display)
              }
              if (i.value == 'nos_of_package') {
                i.display = this.getColumnName(this.company_setup.logistics_column_list,'no_of_package',i.display)
              }



            }
          }
          this.makeData();

          break;

      case 'irnreport':
        this.commonVariableList.columnList = globalVariables.irnVariableList.columnList
        this.commonVariableList.items = this.tableDetails.data.irn_items ? this.tableDetails.data.irn_items : [];
        let is_damaged: boolean = true;
        this.company_setup.irn_unit_type_visible = this.company_setup.irn_unit_type_visible ? this.company_setup.irn_unit_type_visible : '0';
        this.company_setup.irn_add_button_custom_name = this.company_setup.irn_add_button_custom_name ? this.company_setup.irn_add_button_custom_name : 'Add IRN'
        this.company_setup.irn_date_custom_name = this.company_setup.irn_date_custom_name ? this.company_setup.irn_date_custom_name : 'IRN Date'
        this.company_setup.product_description_irn=this.company_setup.product_description_irn?this.company_setup.product_description_irn:'0';

        this.company_setup.irn_no_custom_name = this.company_setup.irn_no_custom_name ? this.company_setup.irn_no_custom_name : 'IRN No'

        this.company_setup.irn_action_visible = this.company_setup.irn_action_visible ? this.company_setup.irn_action_visible : '0';
        this.company_setup.irn_damaged_visible = this.company_setup.irn_damaged_visible ? this.company_setup.irn_damaged_visible : '0';
        this.company_setup.irn_subcategory_visible = this.company_setup.irn_subcategory_visible ? this.company_setup.irn_subcategory_visible : '0';
        this.company_setup.irn_category_visible = this.company_setup.irn_category_visible ? this.company_setup.irn_category_visible : '0';
        this.company_setup.irn_catalog_visible = this.company_setup.irn_catalog_visible ? this.company_setup.irn_catalog_visible : '0';
        this.company_setup.irn_requested_by_visible = this.company_setup.irn_requested_by_visible ? this.company_setup.irn_requested_by_visible : '0';
        this.company_setup.allowed_digits_after_decimal = this.company_setup.allowed_digits_after_decimal ? this.company_setup.allowed_digits_after_decimal : "2";
        this.company_setup.enable_po_unit_and_total_price_fields = this.company_setup.enable_po_unit_and_total_price_fields ? this.company_setup.enable_po_unit_and_total_price_fields : '0';
        this.company_setup.is_delivery_cc_visible_po = this.company_setup.is_delivery_cc_visible_po ? this.company_setup.is_delivery_cc_visible_po : '0';
        is_damaged = this.commonVariableList.items.some((v) => { return v.is_damaged })

        if (this.commonVariableList.items) {
          for (let i of this.commonVariableList.items) {

            i.qty=this.webService.convertNaN(i.qty, this.company_setup.allowed_digits_after_decimal)
            i.qty=parseFloat(i.qty)
            i.qty=this.webService.convertNaN(i.qty, this.company_setup.allowed_digits_after_decimal)

            i.total_required_qty=this.webService.convertNaN(i.total_required_qty, this.company_setup.allowed_digits_after_decimal)
            i.total_required_qty=parseFloat(i.total_required_qty)
            i.total_required_qty=this.webService.convertNaN(i.total_required_qty, this.company_setup.allowed_digits_after_decimal)

            i.current_required_qty=this.webService.convertNaN(i.current_required_qty, this.company_setup.allowed_digits_after_decimal)
            i.current_required_qty=parseFloat(i.current_required_qty)
            i.current_required_qty=this.webService.convertNaN(i.current_required_qty, this.company_setup.allowed_digits_after_decimal)

            i.received_qty=this.webService.convertNaN(i.received_qty, this.company_setup.allowed_digits_after_decimal)
            i.received_qty=parseFloat(i.received_qty)
            i.received_qty=this.webService.convertNaN(i.received_qty, this.company_setup.allowed_digits_after_decimal)

            i.accepted_qty=this.webService.convertNaN(i.accepted_qty, this.company_setup.allowed_digits_after_decimal)
            i.accepted_qty=parseFloat(i.accepted_qty)
            i.accepted_qty=this.webService.convertNaN(i.accepted_qty, this.company_setup.allowed_digits_after_decimal)


            i.rejected_qty=this.webService.convertNaN(i.rejected_qty, this.company_setup.allowed_digits_after_decimal)
            i.rejected_qty=parseFloat(i.rejected_qty)
            i.rejected_qty=this.webService.convertNaN(i.rejected_qty, this.company_setup.allowed_digits_after_decimal)



          }
        }

        // IRN footer total: show Grand Total Price under Total Unit Price column.
        this.irnGrandTotalPrice = '';
        if (this.company_setup.enable_po_unit_and_total_price_fields_for_normal_po == '1') {
          let sum: number = 0;
          for (let row of this.commonVariableList.items) {
            // For IRN, total is taken from po_total_price (already provided by API).
            let value: any = (row && row.po_total_price != undefined && row.po_total_price !== null) ? row.po_total_price : 0;
            sum += parseFloat(this.webService.convertNaN(value));
          }
          this.irnGrandTotalPrice = this.webService.convertNaN(sum, this.company_setup.allowed_digits_after_decimal);
        }

        if (this.commonVariableList.columnList) {
          console.log('irn')

          for (let i of this.commonVariableList.columnList) {

            if (i.value == 'merge_barcode' && this.company_setup.is_merge_barcode_visible == '1') {
              i.is_view = true;
            }
            if (i.value == 'merge_barcode' && this.company_setup.is_merge_barcode_visible == '0') {
              i.is_view = false;
            }

            if (i.value == 'irn_no') {
              i.display = this.company_setup.irn_no_custom_name;
            }
            if (i.value == 'irn_date') {
              i.display = this.company_setup.irn_date_custom_name;
            }
            if (i.value == 'product_description' && this.company_setup.product_description_irn=='1') {
              i.is_view = true;
              }
            if (i.value == 'category_name' && this.company_setup.irn_category_visible == '1') {
              i.is_view = true;
            }
            if (i.value == 'category_name' && this.company_setup.irn_category_visible == '0') {
              i.is_view = false;
            }
            if (i.value == 'subcategory_name' && this.company_setup.irn_subcategory_visible == '1') {
              i.is_view = true;
            }
            if (i.value == 'subcategory_name' && this.company_setup.irn_subcategory_visible == '0') {
              i.is_view = false;
            }


            if (i.value == 'unit_type_name' && this.company_setup.irn_unit_type_visible == '1') {
              i.is_view = true;
            }
            if (i.value == 'unit_type_name' && this.company_setup.irn_unit_type_visible == '0') {
              i.is_view = false;
            }
            


            if (i.value == 'product_catalog_id' && this.company_setup.product_catalog_id == '1' && this.company_setup.irn_catalog_visible == '1') {
              i.is_view = true;
            }
            if (i.value == 'product_catalog_id' && this.company_setup.product_catalog_id == '0' && this.company_setup.irn_catalog_visible == '0') {
              i.is_view = false;
            }
            if (i.value == 'accepted_qty' && this.company_setup.merge_grn_irn == '1') {
              i.is_view = true;
            }
            if (i.value == 'accepted_qty' && this.company_setup.merge_grn_irn == '0') {
              i.is_view = false;
            }

            if (i.value == 'rejected_qty' && this.company_setup.merge_grn_irn == '1') {
              i.is_view = true;
            }
            if (i.value == 'rejected_qty' && this.company_setup.merge_grn_irn == '0') {
              i.is_view = false;
            }

            if (i.value == 'rejected_reason' && this.company_setup.merge_grn_irn == '1') {
              i.is_view = true;
            }
            if (i.value == 'rejected_reason' && this.company_setup.merge_grn_irn == '0') {
              i.is_view = false;
            }
            if (i.value == 'is_damaged' && !is_damaged && this.company_setup.irn_damaged_visible == '0') {
              i.is_view = false;
            }
            if (i.value == 'is_damaged' && is_damaged && this.company_setup.irn_damaged_visible == '1') {
              i.is_view = true;
            }


            if (i.value == 'invoice_qty' && this.company_setup.is_invoice_qty_visible_in_irn == '0') {
              i.is_view = false;
            }
            if (i.value == 'invoice_qty'  && this.company_setup.is_invoice_qty_visible_in_irn == '1') {
              i.is_view = true;
            }

            if (i.value == 'invoice_unit_price'  && this.company_setup.is_invoice_unit_price_visible_in_irn == '0') {
              i.is_view = false;
            }
            if (i.value == 'invoice_unit_price'  && this.company_setup.is_invoice_unit_price_visible_in_irn == '1') {
              i.is_view = true;
            }

            if (i.value == 'project_name' && this.company_setup.is_budget_selection_at_item_level_in_product_table == '1') {
              i.display = this.company_setup.rename_project?this.company_setup.rename_project:'Project';
              i.is_view = true;
            }

            if (i.value == 'task_name' && this.company_setup.is_budget_selection_at_item_level_in_product_table == '1') {
              i.display = this.company_setup.rename_task?this.company_setup.rename_task:'Task';
              i.is_view = true;
            }
            if(i.value == 'po_unit_price' && this.company_setup.enable_po_unit_and_total_price_fields == '1' && i.is_blanket_po == '1'){
              i.is_view = true;
            }
            if(i.value == 'po_total_price'  && this.company_setup.enable_po_unit_and_total_price_fields == '1' && i.is_blanket_po == '1'){
              i.is_view = true;
            }
            if (i.value == 'delivery_cc_name' && this.company_setup.is_delivery_cc_visible_po == '1') {
              i.is_view = true;
            }
            if (i.value == 'delivery_cc_name' && this.company_setup.is_delivery_cc_visible_po == '0') {
              i.is_view = false;
            }
            if(i.value == 'total_grn_value_po_price'){
             i.is_view = this.company_setup.enable_po_unit_and_total_price_fields_for_normal_po == '1' ? true : false;
            }
          }
        }
        this.makeData();

        break;

       case 'poreport':
        this.stillLoading = true;
        let url:any='/'+window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
        // //console.log(this.webService.getMenuByUrl(url));
        let is_new_item_visible:boolean=this.webService.getMenuByUrl(url).id=="38"?false:true;
        // //console.log('is po='+is_new_item_visible);
        this.commonVariableList.columnList = globalVariables.poVariableList.columnList;

        if(this.commonVariableList.columnList)
        {
          for(let i of this.commonVariableList.columnList)
          {
            let ddccode:any='';
            if(this.tableDetails.data.is_different_document_currency=='1')
          {
            ddccode=this.setDDCCode(this.tableDetails.data.currencies);
          }
          else
          {
            ddccode=this.company_setup.currency_icon
          }
            if(i.value=='product_unit_price')
            {
              i.display="Unit Price ("+this.company_setup.currency_icon+")"
            }
            if (i.value == 'project_name') {
              if(this.company_setup.is_budget_selection_at_item_level_in_product_table == '1'){
                i.is_view = true;
                i.display = this.company_setup.rename_project ? this.company_setup.rename_project : 'Project'
              }else{
                i.is_view = false;
              }
            }
            if (i.value == 'task_name') {
              if(this.company_setup.is_budget_selection_at_item_level_in_product_table == '1'){
                i.is_view = true;
                i.display = this.company_setup.rename_task ? this.company_setup.rename_task : 'Task'
              }else{
                i.is_view = false;
              }
            }
            if(i.value=='discount_unit_price')
            {
              i.display="Discount Unit Price ("+this.company_setup.currency_icon+")"
            }

            if(i.value=='discounted_unit_price')
            {
              // i.display="Discounted Unit Price ("+this.company_setup.currency_icon+")"
              i.display=`${this.company_setup.in_po_custom_name_for_discounted_unit_price} (${this.company_setup.currency_icon})`
            }
            if(i.value=='discounted_amount')
            {
              i.display=this.company_setup.custome_name_for_total_discounted_amount_in_po_module;
            }
            if(i.value=='hsn_code')
            {
                i.display=this.company_setup.custom_hsn_code;
            }
            if (i.value == 'saving_category') {
              if (this.IsItemVisible('savings_category', false)) {
                i.is_view = true;
                i.display = this.getItemName('savings_category') || 'Saving Category';
              } else {
                i.is_view = false;
              }
            }
            if (i.value == 'saving_amount_in_base_currency') {
              if (this.IsItemVisible('savings_amount_base_currency', false)) {
                i.is_view = true;
                i.display = this.getItemName('savings_amount_base_currency') || 'Savings Amount in Base Currency';
              } else {
                i.is_view = false;
              }
            }

          }
        }
        this.company_setup.discount_type_in_po = this.tableDetails.data.discount_type_in_po ? this.tableDetails.data.discount_type_in_po : this.company_setup.discount_type_in_po;
        this.commonVariableList.fields = this.tableDetails.data;
        this.commonVariableList.items = this.tableDetails.data.po_items ? this.tableDetails.data.po_items : (this.tableDetails.data.payment_details ? this.tableDetails.data.payment_details : []);
        // For invoice payment, items are in payment_details, for PO items are in po_items
        if (this.tableDetails.id === 'invoicepaymentreport') {
          this.old_json_data = this.tableDetails.old_json_data ? (this.tableDetails.old_json_data.items || []) : [];
        } else {
          this.old_json_data = this.tableDetails.old_json_data ? this.tableDetails.old_json_data.items : [];
        }
        this.diff_json_data = this.tableDetails.diff_json_data ? this.tableDetails.diff_json_data : {};
        // console.log("this.old_json_data ", this.old_json_data)
        this.show_difference = this.tableDetails.show_difference && this.tableDetails.show_difference=='1' ? true : false;
        this.commonVariableList.fields = this.tableDetails.data;
        this.company_setup.is_catalog_id_visible = false;
        this.company_setup.is_haz_visible = false;
        this.company_setup.is_hs_code_visible = false;
        this.company_setup.is_un_no_visible = false;
        this.company_setup.is_packaging_details_visible = false;
        this.company_setup.is_sample_details_visible = false;
        this.company_setup.is_item_unit_price_visible = false;
        this.company_setup.is_freight_visible = false;
        this.company_setup.is_insurance_visible = false;
        this.company_setup.is_other_cost_visible = false;
        let is_direct_items:boolean=false;
        let is_amend_visible:boolean=false;


        if(this.show_difference) {
          let sl_no: number = 1;
          for (let i of this.old_json_data) {
            i.sl_no = sl_no;
            i.is_highlighted_row=i.is_highlighted_row?i.is_highlighted_row:false;
            sl_no++;
          } 
        }

        this.company_setup.po_item_columnList = this.company_setup.po_item_columnList ? this.company_setup.po_item_columnList : []
        if (this.company_setup.po_item_columnList.length > 0) {
          this.company_setup.is_catalog_id_visible = this.company_setup.po_item_columnList.some((v) => { return v.id == 'catalog_id' && v.isVisible })
          this.company_setup.is_haz_visible = this.company_setup.po_item_columnList.some((v) => { return v.id == 'haz' && v.isVisible })
          this.company_setup.is_hs_code_visible = this.company_setup.po_item_columnList.some((v) => { return v.id == 'hs_code' && v.isVisible })
          this.company_setup.is_un_no_visible = this.company_setup.po_item_columnList.some((v) => { return v.id == 'un_no' && v.isVisible })
          this.company_setup.is_packaging_details_visible = this.company_setup.po_item_columnList.some((v) => { return v.id == 'packaging_details' && v.isVisible })
          this.company_setup.is_sample_details_visible = this.company_setup.po_item_columnList.some((v) => { return v.id == 'sample_details' && v.isVisible })
          this.company_setup.is_item_unit_price_visible = this.company_setup.po_item_columnList.some((v) => { return v.id == 'item_unit_price' && v.isVisible })
          this.company_setup.is_freight_visible = this.company_setup.po_item_columnList.some((v) => { return v.id == 'freight' && v.isVisible })
          this.company_setup.is_insurance_visible = this.company_setup.po_item_columnList.some((v) => { return v.id == 'insurance' && v.isVisible })
          this.company_setup.is_other_cost_visible = this.company_setup.po_item_columnList.some((v) => { return v.id == 'other_cost' && v.isVisible })
        }
        // console.log(this.commonVariableList.items)
        if(!is_new_item_visible)
        {
          this.commonVariableList.items=this.commonVariableList.items.filter((v)=>{return v.is_direct=='0'});
        }
        if (this.commonVariableList.items) {
          for (let d of this.commonVariableList.items) {
            if(d.is_direct=='0')
            {
              d.revised_po_date='';
            }
            if(!is_new_item_visible && d.is_direct=='0')
            {
              d.is_highlighted_row=false;
            }
            if(is_new_item_visible && d.is_direct=='1')
            {
              d.is_highlighted_row=true;
            }
            d.pending_qty = this.webService.convertNaN(d.pending_qty) ? this.webService.convertNaN(d.pending_qty, this.company_setup.allowed_digits_after_decimal) : '0';
            d.revised_qty = this.webService.convertNaN(d.revised_qty) ? this.webService.convertNaN(d.revised_qty, this.company_setup.allowed_digits_after_decimal) : '0';

            d.product_qty = this.webService.convertNaN(d.product_qty) ? this.webService.convertNaN(d.product_qty, this.company_setup.allowed_digits_after_decimal) : '0';
            
            d.unit_price = this.webService.convertNaN(d.unit_price) ? this.webService.convertNaN(d.unit_price, this.company_setup.allowed_digits_after_decimal) : '0';

            d.lead_time = this.webService.convertNaN(d.lead_time) ? this.webService.convertNaN(d.lead_time) : '0';
            d.current_stock = this.webService.convertNaN(d.current_stock) ? this.webService.convertNaN(d.current_stock) : '0';
            d.average_daily_consumption = this.webService.convertNaN(d.average_daily_consumption) ? this.webService.convertNaN(d.average_daily_consumption) : '0';
            d.inventory_in_hand = this.webService.convertNaN(d.inventory_in_hand) ? this.webService.convertNaN(d.inventory_in_hand) : '0';
            d.procured_days = this.webService.convertNaN(d.procured_days) ? this.webService.convertNaN(d.procured_days) : '0';
            d.moq = this.webService.convertNaN(d.moq) ? this.webService.convertNaN(d.moq) : '0';
            d.item_qty = this.webService.convertNaN(d.item_qty) ? this.webService.convertNaN(d.item_qty, this.company_setup.allowed_digits_after_decimal) : '0';

            d.unit_price = parseFloat(d.unit_price) ? parseFloat(d.unit_price) : '0';
            d.product_qty = parseFloat(d.product_qty) ? parseFloat(d.product_qty) : '0';

            d.lead_time = parseFloat(d.lead_time) ? parseFloat(d.lead_time) : '0';
            d.current_stock = parseFloat(d.current_stock) ? parseFloat(d.current_stock) : '0';
            d.average_daily_consumption = parseFloat(d.average_daily_consumption) ? parseFloat(d.average_daily_consumption) : '0';
            d.inventory_in_hand = parseFloat(d.inventory_in_hand) ? parseFloat(d.inventory_in_hand) : '0';
            d.procured_days = parseFloat(d.procured_days) ? parseFloat(d.procured_days) : '0';
            d.moq = parseFloat(d.moq) ? parseFloat(d.moq) : '0';
            d.item_qty = parseFloat(d.item_qty) ? parseFloat(d.item_qty) : '0';


            d.unit_price = this.webService.convertNaN(d.unit_price , this.company_setup.allowed_digits_after_decimal) ? this.webService.convertNaN(d.unit_price) : '0';
            d.product_qty = this.webService.convertNaN(d.product_qty) ? this.webService.convertNaN(d.product_qty, this.company_setup.allowed_digits_after_decimal) : '0';

            d.lead_time = this.webService.convertNaN(d.lead_time) ? this.webService.convertNaN(d.lead_time) : '0';
            d.current_stock = this.webService.convertNaN(d.current_stock) ? this.webService.convertNaN(d.current_stock) : '0';
            d.average_daily_consumption = this.webService.convertNaN(d.average_daily_consumption) ? this.webService.convertNaN(d.average_daily_consumption) : '0';
            d.inventory_in_hand = this.webService.convertNaN(d.inventory_in_hand) ? this.webService.convertNaN(d.inventory_in_hand) : '0';
            d.procured_days = this.webService.convertNaN(d.procured_days) ? this.webService.convertNaN(d.procured_days) : '0';
            d.moq = this.webService.convertNaN(d.moq) ? this.webService.convertNaN(d.moq) : '0';
            d.item_qty = this.webService.convertNaN(d.item_qty) ? this.webService.convertNaN(d.item_qty, this.company_setup.allowed_digits_after_decimal) : '0';

            d.product_qty=this.webService.convertNaN(d.product_qty, this.company_setup.allowed_digits_after_decimal)
            d.product_qty=parseFloat(d.product_qty)
            d.product_qty=this.webService.convertNaN(d.product_qty, this.company_setup.allowed_digits_after_decimal)

           // Assuming company_setup.allowed_digits_after_decimal is a number representing the desired decimal places
// //         const digitsAfterDecimal = this.company_setup.allowed_digits_after_decimal;
// const parsedValue = parseFloat(this.webService.convertNaN(d.product_unit_price));

// // Check if parsedValue is a valid number before using toFixed
// if (!isNaN(parsedValue)) {
//   // Use toFixed only if parsedValue is a valid number
//   d.product_unit_price = parsedValue.toFixed(digitsAfterDecimal);
// } else {
//   // Handle the case when parsedValue is NaN, for example, set d.product_unit_price to a default value
//   d.product_unit_price = '0.000000'; // Set to a default value or an appropriate value
// }

           d.product_unit_price=this.webService.convertNaN(d.product_unit_price , this.company_setup.allowed_digits_after_decimal)
          d.product_unit_price=parseFloat(d.product_unit_price)
          d.product_unit_price=this.webService.convertNaN(d.product_unit_price , this.company_setup.allowed_digits_after_decimal)







            d.hsn_other_tax = d.hsn_other_tax ? d.hsn_other_tax : '0'
            d.hsn_ugst = d.hsn_ugst ? d.hsn_ugst : '0'
            d.hsn_cgst = d.hsn_cgst ? d.hsn_cgst : '0'
            d.hsn_sgst = d.hsn_sgst ? d.hsn_sgst : '0'
            d.hsn_igst = d.hsn_igst ? d.hsn_igst : '0'

            d.cess = this.webService.convertNaN(d.cess)
            d.other_tax = this.webService.convertNaN(d.other_tax)
            d.ugst = this.webService.convertNaN(d.ugst)
            d.cgst = this.webService.convertNaN(d.cgst)
            d.sgst = this.webService.convertNaN(d.sgst)
            d.igst = this.webService.convertNaN(d.igst)

            d.cess = parseFloat(d.cess)
            d.other_tax = parseFloat(d.other_tax)
            d.ugst = parseFloat(d.ugst)
            d.cgst = parseFloat(d.cgst)
            d.sgst = parseFloat(d.sgst)
            d.igst = parseFloat(d.igst)


            d.cgst=this.webService.convertNaN(d.cgst)
            d.sgst=this.webService.convertNaN(d.sgst)
            d.igst=this.webService.convertNaN(d.igst)
            d.ugst=this.webService.convertNaN(d.ugst)
            d.cess=this.webService.convertNaN(d.cess)
            d.other_tax=this.webService.convertNaN(d.other_tax)


            d.hsn_cess = parseFloat(d.cess) <= 0 ? '' : d.hsn_cess;
            d.hsn_other_tax = parseFloat(d.other_tax) <= 0 ? '' : d.hsn_other_tax;
            d.hsn_ugst = parseFloat(d.ugst) <= 0 ? '' : d.hsn_ugst;
            d.hsn_cgst = parseFloat(d.cgst) <= 0 ? '' : d.hsn_cgst;
            d.hsn_sgst = parseFloat(d.sgst) <= 0 ? '' : d.hsn_sgst;
            d.hsn_igst = parseFloat(d.igst) <= 0 ? '' : d.hsn_igst;
            
            // d.service_end_date = this.webService.makeWrongDateEmpty( d.service_end_date)
            // d.service_start_date = this.webService.makeWrongDateEmpty(d.service_start_date)
            d.service_end_date = this.webService.formatDateAccordingToSetup(
              this.webService.makeWrongDateEmpty(this.webService.getLocalDate(d.service_end_date)), 
              this.company_setup.in_invoice_date_format
            );
            d.service_start_date = this.webService.formatDateAccordingToSetup(
              this.webService.makeWrongDateEmpty(this.webService.getLocalDate(d.service_start_date)), 
              this.company_setup.in_invoice_date_format
            );
            // d.product_required_by = this.webService.makeWrongDateEmpty(d.product_required_by)
            d.product_required_by = this.webService.formatDateAccordingToSetup(this.webService.getLocalDate(d.product_required_by),this.company_setup.in_invoice_date_format)
            d.amend_po_status=d.amend_po_status?d.amend_po_status:'',
            d.haz = d.haz == '1' ? 'Yes': 'No'
            d.delivery_cc_name = d.delivery_cc_name ? d.delivery_cc_name : '';
            d.is_cvppm = d.price_coming_from_cvppm == '1' ? true : false;
            this.company_setup.discount_type_in_po = d.discount_type_in_po ? d.discount_type_in_po : this.company_setup.discount_type_in_po;
              }
        }

        let is_not_service: boolean = true;
        let is_goods: boolean = true;
        let is_logistic: boolean = true;
        let is_all_service: boolean = true;
        let is_not_discount: boolean = false;
        let isServiceProduct:boolean = false;
        let is_revised_qty_visible:boolean=false;
        let is_pending_qty_visible:boolean=false;

        is_revised_qty_visible=this.commonVariableList.items.some((v) => {
          return parseFloat(this.webService.convertNaN(v.revised_qty))>0
        })
        is_pending_qty_visible=this.commonVariableList.items.some((v) => {
          return parseFloat(this.webService.convertNaN(v.pending_qty))>0
        })

        is_direct_items=this.commonVariableList.items.some((v) => {
          return v.is_direct =="1"
        })
        is_amend_visible=this.commonVariableList.items.some((v) => {
          return v.amend_po_status !='' && v.amend_po_status !=undefined
        })

        is_not_discount = this.commonVariableList.items.every((v) => {
          return v.discount_unit_price == '0'
        })

        is_logistic = this.commonVariableList.items.some((v) => {
          return v.is_logistic
        })
        
        is_goods = this.commonVariableList.items.every((v) => {
          if( v.product_type != null){
            return v.product_type.toLowerCase() == 'goods'
          }
        })
        is_not_service = this.commonVariableList.items.every((v) => {
          return v.service_start_date == '' && v.service_end_date == ''
        })
        is_all_service = this.commonVariableList.items.every((v) => {
          if(v.product_type != null){
          return v.product_type.toLowerCase() == 'services'
          }
        })
        isServiceProduct = this.commonVariableList.items.some((v) => {
          if(v.product_type != null){
          return v.product_type.toLowerCase() == 'services'
          }
        })
        let revised_po_date_visible:boolean=this.commonVariableList.items.some((v) => {
          return v.revised_po_date !='' && v.revised_po_date!=undefined && v.revised_po_date!=null
        })
        if(url=="/my-orders"|| url=='/poapproval-summary'||url=='/po-approval')
{
  is_revised_qty_visible=false;
}

        this.tableDetails.data.is_custom_ship_to_location = this.tableDetails.data.is_custom_ship_to_location ? this.tableDetails.data.is_custom_ship_to_location : '0';
        this.tableDetails.data.custom_ship_to_location = this.tableDetails.data.custom_ship_to_location ? this.tableDetails.data.custom_ship_to_location : '0';

        if (this.commonVariableList.columnList && this.commonVariableList.items) {
          for(let d of this.commonVariableList.items){
          for (let i of this.commonVariableList.columnList) {

            if (i.value == 'revised_qty' && is_revised_qty_visible) {
              i.is_view = true;
            }
            if (i.value == 'revised_qty' && !is_revised_qty_visible) {
              i.is_view = false;
            }

            if (i.value == 'pending_qty' && is_pending_qty_visible) {
              i.is_view = true;
            }
            if (i.value == 'pending_qty' && !is_pending_qty_visible) {
              i.is_view = false;
            }
            if(i.value=='service_start_date' && d.product_type=='goods')
            {
              i.is_view=false     
            }
            if(i.value=='service_end_date' && d.product_type=='goods')
            {
              i.is_view=false     
            }

            if(i.value == 'cgst' && this.company_setup.custom_cgst_visible == '1'){
              i.display = this.company_setup.custom_cgst_name?this.company_setup.custom_cgst_name:'CGST';
              if(!d.CgstVisible && this.commonVariableList.fields.is_different_document_currency) {
                i.is_view = false;
              } else if (!d.CgstVisible || !this.commonVariableList.fields.is_different_document_currency){
                i.is_view = false;
              } else {
                i.is_view = true;
              }
            }

            if(i.value == 'sgst' && this.company_setup.custom_sgst_visible == '1'){
              i.display = this.company_setup.custom_sgst_name?this.company_setup.custom_sgst_name:'SGST';
              if(!d.SgstVisible && this.commonVariableList.fields.is_different_document_currency) {
                i.is_view = false;
              } else if (!d.SgstVisible || !this.commonVariableList.fields.is_different_document_currency){
                i.is_view = false;
              } else {
                i.is_view = true;
              }
            }
            if(i.value == 'igst' && this.company_setup.custom_igst_visible == '1'){
              i.display = this.company_setup.custom_igst_name?this.company_setup.custom_igst_name:'IGST';
              if(!d.IgstVisible && this.commonVariableList.fields.is_different_document_currency) {
                i.is_view = false;
              } else if (!d.IgstVisible || !this.commonVariableList.fields.is_different_document_currency){
                i.is_view = false;
              } else {
                i.is_view = true;
              }
            }
            if(i.value == 'ugst' && this.company_setup.custom_ugst_visible == '1'){
              i.display = this.company_setup.custom_ugst_name?this.company_setup.custom_ugst_name:'UGST';
              if(!d.UgstVisible && this.commonVariableList.fields.is_different_document_currency) {
                i.is_view = false;
              } else if (!d.UgstVisible || !this.commonVariableList.fields.is_different_document_currency){
                i.is_view = false;
              } else {
                i.is_view = true;
              }
            }
            if(i.value == 'cess' && this.company_setup.custom_cess_visible == '1'){
              i.display = this.company_setup.custom_cess_name?this.company_setup.custom_cess_name:'CESS';
              if(!d.CessVisible && this.commonVariableList.fields.is_different_document_currency) {
                i.is_view = false;
              } else if (!d.CessVisible || !this.commonVariableList.fields.is_different_document_currency){
                i.is_view = false;
              } else {
                i.is_view = true;
              }
            }
            if(i.value == 'other_tax' && this.company_setup.custom_other_tax_visible == '1'){
              i.display = this.company_setup.custom_other_tax_name?this.company_setup.custom_other_tax_name:'Other Tax';
              if(!d.OthertaxVisible && this.commonVariableList.fields.is_different_document_currency) {
                i.is_view = false;
              } else if (!d.OthertaxVisible || !this.commonVariableList.fields.is_different_document_currency){
                i.is_view = false;
              } else {
                i.is_view = true;
              }
            }
            if(i.value == 'product_required_by'){
              i.display = this.company_setup.custome_name_for_required_by_in_po_pr_module;
            }
            if(i.value == 'hsn_code' && this.company_setup.is_hsn_code_visible == '1'){
              i.is_view = true;
            }

            if (i.value == 'ship_to_location' && this.tableDetails.data.is_custom_ship_to_location == '0') {
              i.is_view = true;
            }
            if (i.value == 'ship_to_location' && this.tableDetails.data.is_custom_ship_to_location == '1') {
              i.is_view = false;
            }

            if (i.value == 'open_po_qty' && this.company_setup.is_show_open_qty_button_visible_at_raise_time == '1') {
              i.is_view = true;
            }
            if (i.value == 'open_po_qty' && this.company_setup.is_show_open_qty_button_visible_at_raise_time == '0') {
              i.is_view = false;
            }


            if (i.value == 'open_grn_qty' && this.company_setup.is_show_open_qty_button_visible_at_raise_time == '1') {
              i.is_view = true;
            }
            if (i.value == 'open_grn_qty' && this.company_setup.is_show_open_qty_button_visible_at_raise_time == '0') {
              i.is_view = false;
            }

            if(i.value == 'revised_po_date' &&!is_new_item_visible)
            {
              i.is_view=false
            }
            if(i.value == 'revised_po_date' &&is_new_item_visible)
            {
              i.is_view=true;
              if(!is_direct_items)
              {
                i.is_view=false;
              }

              if(!revised_po_date_visible)
              {
                i.is_view=false;
              }
            }
            // amend po start

            if (i.value == 'amend_po_status' && is_amend_visible) {
              i.is_view = true;
              if(!is_new_item_visible)
              {
                i.is_view=false;
              }
            }
            if (i.value == 'amend_po_status' && !is_amend_visible) {
              i.is_view = false;
            }

            if (i.value == 'amend_po_qty' && is_amend_visible) {
              i.is_view = true;
              if(!is_new_item_visible)
              {
                i.is_view=false;
              }
            }
            if (i.value == 'amend_po_qty' && !is_amend_visible) {
              i.is_view = false;
            }


            if (i.value == 'amend_date' && is_amend_visible) {
              i.is_view = true;
              if(!is_new_item_visible)
              {
                i.is_view=false;
              }
            }
            if (i.value == 'amend_date' && !is_amend_visible) {
              i.is_view = false;
            }

            if (i.value == 'amend_added_by' && is_amend_visible) {
              i.is_view = true;
              if(!is_new_item_visible)
              {
                i.is_view=false;
              }
            }
            if (i.value == 'amend_added_by' && !is_amend_visible) {
              i.is_view = false;
            }
            // amend po closed

            if (i.value == 'average_daily_consumption') {
              i.display = this.company_setup.average_consumption_frequency_name;
            }

            if (i.value == 'current_stock' && this.company_setup.is_current_stock_po_visible == '1') {
              i.is_view = true;
            }
            if (i.value == 'current_stock' && this.company_setup.is_current_stock_po_visible == '0') {
              i.is_view = false;
            }

            if (i.value == 'current_stock' && this.tableDetails.data.is_direct=='1') {
              // i.is_view = false;
            }

            if (i.value == 'average_daily_consumption' && this.company_setup.is_average_daily_consumption_po_visible == '1') {
              i.is_view = true;
            }
            if (i.value == 'average_daily_consumption' && this.company_setup.is_average_daily_consumption_po_visible == '0') {
              i.is_view = false;
            }

            if (i.value == 'average_daily_consumption' && this.tableDetails.data.is_direct=='1') {
              // i.is_view = false;
            }

            if (i.value == 'inventory_in_hand' && this.company_setup.is_inventory_in_hand_po_visible == '1') {
              i.is_view = true;
            }
            if (i.value == 'inventory_in_hand' && this.company_setup.is_inventory_in_hand_po_visible == '0') {
              i.is_view = false;
            }
 if (i.value == 'inventory_in_hand' && this.tableDetails.data.is_direct=='1') {
              // i.is_view = false;
            }
            if (i.value == 'inventory_in_hand') {
              i.display = this.company_setup.pr_inventory_in_hand_name;
            }
            if (i.value == 'procured_days') {
              i.display = this.company_setup.pr_procured_days_name;
            }
            if (i.value == 'lead_time' && this.company_setup.is_lead_time_po_visible == '1') {
              i.is_view = true;
            }
            if (i.value == 'lead_time' && this.company_setup.is_lead_time_po_visible == '0') {
              i.is_view = false;
            }
            if (i.value == 'lead_time' && this.tableDetails.data.is_direct=='1') {
              // i.is_view = false;
            }

            if (i.value == 'procured_days' && this.company_setup.is_procured_days_po_visible == '1') {
              i.is_view = true;
            }
            if (i.value == 'procured_days' && this.company_setup.is_procured_days_po_visible == '0') {
              i.is_view = false;
            }

            if (i.value == 'procured_days' && this.tableDetails.data.is_direct=='1') {
              // i.is_view = false;
            }
            if (i.value == 'discount_unit_price' && this.company_setup.is_discount_applicable_in_po == '1') {
              i.is_view = true;
              if (this.company_setup.discount_type_in_po == '0' || this.company_setup.discount_type_in_po == 'none') {
                if (i.value == 'discount_unit_price') {
                  i.is_view = false;
                }
              }
            }
            if (i.value == 'discount_unit_price' && this.company_setup.is_discount_applicable_in_po == '0') {
              i.is_view = false;
            }
            if (i.value == 'discounted_unit_price' && this.company_setup.is_discount_applicable_in_po == '1') {
              i.is_view = true;
              if (this.company_setup.discount_type_in_po == '0' || this.company_setup.discount_type_in_po == 'none') {
                if (i.value == 'discounted_unit_price') {
                  i.is_view = false;
                }
              }
            }
            if (i.value == 'discounted_unit_price' && this.company_setup.is_discount_applicable_in_po == '0') {
              i.is_view = false;
            }

            if (i.value == 'discount_amount' && this.company_setup.is_discount_applicable_in_po == '1') {
              i.is_view = true;
              if (this.company_setup.discount_type_in_po == '0' || this.company_setup.discount_type_in_po == 'none') {
                if (i.value == 'discount_amount') {
                  i.is_view = false;
                }
              }
            }
            if (i.value == 'discount_amount' && this.company_setup.is_discount_applicable_in_po == '0') {
              i.is_view = false;
            }

            if (i.value == 'discounted_amount' && this.company_setup.is_discount_applicable_in_po == '1') {
              i.is_view = true;
              if (this.company_setup.discount_type_in_po == '0' || this.company_setup.discount_type_in_po == 'none') {
                if (i.value == 'discounted_amount') {
                  i.is_view = false;
                }
              }
            }
            if (i.value == 'discounted_amount' && this.company_setup.is_discount_applicable_in_po == '0') {
              i.is_view = false;
            }

            if (i.value == 'discount_percentage' && this.company_setup.is_discount_applicable_in_po == '1') {
              i.is_view = true;
              if (this.company_setup.discount_type_in_po == '0' || this.company_setup.discount_type_in_po == 'none') {
                if (i.value == 'discount_percentage') {
                  i.is_view = false;
                }
              }
            }
            if (i.value == 'discount_percentage' && this.company_setup.is_discount_applicable_in_po == '0') {
              i.is_view = false;
            }



            if (i.value == 'product_catalog_id' && this.company_setup.is_catalog_id_visible && this.company_setup.product_catalog_id_one == '1') {
              i.is_view = true;
            }
            if (i.value == 'product_catalog_id' && (!this.company_setup.is_catalog_id_visible || this.company_setup.product_catalog_id_one == '0')) {
              i.is_view = false;
            }
            if (i.value == 'product_catalog_id') {
              i.display = this.company_setup.product_master_catelogue_id_name;
            }

            if (i.value == 'description' &&  this.company_setup.while_raising_a_po_prod_Desc_Visible == '1') {
              i.is_view = true;
            }
            if (i.value == 'description' &&  this.company_setup.while_raising_a_po_prod_Desc_Visible == '0') {
              i.is_view = false;
            }

             if (i.value == 'previously_raised_unit_price' &&  this.company_setup.previously_raised_unit_price == '1') {
              i.is_view = true;
            }
            if (i.value == 'previously_raised_unit_price' &&  this.company_setup.previously_raised_unit_price == '0') {
              i.is_view = false;
            }
            if (i.value == 'conversion_unit_price' && this.tableDetails.data.is_different_document_currency == '1') {
              i.is_view = true;
              i.display = "Unit price (" + this.tableDetails.data.currency_code + ")"
            }
            if (i.value == 'conversion_unit_price' && this.tableDetails.data.is_different_document_currency == '0') {
              i.is_view = false;
              i.display = "Unit price ("+this.company_setup.currency_icon+")";

            }

            if (i.value == 'is_logistic' && !is_logistic) {
              i.is_view = false;
            }
            if ((i.value == 'service_start_date' || i.value == 'service_end_date' || i.value == 'total_duration') &&  this.company_setup.is_service_start_end_date_visible == '0') {
              i.is_view = false;
            }

            if ((i.value == 'service_start_date' || i.value == 'service_end_date' || i.value == 'total_duration') && this.company_setup.is_service_start_end_date_visible == '0') {
              i.is_view = false;
            }

            if ((i.value == 'service_start_date' || i.value == 'service_end_date' || i.value == 'total_duration') && (isServiceProduct && this.company_setup.is_service_start_end_date_visible == '1')) {
              i.is_view = true;
            }
            if (i.value == 'budget_amount' && this.company_setup.is_budget_amount_in_po == '1') {
              i.is_view = true;
            }
            if (i.value == 'budget_amount' && this.company_setup.is_budget_amount_in_po == '0') {
              i.is_view = false;
            }

            if(i.value=='ship_to_location'){
              i.display= this.company_setup.custom_ship_location_name ? this.company_setup.custom_ship_location_name : 'Ship Location'
              if(this.company_setup.show_lob_dropdown == '0' && this.company_setup.show_loc_dropdown == '0'){
                i.is_view = true;
              }else{
                i.is_view = false;
              }
            }
            if (i.value == 'haz' && this.company_setup.is_haz_visible) {
              i.is_view = true;
              i.display = this.company_setup.custom_name_haz_in_po;
            }
            if (i.value == 'haz' && this.company_setup.is_haz_visible == false) {
              i.is_view = false;
            }
            if (i.value == 'hs_code' && this.company_setup.is_hs_code_visible) {
              i.is_view = true;
              i.display = this.company_setup.custom_name_hs_code_in_po;
            }
            if (i.value == 'hs_code' && this.company_setup.is_hs_code_visible == false) {
              i.is_view = false;
            }
            if (i.value == 'un_no' && this.company_setup.is_un_no_visible) {
              i.is_view = true;
              i.display = this.company_setup.custom_name_un_no_in_po;
            }
            if (i.value == 'un_no' && this.company_setup.is_un_no_visible == false) {
              i.is_view = false;
            }
            if (i.value == 'packaging_details' && this.company_setup.is_packaging_details_visible) {
              i.is_view = true;
              i.display = this.company_setup.custom_name_packaging_details_in_po;
            }
            if (i.value == 'packaging_details' && this.company_setup.is_packaging_details_visible == false) {
              i.is_view = false;
            }
            if (i.value == 'sample_details' && this.company_setup.is_sample_details_visible) {
              i.is_view = true;
              i.display = this.company_setup.custom_name_sample_details_in_po;
            }
            if (i.value == 'sample_details' && this.company_setup.is_sample_details_visible == false) {
              i.is_view = false;
            }
            if (i.value == 'delivery_cc_name' && this.company_setup.is_delivery_cc_visible_po == '1') {
              i.is_view = true;
            }
            if (i.value == 'delivery_cc_name' && this.company_setup.is_delivery_cc_visible_po == '0') {
              i.is_view = false;
            }
            if (i.value == 'category_name' && this.company_setup.product_category_subcategory_visible_in_po == '1') {
              i.is_view = true;
            }
            if (i.value == 'category_name' && this.company_setup.product_category_subcategory_visible_in_po == '0') {
              i.is_view = false;
            }
            if (i.value == 'subcategory_name' && this.company_setup.product_category_subcategory_visible_in_po == '1') {
              i.is_view = true;
            }
            if (i.value == 'subcategory_name' && this.company_setup.product_category_subcategory_visible_in_po == '0') {
              i.is_view = false;
            }
            if(i.value=='is_cvppm' && this.company_setup.show_is_cvppm_in_po_module != '0') {
              i.is_view = true;
              i.display = this.company_setup.coming_from_cvppm;
            }
            if(i.value=='is_cvppm' && this.company_setup.show_is_cvppm_in_po_module == '0') {
              i.is_view = false;
            }
            if(i.value=='storage_location' && this.company_setup.is_storage_location_visible_in_po == '1') {
              i.is_view = true;
            }
            if(i.value=='storage_location' && this.company_setup.is_storage_location_visible_in_po == '0') {
              i.is_view = false;
            }
            if (i.value == 'channel_type_name') {
              i.is_view = this.webService.is_column_visible(this.company_setup.po_additional_fields_column_list, 'channel', false);
              i.display = this.webService.getColumnName(this.company_setup.po_additional_fields_column_list, 'channel', 'Channel');
            }
          }
        }
        }
        // this.makeData();
        this.makeData_one();


        break;
      case 'mpreport':
        this.commonVariableList.columnList = globalVariables.mpVariableList.columnList;
        this.commonVariableList.items = this.tableDetails.data.mp_items ? this.tableDetails.data.mp_items : [];

        if (this.commonVariableList.columnList) {
          for (let i of this.commonVariableList.columnList) {

            if (i.value == 'product_catalog_id' && this.company_setup.product_catalog_id == '1') {
              i.is_view = true;
            }
            if (i.value == 'product_catalog_id' && this.company_setup.product_catalog_id == '0') {
              i.is_view = false;
            }
            if (i.value == 'average_daily_consumption' && this.company_setup.is_average_daily_consumption_visible == '1') {
              i.is_view = true;
            }

            if (i.value == 'moq' && this.company_setup.is_moq_visible == '1') {
              i.is_view = true;
            }

          }
        }
        this.makeData();

        break;
      case 'sireport':
        this.commonVariableList.columnList = globalVariables.siVariableList.columnList;
        this.commonVariableList.items = this.tableDetails.data.si_items ? this.tableDetails.data.si_items : [];
        let project_detail = '';
        let customer_detail = '';



        if (this.commonVariableList.items) {
          for (let i of this.commonVariableList.items) {
            let d: any = {};
            d = i ? i : {};

            if (d.project_name != '' && d.project_name != undefined) {
              project_detail = d.project_name + " (" + d.project_code + ")";
            }
            if (d.customer_first_name != '' && d.customer_first_name != undefined) {
              customer_detail = d.customer_first_name + " " + d.customer_last_name + " (" + d.customer_code + ")";
            }

            i.customer_detail = customer_detail ? customer_detail : '';
            i.project_detail = project_detail ? project_detail : '';

          }
        }

        if (this.commonVariableList.columnList) {
          for (let i of this.commonVariableList.columnList) {
            if (i.value == 'product_catalog_id' && this.company_setup.product_catalog_id == '1') {
              i.is_view = true;
            }
            if (i.value == 'product_catalog_id' && this.company_setup.product_catalog_id == '0') {
              i.is_view = false;
            }

            if (i.value == 'project_detail' && project_detail != '' && project_detail != undefined) {
              i.is_view = true;
            }
            if (i.value == 'project_detail' && (project_detail == '' || project_detail == undefined)) {
              i.is_view = false;
            }

            if (i.value == 'customer_detail' && customer_detail != '' && customer_detail != undefined) {
              i.is_view = true;
            }
            if (i.value == 'customer_detail' && (customer_detail == '' || customer_detail == undefined)) {
              i.is_view = false;
            }
          }
        }


        this.makeData();

        break;
      case 'prreport':
        if(this.company_setup.is_enquire_form_item_level_visible_in_pr=='1')
        {
          this.actionsList=globalVariables.prVariableList.actionsList?globalVariables.prVariableList.actionsList:[]
          this.actionsList=this.actionsList.filter((v)=>{return v.is_visible})
          }
        this.commonVariableList.columnList = globalVariables.prVariableList.columnList;
        this.commonVariableList.items = this.tableDetails.data.pr_items ? this.tableDetails.data.pr_items : [];
        this.company_setup.in_pr_editable_boq_unit_or_boq_item_qty=this.company_setup.in_pr_editable_boq_unit_or_boq_item_qty?this.company_setup.in_pr_editable_boq_unit_or_boq_item_qty:'boq_item_qty'
        this.company_setup.in_invoice_date_format = this.company_setup.in_invoice_date_format ? this.company_setup.in_invoice_date_format : "dd-mm-yyyy";

        this.showAvailableBudget = (this.tableDetails.showAvailableBudget && this.tableDetails.showAvailableBudget == "0") ? false: true;
        this.showAmounts = (this.tableDetails.showAmounts && this.tableDetails.showAmounts == "0") ? false: true;

        // console.log("this.showAvailableBudget",this.showAvailableBudget)
        // console.log("this.showAmounts",this.showAmounts)
        // console.log("Page URL",this.page_url)
        
        if (this.commonVariableList.items) {
          for (let d of this.commonVariableList.items) {
            d.ven_list=[];
            let v_list:any=[];
            d.vendor=d.vendor?d.vendor:[];
            if(d.vendor)
            {
              for(let p of d.vendor)
              {
                v_list.push(p.vendor_first_name + p.vendor_last_name +"("+p.vendor_code+")")
              }
              // d.ven_list=v_list.join(',')
              d.ven_list=v_list
            }
            d.product_qty = this.webService.convertNaN(d.product_qty) ? this.webService.convertNaN(d.product_qty, this.tableDetails.data.is_boq!='0'|| this.tableDetails.data.is_boq!=false? this.company_setup.allowed_digits_after_decimal_for_boq:this.company_setup.allowed_digits_after_decimal) : '0';
            d.unit_price = this.webService.convertNaN(d.unit_price) ? this.webService.convertNaN(d.unit_price, this.tableDetails.data.is_boq!='0'|| this.tableDetails.data.is_boq!=false? this.company_setup.allowed_digits_after_decimal_for_boq:this.company_setup.allowed_digits_after_decimal) : '0';
            d.product_description = d.product_description ? d.product_description : '';
            d.lead_time = this.webService.convertNaN(d.lead_time) ? this.webService.convertNaN(d.lead_time) : '0';
            d.current_stock = this.webService.convertNaN(d.current_stock) ? this.webService.convertNaN(d.current_stock) : '0';
            d.average_daily_consumption = this.webService.convertNaN(d.average_daily_consumption) ? this.webService.convertNaN(d.average_daily_consumption) : '0';
            d.inventory_in_hand = this.webService.convertNaN(d.inventory_in_hand) ? this.webService.convertNaN(d.inventory_in_hand) : '0';
            d.procured_days = this.webService.convertNaN(d.procured_days) ? this.webService.convertNaN(d.procured_days) : '0';
            d.moq = this.webService.convertNaN(d.moq) ? this.webService.convertNaN(d.moq) : '0';
            d.item_qty = this.webService.convertNaN(d.item_qty) ? this.webService.convertNaN(d.item_qty) : '0';
            d.is_closed_item_wise = d.is_closed_item_wise == '0'?false:true;
            d.unit_price = parseFloat(d.unit_price) ? parseFloat(d.unit_price) : '0';
            d.product_qty = parseFloat(d.product_qty) ? parseFloat(d.product_qty) : '0';

            d.lead_time = parseFloat(d.lead_time) ? parseFloat(d.lead_time) : '0';
            d.current_stock = parseFloat(d.current_stock) ? parseFloat(d.current_stock) : '0';
            d.average_daily_consumption = parseFloat(d.average_daily_consumption) ? parseFloat(d.average_daily_consumption) : '0';
            d.inventory_in_hand = parseFloat(d.inventory_in_hand) ? parseFloat(d.inventory_in_hand) : '0';
            d.procured_days = parseFloat(d.procured_days) ? parseFloat(d.procured_days) : '0';
            d.moq = parseFloat(d.moq) ? parseFloat(d.moq) : '0';
            d.item_qty = parseFloat(d.item_qty) ? parseFloat(d.item_qty) : '0';


            d.unit_price = this.webService.convertNaN(d.unit_price) ? this.webService.convertNaN(d.unit_price, this.tableDetails.data.is_boq!='0'|| this.tableDetails.data.is_boq!=false?this.company_setup.allowed_digits_after_decimal_for_boq:this.company_setup.allowed_digits_after_decimal) : '0';
            d.ddc_unit_price = this.webService.convertNaN(d.ddc_unit_price) ? this.webService.convertNaN(d.ddc_unit_price, this.tableDetails.data.is_boq!='0'|| this.tableDetails.data.is_boq!=false?this.company_setup.allowed_digits_after_decimal_for_boq:this.company_setup.allowed_digits_after_decimal) : '0';
            d.product_qty = this.webService.convertNaN(d.product_qty) ? this.webService.convertNaN(d.product_qty, this.tableDetails.data.is_boq!='0'|| this.tableDetails.data.is_boq!=false?this.company_setup.allowed_digits_after_decimal_for_boq:this.company_setup.allowed_digits_after_decimal) : '0';

            d.lead_time = this.webService.convertNaN(d.lead_time) ? this.webService.convertNaN(d.lead_time) : '0';
            d.current_stock = this.webService.convertNaN(d.current_stock) ? this.webService.convertNaN(d.current_stock) : '0';
            d.average_daily_consumption = this.webService.convertNaN(d.average_daily_consumption) ? this.webService.convertNaN(d.average_daily_consumption) : '0';
            d.inventory_in_hand = this.webService.convertNaN(d.inventory_in_hand) ? this.webService.convertNaN(d.inventory_in_hand) : '0';
            d.procured_days = this.webService.convertNaN(d.procured_days) ? this.webService.convertNaN(d.procured_days) : '0';
            d.moq = this.webService.convertNaN(d.moq) ? this.webService.convertNaN(d.moq) : '0';
            d.item_qty = this.webService.convertNaN(d.item_qty) ? this.webService.convertNaN(d.item_qty) : '0';
            d.delivery_cc_name = d.delivery_cc_name ? d.delivery_cc_name : '';
            d.product_required_by = this.webService.formatDateAccordingToSetup(this.webService.getLocalDate(d.product_required_by),this.company_setup.in_invoice_date_format)
            d.project_name = d.project_name ? d.project_name : ''
            d.task_name = d.task_name ? d.task_name : ''
            d.balance_budget = d.balance_budget ? d.balance_budget : '',
            d.task_available_budget = d.task_available_budget ? d.task_available_budget : ''
          }
        }
        this.enquiryList=this.tableDetails.data.pr_items ? this.tableDetails.data.pr_items : [];
        this.company_setup.is_catalog_id_visible = false;
        this.company_setup.pr_item_columnList = this.company_setup.pr_item_columnList ? this.company_setup.pr_item_columnList : []
        if (this.company_setup.pr_item_columnList.length > 0) {
          this.company_setup.is_catalog_id_visible = this.company_setup.pr_item_columnList.some((v) => { return v.id == 'catalog_id' && v.isVisible })
        }
        // console.log(this.commonVariableList.columnList)
        if (this.commonVariableList.columnList) {
          for (let i of this.commonVariableList.columnList) {
            // if(i.value == 'is_closed_item_wise'){
            //   i.is_closed_item_wise = i.is_closed_item_wise == '0'?false:true;
            // }
            if (i.value == 'total_value' && this.company_setup.tot_val_visible_in_pr == '1') {
              i.is_view = true;
            }
            if (i.value == 'total_value' && (this.company_setup.tot_val_visible_in_pr == '0' || !this.showAmounts)) {
              i.is_view = false;
            }

            if (i.value == 'ven_list' && this.company_setup.preferred_vend_visible_in_pr == '1') {
              i.is_view = true;
            }
            if (i.value == 'ven_list' && this.company_setup.preferred_vend_visible_in_pr == '0') {
              i.is_view = false;
            }
            if(i.value=='already_raised_qty' && this.company_setup.in_pr_editable_boq_unit_or_boq_item_qty=='boq_item_qty' && this.tableDetails.data.is_boq=='1')
            {
              i.is_view=true;
            }
            if(i.value=='already_raised_qty' && (this.company_setup.in_pr_editable_boq_unit_or_boq_item_qty!='boq_item_qty' || this.tableDetails.data.is_boq!='1'))
            {
              i.is_view=false;
            }
            if (i.value == 'product_catalog_id' && this.company_setup.is_catalog_id_visible && this.company_setup.product_catalog_id == '1') {
              i.is_view = true;
            }
            if (i.value == 'product_catalog_id' && (!this.company_setup.is_catalog_id_visible || this.company_setup.product_catalog_id == '0')) {
              i.is_view = false;
            }
            if (i.value == 'average_daily_consumption') {
              i.display = this.company_setup.average_consumption_frequency_name;
            }
            if (i.value == 'unit_price' && (this.company_setup.is_pr_unit_price_visible == '0' || !this.showAmounts)) {
              i.is_view = false;
            }
            
            if (i.value == 'ddc_unit_price') {
              i.display = 'Unit Price (' + this.tableDetails.data.currency_code + ')'
              if((this.company_setup.is_pr_unit_price_visible == '0' || this.tableDetails.data.is_different_document_currency!='1' || !this.showAmounts)) {
                i.is_view = false;
              } else {
                i.is_view = true;
              }
            }
            if (i.value == 'project_name') {
              if(this.company_setup.is_budget_selection_at_item_level_in_product_table == '1'){
                i.is_view = true;
                i.display = this.company_setup.rename_project ? this.company_setup.rename_project : 'Project'
              }else{
                i.is_view = false;
              }
            }
            if (i.value == 'task_name') {
              if(this.company_setup.is_budget_selection_at_item_level_in_product_table == '1'){
                i.is_view = true;
                i.display = this.company_setup.rename_task ? this.company_setup.rename_task : 'Task'
              }else{
                i.is_view = false;
              }
            }
            if (i.value == 'current_stock' && this.company_setup.is_current_stock_visible == '1') {
              i.is_view = true;
            }
            if (i.value == 'shortfall_quantity') {
              i.display = this.getPrColumnName('shortfall_quantity', 'Shortfall Quantity');
              i.is_view = this.is_pr_column_visible('shortfall_quantity', false);
            }

            if(i.value == 'hsn_code' && this.company_setup.is_hsn_code_visible == '1'){
              i.is_view = true;
            }

            if (i.value == 'average_daily_consumption' && this.company_setup.is_average_daily_consumption_visible == '1') {
              i.is_view = true;
            }
            if (i.value == 'inventory_in_hand' && this.company_setup.is_inventory_in_hand_visible == '1') {
              i.is_view = true;
            }
            if (i.value == 'inventory_in_hand') {
              i.display = this.company_setup.pr_inventory_in_hand_name;
            }
            if (i.value == 'procured_days') {
              i.display = this.company_setup.pr_procured_days_name;
            }
            if (i.value == 'lead_time' && this.company_setup.is_lead_time_visible == '1') {
              i.is_view = true;
            }
            if (i.value == 'procured_days' && this.company_setup.is_procured_days_visible == '1') {
              i.is_view = true;
            }

            if (i.value == 'moq' && this.company_setup.is_moq_visible == '1') {
              i.is_view = true;
            }
            if (i.value == 'product_required_by') {
              i.display = this.company_setup.custome_name_for_required_by_in_po_pr_module;
            }
            if (i.value == 'product_description') {
              if(this.is_pr_column_visible('product_description', false)){
                i.is_view = true;
              }else{
                i.is_view = false
              }
              i.display = this.getPrColumnName('product_description', 'Product Description');

            }
            if (i.value == 'delivery_cc_name' && this.company_setup.is_delivery_cc_visible_po == '1') {
              i.is_view = true;
            }
            if (i.value == 'delivery_cc_name' && this.company_setup.is_delivery_cc_visible_po == '0') {
              i.is_view = false;
            }
            if (i.value == 'category_name' && this.company_setup.visible_product_category_subcategory_in_pr == '1') {
              i.is_view = true;
            }
            if (i.value == 'category_name' && this.company_setup.visible_product_category_subcategory_in_pr == '0') {
              i.is_view = false;
            }
            if (i.value == 'subcategory_name' && this.company_setup.visible_product_category_subcategory_in_pr == '1') {
              i.is_view = true;
            }
            if (i.value == 'subcategory_name' && this.company_setup.visible_product_category_subcategory_in_pr == '0') {
              i.is_view = false;
            }
            if (i.value == 'make') {
              if(this.is_pr_column_visible('is_make', false)){
                i.is_view = true;
              }else{
                i.is_view = false
              }
              i.display = this.getPrColumnName('is_make', 'Make');

            }
            if (i.value == 'model') {
              if(this.is_pr_column_visible('is_model', false)){
                i.is_view = true;
              }else{
                i.is_view = false
              }
              i.display = this.getPrColumnName('is_model', 'Model');

            }
            if (i.value == 'additional_field1') {
              if(this.is_pr_column_visible('additional_field1', false)){
                i.is_view = true;
              }else{
                i.is_view = false
              }
              i.display = this.getPrColumnName('additional_field1', 'Additional Field 1');

            }
            if (i.value == 'additional_field2') {
              if(this.is_pr_column_visible('additional_field2', false)){
                i.is_view = true;
              }else{
                i.is_view = false
              }
              i.display = this.getPrColumnName('additional_field2', 'Additional Field 2');

            }
            if (i.value == 'pr_product_no') {
              if(this.is_pr_column_visible('pr_product_no', false)){
                i.is_view = true;
              }else{
                i.is_view = false
              }
              i.display = this.getPrColumnName('pr_product_no', 'Product No');
            }
            if (i.value == 'pr_product_l') {
              if(this.is_pr_column_visible('pr_product_l', false)){
                i.is_view = true;
              }else{
                i.is_view = false
              }
              i.display = this.getPrColumnName('pr_product_l', 'Product L');
            }
            if (i.value == 'pr_product_b') {
              if(this.is_pr_column_visible('pr_product_b', false)){
                i.is_view = true;
              }else{
                i.is_view = false
              }
              i.display = this.getPrColumnName('pr_product_b', 'Product B');
            }
            if (i.value == 'pr_product_d') {
              if(this.is_pr_column_visible('pr_product_d', false)){
                i.is_view = true;
              }else{
                i.is_view = false
              }
              i.display = this.getPrColumnName('pr_product_d', 'Product D');
            }
          }
        }
        this.makeData();

        break;
      case 'irreport':

        this.commonVariableList.columnList = globalVariables.irVariableList.columnList;
        this.commonVariableList.items = this.tableDetails.data.ir_items ? this.tableDetails.data.ir_items : [];
        this.company_setup.is_catalog_id_visible = false;
        this.company_setup.ir_item_columnList = this.company_setup.ir_item_columnList ? this.company_setup.ir_item_columnList : []
        if (this.company_setup.ir_item_columnList.length > 0) {
          this.company_setup.is_catalog_id_visible = this.company_setup.ir_item_columnList.some((v) => { return v.id == 'catalog_id' && v.isVisible })
        }
        if(this.commonVariableList.items)
        {
          for(let x of this.commonVariableList.items)
          {
            x.lead_time = this.webService.convertNaN(parseFloat(this.webService.convertNaN(x.lead_time, this.company_setup.allowed_digits_after_decimal_for_boq)), this.company_setup.allowed_digits_after_decimal_for_boq) ?  this.webService.convertNaN(parseFloat(this.webService.convertNaN(x.lead_time, this.company_setup.allowed_digits_after_decimal_for_boq)), this.company_setup.allowed_digits_after_decimal_for_boq) : '0';
            x.current_stock =  this.webService.convertNaN(parseFloat(this.webService.convertNaN(x.current_stock, this.company_setup.allowed_digits_after_decimal_for_boq)), this.company_setup.allowed_digits_after_decimal_for_boq) ?  this.webService.convertNaN(parseFloat(this.webService.convertNaN(x.current_stock, this.company_setup.allowed_digits_after_decimal_for_boq)), this.company_setup.allowed_digits_after_decimal_for_boq) : '0';
            // x.ir_location = x.ir_location_noinit ? x.ir_location_noinit : '0';
            x.average_daily_consumption =  this.webService.convertNaN(parseFloat(this.webService.convertNaN(x.average_daily_consumption, this.company_setup.allowed_digits_after_decimal_for_boq)), this.company_setup.allowed_digits_after_decimal_for_boq) ?  this.webService.convertNaN(parseFloat(this.webService.convertNaN(x.average_daily_consumption, this.company_setup.allowed_digits_after_decimal_for_boq)), this.company_setup.allowed_digits_after_decimal_for_boq) : '0';
            x.inventory_in_hand =  this.webService.convertNaN(parseFloat(this.webService.convertNaN(x.inventory_in_hand, this.company_setup.allowed_digits_after_decimal_for_boq)), this.company_setup.allowed_digits_after_decimal_for_boq) ?  this.webService.convertNaN(parseFloat(this.webService.convertNaN(x.inventory_in_hand, this.company_setup.allowed_digits_after_decimal_for_boq)), this.company_setup.allowed_digits_after_decimal_for_boq) : '0';
            x.procured_days =  this.webService.convertNaN(parseFloat(this.webService.convertNaN(x.procured_days, this.company_setup.allowed_digits_after_decimal_for_boq)), this.company_setup.allowed_digits_after_decimal_for_boq) ?  this.webService.convertNaN(parseFloat(this.webService.convertNaN(x.procured_days, this.company_setup.allowed_digits_after_decimal_for_boq)), this.company_setup.allowed_digits_after_decimal_for_boq) : '0';
            x.moq =  this.webService.convertNaN(parseFloat(this.webService.convertNaN(x.moq, this.company_setup.allowed_digits_after_decimal_for_boq)), this.company_setup.allowed_digits_after_decimal_for_boq) ?  this.webService.convertNaN(parseFloat(this.webService.convertNaN(x.moq, this.company_setup.allowed_digits_after_decimal_for_boq)), this.company_setup.allowed_digits_after_decimal_for_boq) : '0';

            x.item_qty =  this.webService.convertNaN(parseFloat(this.webService.convertNaN(x.item_qty, this.company_setup.allowed_digits_after_decimal_for_boq)), this.company_setup.allowed_digits_after_decimal_for_boq) ?  this.webService.convertNaN(parseFloat(this.webService.convertNaN(x.item_qty, this.company_setup.allowed_digits_after_decimal_for_boq)), this.company_setup.allowed_digits_after_decimal_for_boq) : '0';

            x.product_qty =  this.webService.convertNaN(parseFloat(this.webService.convertNaN(x.product_qty, this.company_setup.allowed_digits_after_decimal_for_boq)), this.company_setup.allowed_digits_after_decimal_for_boq) ?  this.webService.convertNaN(parseFloat(this.webService.convertNaN(x.product_qty, this.company_setup.allowed_digits_after_decimal_for_boq)), this.company_setup.allowed_digits_after_decimal_for_boq) : '0';

          }
        }
        if (this.commonVariableList.columnList) {
          for (let i of this.commonVariableList.columnList) {
            if (i.value == 'product_catalog_id' && this.company_setup.is_catalog_id_visible && this.company_setup.product_catalog_id == '1') {
              i.is_view = true;
            }
            if (i.value == 'product_catalog_id' && (!this.company_setup.is_catalog_id_visible || this.company_setup.product_catalog_id == '0')) {
              i.is_view = false;
            }
            if (i.value == 'average_daily_consumption') {
              i.display = this.company_setup.average_consumption_frequency_name_in_ir;
            }
            if (i.value == 'unit_price' && (this.company_setup.is_pr_unit_price_visible == '0' ||this.company_setup.hide_product_unit_price_ir == '1') ) {
              i.is_view = false;
            }
            if (i.value == 'current_stock' && this.company_setup.is_current_stock_visible_in_ir == '1') {
              i.is_view = true;
            }

            if (i.value == 'average_daily_consumption' && this.company_setup.is_average_daily_consumption_visible_in_ir == '1') {
              i.is_view = true;
            }
            if (i.value == 'inventory_in_hand' && this.company_setup.is_inventory_in_hand_visible_in_ir == '1') {
              i.is_view = true;
            }
            if (i.value == 'inventory_in_hand') {
              i.display = this.company_setup.ir_inventory_in_hand_name;
            }
            if (i.value == 'procured_days') {
              i.display = this.company_setup.ir_procured_days_name;
            }
            if (i.value == 'lead_time' && this.company_setup.is_lead_time_visible_in_ir == '1') {
              i.is_view = true;
            }
            if (i.value == 'procured_days' && this.company_setup.is_procured_days_visible_in_ir == '1') {
              i.is_view = true;
            }

            if (i.value == 'moq' && this.company_setup.is_moq_visible_in_ir == '1') {
              i.is_view = true;
            }

          }
        }
        this.makeData();

        break;
      case 'ir_history_report':

        this.commonVariableList.columnList = globalVariables.irVariableList.columnList;
        this.commonVariableList.items = this.tableDetails.data.ir_items ? this.tableDetails.data.ir_items : [];
        this.company_setup.is_catalog_id_visible = false;
        this.company_setup.ir_item_columnList = this.company_setup.ir_item_columnList ? this.company_setup.ir_item_columnList : []
        if (this.company_setup.ir_item_columnList.length > 0) {
          this.company_setup.is_catalog_id_visible = this.company_setup.ir_item_columnList.some((v) => { return v.id == 'catalog_id' && v.isVisible })
        }
        if (this.commonVariableList.columnList) {
          for (let i of this.commonVariableList.columnList) {
            if (i.value == 'product_catalog_id' && this.company_setup.is_catalog_id_visible && this.company_setup.product_catalog_id == '1') {
              i.is_view = true;
            }
            if (i.value == 'product_catalog_id' && (!this.company_setup.is_catalog_id_visible || this.company_setup.product_catalog_id == '0')) {
              i.is_view = false;
            }
            if (i.value == 'average_daily_consumption') {
              i.display = this.company_setup.average_consumption_frequency_name_in_ir;
            }
            if (i.value == 'unit_price' && this.company_setup.is_pr_unit_price_visible == '0') {
              i.is_view = false;
            }
            if (i.value == 'current_stock' && this.company_setup.is_current_stock_visible_in_ir == '1') {
              i.is_view = true;
            }

            if (i.value == 'average_daily_consumption' && this.company_setup.is_average_daily_consumption_visible_in_ir == '1') {
              i.is_view = true;
            }
            if (i.value == 'inventory_in_hand' && this.company_setup.is_inventory_in_hand_visible_in_ir == '1') {
              i.is_view = true;
            }
            if (i.value == 'inventory_in_hand') {
              i.display = this.company_setup.ir_inventory_in_hand_name;
            }
            if (i.value == 'procured_days') {
              i.display = this.company_setup.ir_procured_days_name;
            }
            if (i.value == 'lead_time' && this.company_setup.is_lead_time_visible_in_ir == '1') {
              i.is_view = true;
            }
            if (i.value == 'procured_days' && this.company_setup.is_procured_days_visible_in_ir == '1') {
              i.is_view = true;
            }

            if (i.value == 'moq' && this.company_setup.is_moq_visible_in_ir == '1') {
              i.is_view = true;
            }

          }
        }
        this.makeData();

        break;

      case 'mprreport':

        this.commonVariableList.columnList = globalVariables.mprVariableList.columnList;
        this.commonVariableList.items = this.tableDetails.data.mpr_items ? this.tableDetails.data.mpr_items : [];
        if (this.commonVariableList.columnList) {
          for (let i of this.commonVariableList.columnList) {
            if (i.value == 'product_catalog_id' && this.company_setup.product_catalog_id == '1') {
              i.is_view = true;
            }
            if (i.value == 'product_catalog_id' && this.company_setup.product_catalog_id == '0') {
              i.is_view = false;
            }

            if (i.value == 'productcode' && this.company_setup.is_mpr_sku_visible == '0') {
              i.is_view = false;
            }
            if (i.value == 'productcode' && this.company_setup.is_mpr_sku_visible == '1') {
              i.is_view = true;
            }
            if (i.value == 'unit_type_name' && this.company_setup.is_mpr_unit_type_visible == '0') {
              i.is_view = false;
            }
            if (i.value == 'unit_type_name' && this.company_setup.is_mpr_unit_type_visible == '1') {
              i.is_view = true;
            }

            if (i.value == 'buffer_stock' && this.company_setup.is_mpr_buffer_stock_visible == '0') {
              i.is_view = false;
            }
            if (i.value == 'buffer_stock' && this.company_setup.is_mpr_buffer_stock_visible == '1') {
              i.is_view = true;
            }
            if (i.value == 'is_this_my_boq' && this.company_setup.is_mpr_my_boq_visible == '0') {
              i.is_view = false;
            }
            if (i.value == 'is_this_my_boq' && this.company_setup.is_mpr_my_boq_visible == '1') {
              i.is_view = true;
            }

          }
        }
        this.makeData();

        break;
      case 'stnreport':
        this.commonVariableList.columnList = globalVariables.stnVariableList.columnList;
        this.commonVariableList.items = this.tableDetails.data.product_details ? this.tableDetails.data.product_details : [];
        this.makeData();

        break;
      case 'proformainvoicereport':
        this.commonVariableList.columnList = globalVariables.proformainvoiceVariableList.columnList;
        this.commonVariableList.items = this.tableDetails.data.invoice_items ? this.tableDetails.data.invoice_items : [];
        this.makeData();
        break;

      case 'salesOrderData':
        this.commonVariableList.columnList = globalVariables.SalesOrderVariableList.columnList;
        this.commonVariableList.items = this.tableDetails.data.invoice_items ? this.tableDetails.data.invoice_items : [];
        if (this.commonVariableList.columnList) {
          for (let x of this.commonVariableList.columnList) {
            // if(x.value == 'hsn_code' && this.company_setup.sales_description_visible=='1'){
            //   x.is_view=true;
            // }

            if (x.value == 'account_name' && this.company_setup.sales_account_name_visible == '1') {
              x.is_view = true;
            }

            if (x.value == 'account_name' && this.company_setup.sales_account_name_visible == '0') {
              x.is_view = false;
            }

            if (x.value == 'hsn_code' && this.company_setup.sales_hsn_code_visible == '1') {
              x.is_view = true;
            }

            if (x.value == 'hsn_code' && this.company_setup.sales_hsn_code_visible == '0') {
              x.is_view = false;
            }

            if (x.value == 'invoice_cgst' && this.company_setup.sales_cgst_visible == '1') {
              x.is_view = true;
            }

            if (x.value == 'invoice_cgst' && this.company_setup.sales_cgst_visible == '0') {
              x.is_view = false;
            }

            if (x.value == 'invoice_sgst' && this.company_setup.sales_sgst_visible == '1') {
              x.is_view = true;
            }

            if (x.value == 'invoice_sgst' && this.company_setup.sales_sgst_visible == '0') {
              x.is_view = false;
            }

            if (x.value == 'invoice_igst' && this.company_setup.sales_igst_visible == '1') {
              x.is_view = true;
            }

            if (x.value == 'invoice_igst' && this.company_setup.sales_igst_visible == '0') {
              x.is_view = false;
            }

            if (x.value == 'invoice_ugst' && this.company_setup.sales_ugst_visible == '1') {
              x.is_view = true;
            }

            if (x.value == 'invoice_ugst' && this.company_setup.sales_ugst_visible == '0') {
              x.is_view = false;
            }

            if (x.value == 'invoice_cess' && this.company_setup.sales_cess_visible == '1') {
              x.is_view = true;
            }

            if (x.value == 'invoice_cess' && this.company_setup.sales_cess_visible == '0') {
              x.is_view = false;
            }
            if (x.value == 'invoice_other_tax' && this.company_setup.sales_other_tax_visible == '1') {
              x.is_view = true;
            }

            if (x.value == 'invoice_other_tax' && this.company_setup.sales_other_tax_visible == '0') {
              x.is_view = false;
            }

            if (x.value == 'invoice_tax' && this.company_setup.sales_gst_visible == '1') {
              x.is_view = true;
            }

            if (x.value == 'invoice_tax' && this.company_setup.sales_gst_visible == '0') {
              x.is_view = false;
            }



          }
        }
        this.makeData();
        break;
        case 'salesinvoicereport':
          this.commonVariableList.columnList = globalVariables.salesinvoiceVariableList.columnList;
          this.commonVariableList.items = this.tableDetails.data.invoice_items ? this.tableDetails.data.invoice_items : [];

          if (this.commonVariableList.columnList) {
            for (let x of this.commonVariableList.columnList) {
                if(x.value=='account_name' && this.company_setup.is_account_code_visible_in_sales_invoice=='1')
                {
                  x.is_view = true;

                }
                if(x.value=='account_name'&& this.company_setup.is_account_code_visible_in_sales_invoice=='0')
                {
                  x.is_view = false;

                }

                if(x.value=='inventory_unit_price' && this.company_setup.is_sales_invoice_price_visible=='1')
                {
                  x.is_view = true;

                }
                if(x.value=='inventory_unit_price'&& this.company_setup.is_sales_invoice_price_visible=='0')
                {
                  x.is_view = false;

                }


              if (x.value == 'conversion_unit_price' && this.tableDetails.data.is_different_document_currency == '0') {
                x.display = "FC Unit Price"
                x.is_view = false;
              }
              if (x.value == 'conversion_unit_price' && this.tableDetails.data.is_different_document_currency == '1') {
                x.display = "FC Unit Price" + "(" + this.tableDetails.data.currency_code + ")";
                x.is_view = true;
              }


              if (x.value == 'available_stock' && this.company_setup.in_sales_invoice_is_available_stock_visible == '1') {
                x.is_view = true;
              }

              if (x.value == 'available_stock' && this.company_setup.in_sales_invoice_is_available_stock_visible == '0') {
                x.is_view = false;
              }





            }
          }
          this.makeData();

          break;
      case 'invoicepaymentreport':
        this.commonVariableList.columnList = globalVariables.invoicePaymentVariableList.columnList;
        this.commonVariableList.items = this.tableDetails.data.payment_details ? this.tableDetails.data.payment_details : [];
        this.company_setup.is_invoice_Payments_retention_amount = this.company_setup.is_invoice_Payments_retention_amount ? this.company_setup.is_invoice_Payments_retention_amount : '0';
        this.company_setup.is_invoice_Payments_volume_discount = this.company_setup.is_invoice_Payments_volume_discount ? this.company_setup.is_invoice_Payments_volume_discount : '0';
        this.company_setup.is_invoice_Payments_cash_discount = this.company_setup.is_invoice_Payments_cash_discount ? this.company_setup.is_invoice_Payments_cash_discount : '0';
        this.company_setup.is_invoice_Payments_current_payable = this.company_setup.is_invoice_Payments_current_payable ? this.company_setup.is_invoice_Payments_current_payable : '0';
        this.company_setup.remarks_visible_in_part_payment=this.company_setup.remarks_visible_in_part_payment ? this.company_setup.remarks_visible_in_part_payment :'0';
        this.company_setup.in_inv_payment_upload_at_row_level_visible=this.company_setup.in_inv_payment_upload_at_row_level_visible ? this.company_setup.in_inv_payment_upload_at_row_level_visible :'0';
        this.company_setup.invoice_additional_column_list = this.company_setup.invoice_additional_column_list ? this.company_setup.invoice_additional_column_list : [];

        this.company_setup.debit_note_amount = (this.company_setup.invoice_additional_column_list && this.company_setup.invoice_additional_column_list.length > 0) ? this.company_setup.invoice_additional_column_list.filter(v => v.key == 'debit_note_amount')[0] : {'text':'','is_visible_in_pyament_module':false,'custom_name':''};
        this.company_setup.debit_note_number =(this.company_setup.invoice_additional_column_list && this.company_setup.invoice_additional_column_list.length > 0)  ? this.company_setup.invoice_additional_column_list.filter(v => v.key == 'debit_note_number')[0] : {'text':'','is_visible_in_pyament_module':false,'custom_name':''};

       if(this.commonVariableList.items)
       {
         for(let i of this.commonVariableList.items)
         {
          //  console.log(i);
           i.dc_list=i.dc_list?i.dc_list:[]
           i.attachments=i.attachments?i.attachments:[]
          i.attachments=this.webService.makeAttachment(i.attachments);
          i.attachment=i.attachments?i.attachments:[];
          
           if(i.dc_list.length<=0)
           {
            if(i.debit_no!=undefined && i.debit_no!='' && i.debit_no!=null)
            {
              i.dc_list.push({id:i.debit_no?i.debit_no:'',no:i.debit_no?i.debit_no:'',amount:i.debit_note_amount?i.debit_note_amount:''})
            }
           }
          //  console.log(i.dc_list);

         }
       }
        let is_debit:boolean=this.commonVariableList.items.some((v)=>{return parseFloat(this.webService.convertNaN(v.debit_note_amount))>0})
        if (this.commonVariableList.columnList) {
          for (let i of this.commonVariableList.columnList) {
            if (i.value == 'total_balance_amount' && this.company_setup.is_invoice_Payments_retention_amount == '1') {
              i.is_view = true;
            }
            if (i.value == 'total_balance_amount' && this.company_setup.is_invoice_Payments_retention_amount == '0') {
              i.is_view = false;
            }

            if (i.value == 'cash_discount_amount' && this.company_setup.is_invoice_Payments_cash_discount == '1') {
              i.is_view = true;
            }
            if (i.value == 'cash_discount_amount' && this.company_setup.is_invoice_Payments_cash_discount == '0') {
              i.is_view = false;
            }

            if (i.value == 'attachments' && this.company_setup.in_inv_payment_upload_at_row_level_visible == '1') {
              i.is_view = true;
            }
            if (i.value == 'attachments' && this.company_setup.in_inv_payment_upload_at_row_level_visible == '0') {
              i.is_view = false;
            }

            if (i.value == 'volume_discount_amount' && this.company_setup.is_invoice_Payments_volume_discount == '1') {
              i.is_view = true;
            }
            if (i.value == 'volume_discount_amount' && this.company_setup.is_invoice_Payments_volume_discount == '0') {
              i.is_view = false;
            }

            if (i.value == 'gst_deduction_amount' && this.company_setup.is_invoice_Payments_gst_deduction_visible == '1') {
              i.is_view = true;
            }
            if (i.value == 'gst_deduction_amount' && this.company_setup.is_invoice_Payments_gst_deduction_visible == '0') {
              i.is_view = false;
            }
            if (i.value == 'gst_deduction_amount') {
              i.display = this.company_setup.in_invoice_custom_gst_deduction_amount_name;
            }

            if (i.value == 'dc_list' && is_debit && this.company_setup.debit_note_number.is_visible_in_pyament_module ) {
              i.is_view = true;
            }
            if (i.value == 'dc_list' && !is_debit && this.company_setup.debit_note_number.is_visible_in_pyament_module ) {
              i.is_view = false;
            }
            if (i.value == 'debit_note_amount' && is_debit && this.company_setup.debit_note_amount.is_visible_in_pyament_module )  {
              i.is_view = true;
            }
            if (i.value == 'debit_note_amount' && !is_debit && this.company_setup.debit_note_amount.is_visible_in_pyament_module ) {
              i.is_view = false;
            }
            if (i.value == 'other_payment_deduction') {
              if( this.company_setup.other_payment_deduction == '1'){
                i.is_view = true;
              }else{
                i.is_view = false;
              }
            }
            if (i.value == 'dc_list') {
              i.display = this.getColumnName(
                  this.company_setup.invoice_additional_column_list,
                  'dc_list',
                  this.company_setup.debit_note_number .custom_name 
                      ? this.company_setup.debit_note_number.custom_name 
                      : i.display
              );
            }
            if (i.value == 'debit_note_amount') {
              i.display = this.getColumnName(
                  this.company_setup.invoice_additional_column_list,
                  'debit_note_amount',
                  this.company_setup.debit_note_amount.custom_name 
                      ? this.company_setup.debit_note_amount.custom_name 
                      : i.display
              );
            }
          }
        }
        this.makeData();

        break;
        case 'adhocpaymentreport':
          this.commonVariableList.columnList = []
          this.commonVariableList.items =[]
          console.log(this.tableDetails)
          this.je_tableForAdvance = this.tableDetails.data.je_table ? this.tableDetails.data.je_table : []
          if (this.je_tableForAdvance) {
            for (let i of this.je_tableForAdvance) {
              i.jeDetails = i.jeDetails ? i.jeDetails : []
            }
          }
          this.makeData();

          break;
      case 'invoicepartpaymentreport':
        this.commonVariableList.columnList = globalVariables.invoicePartPaymentVariableList.columnList;
        this.commonVariableList.items = this.tableDetails.data.payment_history  ? this.tableDetails.data.payment_history  : [];
        if(this.commonVariableList.items)
       {
         for(let i of this.commonVariableList.items)
         {
           i.dc_list=i.dc_list?i.dc_list:[]
           if(i.dc_list.length<=0)
           {
            if(i.debit_no!=undefined && i.debit_no!='' && i.debit_no!=null)
            {
              i.dc_list.push({id:i.debit_no?i.debit_no:'',no:i.debit_no?i.debit_no:'',amount:i.debit_note_amount?i.debit_note_amount:''})
            }
           }
           console.log(i.dc_list);

         }
       }
       let is_debit_note:boolean=this.commonVariableList.items.some((v)=>{return parseFloat(this.webService.convertNaN(v.debit_note_amount))>0})

        //console.log(this.commonVariableList.items)
        if (this.commonVariableList.columnList) {
          for (let i of this.commonVariableList.columnList) {
            if (i.value == 'total_balance_amount' && this.company_setup.is_invoice_Payments_retention_amount == '1') {
              i.is_view = true;
            }
            if (i.value == 'total_balance_amount' && this.company_setup.is_invoice_Payments_retention_amount == '0') {
              i.is_view = false;
            }

            if (i.value == 'cash_discount_amount' && this.company_setup.is_invoice_Payments_cash_discount == '1') {
              i.is_view = true;
            }
            if (i.value == 'cash_discount_amount' && this.company_setup.is_invoice_Payments_cash_discount == '0') {
              i.is_view = false;
            }

            if (i.value == 'volume_discount_amount' && this.company_setup.is_invoice_Payments_volume_discount == '1') {
              i.is_view = true;
            }
            if (i.value == 'volume_discount_amount' && this.company_setup.is_invoice_Payments_volume_discount == '0') {
              i.is_view = false;
            }

            if (i.value == 'current_payable_amount' && this.company_setup.is_invoice_Payments_current_payable == '1') {
              i.is_view = true;
            }
            if (i.value == 'current_payable_amount' && this.company_setup.is_invoice_Payments_current_payable == '0') {
              i.is_view = false;
            }

            if (i.value == 'current_paid_amount' && this.company_setup.is_invoice_Payments_current_payable == '1') {
              i.is_view = true;
            }
            if (i.value == 'current_paid_amount' && this.company_setup.is_invoice_Payments_current_payable == '0') {
              i.is_view = false;
            }
            if (i.value == 'remarks' && this.company_setup.remarks_visible_in_part_payment == '1') {
              i.is_view = true;
            }
            if (i.value == 'remarks' && this.company_setup.remarks_visible_in_part_payment == '0') {
              i.is_view = false;
            }
            if (i.value == 'dc_list' && is_debit_note) {
              i.is_view = true;
            }
            if (i.value == 'dc_list' && !is_debit_note) {
              i.is_view = false;
            }

            if (i.value == 'debit_note_amount' && is_debit_note) {
              i.is_view = true;
            }
            if (i.value == 'debit_note_amount' && !is_debit_note) {
              i.is_view = false;
            }
       
          }
        }
        this.makeData();

        break;
      case 'invoiceretentionpaymentreport':
        this.commonVariableList.columnList = globalVariables.invoiceRetentionPaymentVariableList.columnList;
        this.commonVariableList.items = this.tableDetails.data.payment_details ? this.tableDetails.data.payment_details : [];
        if (this.commonVariableList.columnList) {
          for (let i of this.commonVariableList.columnList) {
            if (i.value == 'total_balance_amount' && this.company_setup.is_invoice_Payments_retention_amount == '1') {
              i.is_view = true;
            }
            if (i.value == 'total_balance_amount' && this.company_setup.is_invoice_Payments_retention_amount == '0') {
              i.is_view = false;
            }

            if (i.value == 'cash_discount_amount' && this.company_setup.is_invoice_Payments_cash_discount == '1') {
              i.is_view = true;
            }
            if (i.value == 'cash_discount_amount' && this.company_setup.is_invoice_Payments_cash_discount == '0') {
              i.is_view = false;
            }

            if (i.value == 'volume_discount_amount' && this.company_setup.is_invoice_Payments_volume_discount == '1') {
              i.is_view = true;
            }
            if (i.value == 'volume_discount_amount' && this.company_setup.is_invoice_Payments_volume_discount == '0') {
              i.is_view = false;
            }

            if (i.value == 'current_payable_amount' && this.company_setup.is_invoice_Payments_current_payable == '1') {
              i.is_view = true;
            }
            if (i.value == 'current_payable_amount' && this.company_setup.is_invoice_Payments_current_payable == '0') {
              i.is_view = false;
            }
          }
        }
        this.makeData();

        break;
      case 'popaymentreport':
        this.commonVariableList.columnList = globalVariables.poPaymentVariableList.columnList;
        this.commonVariableList.items = this.tableDetails.data.payment_details ? this.tableDetails.data.payment_details : [];
        this.makeData();
      case 'my_advance_report':
        this.commonVariableList.columnList = globalVariables.myAdvancePaymentVariableList.columnList;
        this.commonVariableList.items = this.tableDetails.data.items ? this.tableDetails.data.items : [];
        this.makeData();

        break;
      case 'employee_advance_payment_report':
        this.commonVariableList.columnList = globalVariables.employeeAdvancePaymentVariableList.columnList;
        this.commonVariableList.items = this.tableDetails.data.items ? this.tableDetails.data.items : [];
        this.makeData();

        break;
      case 'rfqNumberReport':
        this.showRfqData("rfq");
        break;

      case 'rfqResponseReport':
        this.showRfqData("rfq_response");
        break;

      case 'productmaster':
        this.commonVariableList.columnList = [];
        this.commonVariableList.items = this.tableDetails.data && this.tableDetails.data.items ? this.tableDetails.data.items : [];
        break;

      default:
        this.toasterService.pop('error', "Error", "Wrong Data For item table");
    }
  }


  colspan: any = '0';
  makeData() {
    if (this.commonVariableList.items) {
      let sl_no: number = 1;
      for (let i of this.commonVariableList.items) {
        i.sl_no = sl_no;
        i.is_highlighted_row=i.is_highlighted_row?i.is_highlighted_row:false;
        sl_no++;
      }
    }

    if (this.commonVariableList.columnList) {
      let sl_no: number = 1;
      for (let i of this.commonVariableList.columnList) {
        // i.sl_no=sl_no;

        i.tr_class = "";
        i.td_class = "";
        if (i.value == 'sl_no') {
          i.tr_class = i.tr_class + "action_tdfirst_sticky fixed_th col-s-no testing_th_" + i.value
          i.td_class = i.td_class + "action_tdfirst_sticky col-s-no testing_td_" + i.value
        }
        else if (i.value == 'product_name') {
          i.tr_class = i.tr_class + "action_tdsecond_sticky fixed_th testing_th_" + i.value
          i.td_class = i.td_class + "action_tdsecond_sticky testing_td_" + i.value
        }
        else if (i.value == 'remarks') {
          i.tr_class = i.tr_class + "remarks testing_th_" + i.value
          i.td_class = i.td_class + "remarks testing_td_" + i.value
        }
        else {
          i.tr_class = "testing_th_" + i.value
          i.td_class = "testing_td_" + i.value
        }

        i.index = i.index ? i.index : '';
        i.currency = i.currency ? i.currency : '';

        i.tr_class = i.tr_class + " testing_th_index_" + sl_no;
        i.td_class = i.td_class + " testing_td_index_" + sl_no+' span_ansr';
        sl_no++;
      }
    }
    this.isProgressing = false;
    // this.colspan='0'
    // this.colspan=Object.keys(this.commonVariableList.columnList[0]).length?Object.keys(this.commonVariableList.columnList[0]).length:'0'
  }

  makeData_one() {
    if (this.commonVariableList.items) {
      let sl_no: number = 1;
      for (let i of this.commonVariableList.items) {
        i.sl_no = sl_no;
        i.is_highlighted_row=i.is_highlighted_row?i.is_highlighted_row:false;
        sl_no++;
      }
    }

    if (this.commonVariableList.columnList) {
      let sl_no: number = 1;
      for (let i of this.commonVariableList.columnList) {
        // i.sl_no=sl_no;

        i.tr_class = "";
        i.td_class = "";
        if (i.value == 'sl_no') {
          i.tr_class = i.tr_class + "action_tdfirst_sticky fixed_th testing_th_" + i.value
          i.td_class = i.td_class + "action_tdfirst_sticky testing_td_" + i.value
        }
        else if (i.value == 'product_name') {
          i.tr_class = i.tr_class + "action_tdsecond_sticky fixed_th testing_th_" + i.value
          i.td_class = i.td_class + "action_tdsecond_sticky testing_td_" + i.value
        }
        else if (i.value == 'ship_to_location') {
          i.tr_class = i.tr_class + "action_tdthree_sticky fixed_th testing_th_" + i.value
          i.td_class = i.td_class + "action_tdthree_sticky testing_td_" + i.value
        }
        else if (i.value == 'product_type') {
          i.tr_class = i.tr_class + "action_tdfour_sticky fixed_th testing_th_" + i.value
          i.td_class = i.td_class + "action_tdfour_sticky testing_td_" + i.value
        }
        else if (i.value == 'unit_type_name') {
          i.tr_class = i.tr_class + "action_tdfive_sticky fixed_th testing_th_" + i.value
          i.td_class = i.td_class + "action_tdfive_sticky testing_td_" + i.value
        }
        else if (i.value == 'remarks') {
          i.tr_class = i.tr_class + "remarks testing_th_" + i.value
          i.td_class = i.td_class + "remarks testing_td_" + i.value
        }
        else {
          i.tr_class = "testing_th_" + i.value
          i.td_class = "testing_td_" + i.value
        }

        i.tr_class = i.tr_class + " testing_th_index_" + sl_no;
        i.td_class = i.td_class + " testing_td_index_" + sl_no+' span_ansr';
        sl_no++;
      }
    }
    this.isProgressing = false;
    this.stillLoading = false;
    // this.colspan='0'
    // this.colspan=Object.keys(this.commonVariableList.columnList[0]).length?Object.keys(this.commonVariableList.columnList[0]).length:'0'
  }

  eventAction(data, data2) {
    let payload: any = {};
    let url: any = '';
    switch (data.value) {
      case 'qrcode_file_url':
        payload.product_id = [data2.product_id];
        payload.grn_id = data2.grn_id ? data2.grn_id : data2.id;
        payload.has_approved_once=this.tableDetails.data.has_approved_once?this.tableDetails.data.has_approved_once:''
        payload.irn_id=this.tableDetails.data.irn_id?this.tableDetails.data.irn_id:''
        payload.start = '';
        payload.limit = '';
        url = data.event.url;
        break;
      case 'barcode_file_url':
        payload.product_id = [data2.product_id];
        payload.grn_id = data2.grn_id ? data2.grn_id : data2.id;
        payload.has_approved_once=this.tableDetails.data.has_approved_once?this.tableDetails.data.has_approved_once:''
        payload.irn_id=this.tableDetails.data.irn_id?this.tableDetails.data.irn_id:''
        payload.start = '';
        payload.limit = '';
        url = data.event.url;
        break;
      default:
        payload = {};
        url = '';
    }
    this.downLoadFile(url, payload)

  }
  downLoadFile(url, payload) {
    if (url == undefined || url == '') {
      return;
    }

    this.webService.commonPostMethod(url, payload).subscribe(
      data => {
        if (data.status) {
          // window.location.href = data.file_path;
          // window.open(data.file_path, '_blank')
          if(data.file_path==''||data.file_path==null||data.file_path==undefined)
          {
            this.toasterService.pop("error", "Error",(data.message?data.message:'Data not found'));

          }
          else
          {
            window.open(data.file_path, '_blank')

          }
        } else {
          this.toasterService.pop("error", "Error", data.message);
        }
      },
      error => {
        this.toasterService.pop("error", "Error", "Something went wrong")
      })
  }
  getColumnName(arraydata,key, default_data) {
    if (key == '' || key == undefined) {
      return default_data ? default_data : '-';
    }
    if (arraydata.length == undefined || arraydata.length <= 0) {
      return default_data ? default_data : '-';

    }
    let temp: any = [];
    temp = arraydata.filter((v) => { return v.key == key });
    if (temp.length == undefined || temp.length <= 0) {
      return default_data ? default_data : '-';
    }
    return temp[0].custom_name ? temp[0].custom_name : '-'
  }
  is_column_visible(arraydata,key, default_data) {
    if (key == '' || key == undefined) {
      return default_data ? default_data : false;
    }

    if (arraydata.length == undefined || arraydata.length <= 0) {
      return default_data ? default_data : false;

    }
    let temp: any = [];
    temp = arraydata.filter((v) => { return v.key == key });
    if (temp.length == undefined || temp.length <= 0) {
      return default_data ? default_data : false;
    }
    return temp[0].is_visible ? temp[0].is_visible : false
  }

  getPrColumnName(key, default_data) {
    if (key == '' || key == undefined) {
      return default_data ? default_data : '-';
    }
    if (this.company_setup.select_pr_list.length == undefined || this.company_setup.select_pr_list.length <= 0) {
      return default_data ? default_data : '-';

    }
    let temp: any = [];

    temp = this.company_setup.select_pr_list[0].columns.filter((v) => { return v.key == key });

    if (temp.length == undefined || temp.length <= 0) {
      return default_data ? default_data : '-';
    }
    return temp[0].custom_name ? temp[0].custom_name : '-'
  }
  is_pr_column_visible(key, default_data) {
    if (key == '' || key == undefined) {
      return default_data ? default_data : false;
    }
    // if (!this.companySelectionDisabled) {
    //   return true;
    // }
    if (this.company_setup.select_pr_list.length == undefined || this.company_setup.select_pr_list.length <= 0) {
      return default_data ? default_data : false;

    }

    let temp: any = [];
    temp = this.company_setup.select_pr_list[0].columns.filter((v) => { return v.key == key });
    if (temp.length == undefined || temp.length <= 0) {
      return default_data ? default_data : false;
    }
    return temp[0].is_visible ? temp[0].is_visible : false
  }
  is_pr_column_mandatory(key, default_data) {
    if (key == '' || key == undefined) {
      return default_data ? default_data : false;
    }

    if (this.company_setup.select_pr_list.length == undefined || this.company_setup.select_pr_list.length <= 0) {
      return default_data ? default_data : false;

    }
    let temp: any = [];
    temp = this.company_setup.select_pr_list[0].columns.filter((v) => { return v.key == key });
    if (temp.length == undefined || temp.length <= 0) {
      return default_data ? default_data : false;
    }
    return temp[0].is_mandatory ? temp[0].is_mandatory : false
  }

  currencyList:any=[];
  private static sharedCurrencyListCache: any[] = null;
  private static currencyListeners: GenericTableComponent[] = [];
  private static currencyFetching = false;
  private static lastInvoiceApprovalClickNonce: any = null;
  getCurrencyList() {

    if (this.currencyList.length > 0) {
      return;
    }
    if (this.tableDetails && this.tableDetails.invoiceApprovalClickNonce != undefined && GenericTableComponent.lastInvoiceApprovalClickNonce != this.tableDetails.invoiceApprovalClickNonce) { GenericTableComponent.lastInvoiceApprovalClickNonce = this.tableDetails.invoiceApprovalClickNonce; GenericTableComponent.sharedCurrencyListCache = null; GenericTableComponent.currencyFetching = false; GenericTableComponent.currencyListeners = []; }
    if (GenericTableComponent.sharedCurrencyListCache != null) {
      this.currencyList = GenericTableComponent.sharedCurrencyListCache.slice();
      if (this.setup.is_setup) { 
        this.setSetupData(this.setup); 
      } else { 
        this.GetCompanySetUpData(); 
      }
      return;
    }
    GenericTableComponent.currencyListeners.push(this);
    if (GenericTableComponent.currencyFetching) { return; }
    GenericTableComponent.currencyFetching = true;
    let requestObj = {

    }
    this.webService.commonPostMethod("Account_master/ajax_getallcurrencies", requestObj).
      subscribe(
        data => {
          GenericTableComponent.currencyFetching = false;
          if (data.status) {
            this.currencyList = data.currencies;
            if (this.currencyList) {
              for (let i of this.currencyList) {
                i.name = i.name + "(" + i.code + ")";
              }
            }
            GenericTableComponent.sharedCurrencyListCache = this.currencyList ? this.currencyList.slice() : [];
          }
          else {
            this.toasterService.pop("error", "Error", data.message);
          }
          let batch = GenericTableComponent.currencyListeners.splice(0);
          for (let cmp of batch) {
            cmp.currencyList = GenericTableComponent.sharedCurrencyListCache != null ? GenericTableComponent.sharedCurrencyListCache.slice() : [];
            if (cmp.setup.is_setup) { cmp.setSetupData(cmp.setup); } else { cmp.GetCompanySetUpData(); }
          }
        },
        error => {
          GenericTableComponent.currencyFetching = false;
          this.toasterService.pop("error", "Error", "Something Went Wrong");
          let batch = GenericTableComponent.currencyListeners.splice(0);
          for (let cmp of batch) {
            if (cmp.setup.is_setup) { cmp.setSetupData(cmp.setup); } else { cmp.GetCompanySetUpData(); }
          }
        }
      );


  }
  setDDCCode(id) {
    let temp: any = [];
    temp = this.currencyList.filter((v) => { return v.id == id });
    return temp[0].code ? temp[0].code : '';
  }
  IsJeVisible(key)
{ return  this.company_setup.invoiceJESettings.length>0?(this.company_setup.invoiceJESettings.some((v)=>{return v.key==key && v.is_visible})):false;
}
getJEName(key)
{ return  this.company_setup.invoiceJESettings.length>0?(this.company_setup.invoiceJESettings.some((v)=>{return v.key==key})?this.company_setup.invoiceJESettings.filter((v)=>{return v.key==key})[0].custom_name:''):''
}
showModal(row,tempData,report_id)
{
 switch(report_id)
 {
 case 'dcnotereport':
   this.showDCNote(tempData);
   break;
   case 'invoicereport':
    this.showInvoice(tempData);
    break;
  case 'productmaster': {
    const d: any = tempData;
    const productId = d && (d.item_id ? d.item_id : (d.product_id ? d.product_id : (d.product && d.product.product_id ? d.product.product_id : '')));
    const costCenterId = d && (d.delivery_cc ? d.delivery_cc : (d.cost_center_id ? d.cost_center_id : (this.tableDetails.data && this.tableDetails.data.pr_location ? this.tableDetails.data.pr_location : '')));
    if (!productId) { break; }
    this.commonVariableList.modalDetails = {
      id: 'productmaster',
      name: 'Product Master Details',
      is_view: true,
      is_cwip: false,
      data: { product_id: productId, cost_center_id: costCenterId ? costCenterId : '' }
    };
    break;
  }
   default:
     this.toasterService.pop('info','Info','Details not found');
 }
}
  openProductMasterFromTable(d: any) {
    if (!d) { return; }
    const productId = d.item_id ? d.item_id : (d.product_id ? d.product_id : (d.product && d.product.product_id ? d.product.product_id : ''));
    const costCenterId = d.delivery_cc ? d.delivery_cc : (d.cost_center_id ? d.cost_center_id : (this.tableDetails.data && this.tableDetails.data.pr_location ? this.tableDetails.data.pr_location : ''));
    if (!productId) { return; }
    this.commonVariableList.modalDetails = {
      id: 'productmaster',
      name: 'Product Master Details',
      is_view: true,
      is_cwip: false,
      data: { product_id: productId, cost_center_id: costCenterId ? costCenterId : '' }
    };
  }

  viewRow(evt: any) {
    if (evt && evt.action === 'close') {
      this.commonVariableList.modalDetails.is_view = false;
    }
  }

showDCNote(d)
  {
    this.commonVariableList.modalDetails = { "data": { "id": d?d:'' ,'is_this_invoice_no':0}, "id": "dcnotereport", "name": 'D/C Details', "Desscription": 'PO', "is_view": true };
    this.commonVariableList.modalDetails.is_view = true;
  }
  showInvoice(d)
  {
    this.commonVariableList.modalDetails = { "data": { "id": d.actual_invoice_id?d.actual_invoice_id:'','is_this_invoice_no':0}, "id": "invoicereport", "name": 'D/C Details', "Desscription": 'PO', "is_view": true };
    this.commonVariableList.modalDetails.is_view = true;
  }
  current_index:number=0
  Enquery_showIssue(flag: boolean,index?:number) {
    if (flag) {
      this.current_index=index
      document.getElementById("Enquery_IssueSidenav").style.width = "70%";
      document.getElementById("Enquery_showIssueModel").style.display = "block";
      document.body.style.backgroundColor = "rgba(0,0,0,0.4)";
    } else {
      document.getElementById("Enquery_IssueSidenav").style.width = "0";
      document.getElementById("Enquery_showIssueModel").style.display = "none";
      document.body.style.backgroundColor = "#f0f0f1";
    }
  }
  getColumnNameQuotationManagement(key, default_data) {
    if (key == '' || key == undefined) {
      return default_data ? default_data : '-';
    }
    if (this.company_setup.quotation_management_master_column_list.length == undefined || this.company_setup.quotation_management_master_column_list.length <= 0) {
      return default_data ? default_data : '-';

    }
    let temp: any = [];
    temp = this.company_setup.quotation_management_master_column_list.filter((v) => { return v.key == key });
    if (temp.length == undefined || temp.length <= 0) {
      return default_data ? default_data : '-';
    }
    return temp[0].custom_name ? temp[0].custom_name : '-'
  }

  is_QuotationManagement_column_visible(key, default_data) {
    if (key == '' || key == undefined) {
      return default_data ? default_data : false;
    }
    if (this.company_setup.quotation_management_master_column_list.length == undefined || this.company_setup.quotation_management_master_column_list.length <= 0) {
      return default_data ? default_data : false;

    }

    let temp: any = [];
    temp = this.company_setup.quotation_management_master_column_list.filter((v) => { return v.key == key });
    if (temp.length == undefined || temp.length <= 0) {
      return default_data ? default_data : false;
    }
    return temp[0].is_visible ? temp[0].is_visible : false
  }

  itemList : any = [];
  rfqdata : any = {
    "reason": '',
    "currency_code": '',
    "annual_budget_amount": '',
    "budget_consumed_till_date": '',
    "current_amount_rfq": '',
    "balance_budget": '',
  }
  showRfqData(type) {
    this.commonVariableList.columnList = globalVariables.rfqVariableList.columnList;
    this.commonVariableList.items = this.tableDetails.data.vendor_items ? this.tableDetails.data.vendor_items : [];
    let data = this.tableDetails.data;

    let level_list = [];
    this.itemList = this.commonVariableList.items;
    let ship_to_location = this.tableDetails.data.ship_to_location ? this.tableDetails.data.ship_to_location : "";

    if(type=="rfq_response") {
      this.rfqdata = {
        "reason": this.tableDetails.data.reason,
        "currency_code": this.tableDetails.data.currency_code!='' ? this.tableDetails.data.currency_code: this.company_setup.default_currency_code,
        "annual_budget_amount": this.tableDetails.data.cost_center_budget_details_obj.annual_budget_amount,
        "budget_consumed_till_date": this.tableDetails.data.cost_center_budget_details_obj.budget_consumed_till_date,
        "current_amount_rfq": this.tableDetails.data.cost_center_budget_details_obj.current_amount_rfq,
        "balance_budget": this.tableDetails.data.cost_center_budget_details_obj.balance_budget,
      }
    }
    if(this.commonVariableList.items) {
      let level_index: number = 1;
      let auction_value = this.tableDetails.data.auction_value && this.tableDetails.data.auction_value == '1' ? true : false;

      let selected_vendor_price = 0;
      this.itemList.forEach((i)=>{
        i.selected_vendor_price = i.selected_vendor_price ? i.selected_vendor_price : 0;
        i.selected_vendor_price = parseFloat(i.selected_vendor_unit_price) * parseFloat(i.qty)
        i.selected_vendor_price = this.webService.convertNaN(i.selected_vendor_price)
        selected_vendor_price = selected_vendor_price + parseFloat(i.selected_vendor_price)
        selected_vendor_price = this.webService.convertNaN(parseFloat(this.webService.convertNaN(selected_vendor_price)));
      });

      for(let i of this.commonVariableList.items) {
        i.company_item_attachments = i.company_item_attachments ? i.company_item_attachments : []
        i.attachment = [];
        i.attachment = this.webService.makeAttachment(i.company_item_attachments)
        i.po_price_list = i.po_price_list ? i.po_price_list : [];

        if(type=="rfq_response") {
          // START
          i.item_list_saved_by_vendor = i.item_list_saved_by_vendor ? i.item_list_saved_by_vendor : []
          if (i.item_list_saved_by_vendor) {
            for (let x of i.item_list_saved_by_vendor) {
              x.level = x.gst_amount;
              x.name = x.vendor_name + " (" + x.vendor_code + ")";
              i.total_vendor_price = parseFloat(i.total_vendor_price) + parseFloat(x.gst_amount)
            }
          }
          if (i.item_list_saved_by_vendor.length > 0) {
            if (!auction_value) {
              i.item_list_saved_by_vendor.sort((a, b) => parseFloat(a.gst_amount) - parseFloat(b.gst_amount));
            } else {
              i.item_list_saved_by_vendor.sort((a, b) => parseFloat(b.gst_amount) - parseFloat(a.gst_amount));
            }
          }
  
          if (i.item_list_saved_by_vendor) {
            let index: number = 1;
            for (let x of i.item_list_saved_by_vendor) {
              x.level = "L" + level_index;
              x.total_vendor_price = i.total_vendor_price ? i.total_vendor_price : '0';
              level_list.push(x);
              index++;
            }
          }

          if (level_list) {
            for (let i of level_list) {
              i.total = this.getTotalByVendorId(i.vendor_id, this.commonVariableList.items);
              i.level = i.total;
            }
          }
          if (level_list.length > 0) {
            if (!auction_value) {
              level_list.sort((a, b) => parseFloat(a.level) - parseFloat(b.level));
            } else {
              level_list.sort((a, b) => parseFloat(b.level) - parseFloat(a.level));
            }
          }
          level_list = this.webService.removeDuplicates(level_list, 'vendor_id');
          
          if (level_list) {
            let index: number = 1;
            for (let i of level_list) {
              i.level = "L" + index;
              index++;
            }
          }
      
          if (this.itemList) {
            let level_index1: number = 0;
            for (let i of this.itemList) {
      
              if (i.item_list_saved_by_vendor) {
                let sublevel: number = 0;
                for (let j of i.item_list_saved_by_vendor) {
                  let te: any = {}
                  te = level_list[sublevel] ? level_list[sublevel] : {};
                  let te_d: any = {}
                  if(Object.keys(te).length>0)
                  {
                    if (i.item_list_saved_by_vendor.some((v) => { return te.vendor_id == v.vendor_id && v.item_id == j.item_id })) {
                      te_d = i.item_list_saved_by_vendor.filter((v) => { return te.vendor_id == v.vendor_id && v.item_id == j.item_id })[0];
                    }
                  }

                  sublevel++;
                }
              }
              level_index1++;
            }
          }

          if (this.itemList) {
            for (let i of this.itemList) {
              if (i.item_list_saved_by_vendor) {
                if (!auction_value) {
                  i.item_list_saved_by_vendor.sort((a, b) => parseFloat(a.main_gst_amount) - parseFloat(b.main_gst_amount));
                } else {
                  i.item_list_saved_by_vendor.sort((a, b) => parseFloat(b.main_gst_amount) - parseFloat(a.main_gst_amount));
                }
                let subind: number = 0;
                for (let j of i.item_list_saved_by_vendor) {
                  j.subindex_level = "L" + (subind + 1);
                  subind++;
                }
              }
              if (!auction_value) {
                i.item_list_saved_by_vendor.sort((a, b) => parseFloat(a.gst_amount) - parseFloat(b.gst_amount));
              } else {
                i.item_list_saved_by_vendor.sort((a, b) => parseFloat(b.gst_amount) - parseFloat(a.gst_amount));
              }
            }
          }
          // END
        }
      }
    }
    // this.getPoPrice(ship_to_location);
    let columnList = [];
    let commonColumnList = this.commonVariableList.columnList;
    if (commonColumnList) {
      for (let i of commonColumnList) {
        if (i.value == 'product_name' && this.is_QuotationManagement_column_visible('product_name',false)) {
          i.is_view = true;
          i.display = this.getColumnNameQuotationManagement('product_name','Product Name')
        }
        if (i.value == 'product_name' && !this.is_QuotationManagement_column_visible('product_name',false)) {
          i.is_view = false;
          i.display = this.getColumnNameQuotationManagement('product_name','Product Name')
        }
        if (i.value == 'make' && !this.is_QuotationManagement_column_visible('is_make',false)) {
          i.is_view = false;
          i.display = this.getColumnNameQuotationManagement('is_make','Make')
        }
        if (i.value == 'model' && !this.is_QuotationManagement_column_visible('is_model',false)) {
          i.is_view = false;
          i.display = this.getColumnNameQuotationManagement('is_model','Model')
        }
        if (i.value == 'additional_field1' && !this.is_QuotationManagement_column_visible('additional_field1',false)) {
          i.is_view = false;
          i.display = this.getColumnNameQuotationManagement('additional_field1','Additional Field1')
        }
        if (i.value == 'additional_field2' && !this.is_QuotationManagement_column_visible('additional_field2',false)) {
          i.is_view = false;
          i.display = this.getColumnNameQuotationManagement('additional_field2','Additional Field2')
        }
        
        if (i.value == 'description' && this.is_QuotationManagement_column_visible('description',false)) {
          i.is_view = true;
          i.display = this.getColumnNameQuotationManagement('description','Description')
        }
        if (i.value == 'description' && !this.is_QuotationManagement_column_visible('description',false)) {
          i.is_view = false;
          i.display = this.getColumnNameQuotationManagement('description','Description')
        }
        if (i.value == 'uom_name' && this.is_QuotationManagement_column_visible('uom',false)) {
          i.is_view = true;
          i.display = this.getColumnNameQuotationManagement('uom','UOM Name')
        }
        if (i.value == 'uom_name' && !this.is_QuotationManagement_column_visible('uom',false)) {
          i.is_view = false;
          i.display = this.getColumnNameQuotationManagement('uom','UOM Name')
        }
        if (i.value == 'qty' && this.is_QuotationManagement_column_visible('quantity',false)) {
          i.is_view = true;
          i.display = this.getColumnNameQuotationManagement('quantity','Quantity')
        }
        if (i.value == 'qty' && !this.is_QuotationManagement_column_visible('quantity',false)) {
          i.is_view = false;
          i.display = this.getColumnNameQuotationManagement('quantity','Quantity')
        }
        
        if(type=="rfq_response") {
          if (i.value == 'pr_no' && this.tableDetails.data.product_selection_type=='pr') {
            i.is_view = true;
          }
          if (i.value == 'required_by_date') {
            i.is_view = false;
          }
          if (i.value == 'product_catalog_id' && this.is_QuotationManagement_column_visible('catalog_id',false)) {
            i.is_view = true;
            i.display = this.getColumnNameQuotationManagement('catalog_id','Product Catalog ID');
          }
          if (i.value == 'target_price' && this.is_QuotationManagement_column_visible('target_price',false)) {
            i.is_view = true;
            i.display = this.getColumnNameQuotationManagement('target_price','Target Price') + " " + (data.currency_code!='' ? data.currency_code : this.company_setup.default_currency_code);
            i.currency = data.currency_code!='' ? data.currency_code : this.company_setup.default_currency_code;
          }
          if (i.value == 'min_bid_revised_amount' && this.is_QuotationManagement_column_visible('min_bid_revised_amount',false)) {
            i.is_view = true;
            i.display = this.getColumnNameQuotationManagement('min_bid_revised_amount','Minimum Decrease in Bid Amount') + " " + (data.currency_code!='' ? data.currency_code : this.company_setup.default_currency_code);
            i.currency = data.currency_code!='' ? data.currency_code : this.company_setup.default_currency_code;
          }
          if (i.value == 'po_price_list') {
            i.is_view = true;
            i.display = this.getColumnNameQuotationManagement('po_price_list','PO Past Value');

            columnList.push(i);
            let index = 1;
            for(let t of level_list) {
              let t1 = {
                "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "",
                "value": "",
                "is_text": true, "is_number": false,
                "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'rfq_price', 'index': index, 'currency': data.currency_code!='' ? data.currency_code : this.company_setup.default_currency_code,
              };
              t1.is_view = true;
              t1.display = t.level + " " + t.import_name  + " " + (data.currency_code!='' ? data.currency_code : this.company_setup.default_currency_code);
              t1.value = 'main_gst_amount';
              columnList.push(t1);
              index++;
            }
            continue;
          }
          if (i.value == 'selected_vendor_name') {
            i.is_view = true;
            i.display = this.getColumnNameQuotationManagement('selected_vendor_name','Selected Vendor Name');
          }
          if (i.value == 'selected_vendor_unit_price') {
            i.is_view = true;
            i.display = this.getColumnNameQuotationManagement('selected_vendor_unit_price','Selected Vendor Unit Price') + " " + (data.currency_code!='' ? data.currency_code : this.company_setup.default_currency_code);
            i.currency = data.currency_code!='' ? data.currency_code : this.company_setup.default_currency_code;
          }
          if (i.value == 'selected_vendor_gst_amount') {
            i.is_view = true;
            i.display = "Selected Vendor" + " GST" + " Amount " + (data.currency_code!='' ? data.currency_code : this.company_setup.default_currency_code);
            i.currency = data.currency_code!='' ? data.currency_code : this.company_setup.default_currency_code;
          }
          if (i.value == 'selected_vendor_price') {
            i.is_view = true;
            i.display = this.getColumnNameQuotationManagement('selected_vendor_price','Selected Vendor Total Price') + " " + (data.currency_code!='' ? data.currency_code : this.company_setup.default_currency_code);
            i.currency = data.currency_code!='' ? data.currency_code : this.company_setup.default_currency_code;
          }
        } else {
          if (i.value == 'required_by_date' && this.is_QuotationManagement_column_visible('required_by',false)) {
            i.is_view = true;
            i.display = this.getColumnNameQuotationManagement('required_by','Required By')
          }
          if (i.value == 'required_by_date' && !this.is_QuotationManagement_column_visible('required_by',false)) {
            i.is_view = false;
            i.display = this.getColumnNameQuotationManagement('required_by','Required By')
          }
          if (i.value == 'target_price' && this.is_QuotationManagement_column_visible('target_price',false)) {
            i.is_view = true;
            i.display = this.getColumnNameQuotationManagement('target_price','Target Price')
          }
          if (i.value == 'target_price' && !this.is_QuotationManagement_column_visible('target_price',false)) {
            i.is_view = false;
            i.display = this.getColumnNameQuotationManagement('target_price','Target Price')
          }
        }

        if (i.value == 'remarks' && this.is_QuotationManagement_column_visible('remarks_in_product_table',false)) {
          i.is_view = true;
          i.display = this.getColumnNameQuotationManagement('remarks_in_product_table','Remarks')
        }
        if (i.value == 'remarks' && !this.is_QuotationManagement_column_visible('remarks_in_product_table',false)) {
          i.is_view = false;
          i.display = this.getColumnNameQuotationManagement('remarks_in_product_table','Remarks')
        }

        if (i.value == 'company_item_attachments' && this.is_QuotationManagement_column_visible('attachment_in_product_table',false)) {
          i.is_view = true;
          i.display = this.getColumnNameQuotationManagement('attachment_in_product_table','Attachment')
        }
        if (i.value == 'company_item_attachments' && !this.is_QuotationManagement_column_visible('attachment_in_product_table',false)) {
          i.is_view = false;
          i.display = this.getColumnNameQuotationManagement('attachment_in_product_table','Attachment')
        }
        if (i.value == 'boq_product_nos') {
          if(this.is_QuotationManagement_column_visible('boq_product_nos', false)){
            i.is_view = true;
          }else{
            i.is_view = false
          }
          i.display = this.getColumnNameQuotationManagement('boq_product_nos', 'Product No');
        }
        if (i.value == 'boq_product_l') {
          if(this.is_QuotationManagement_column_visible('boq_product_l', false)){
            i.is_view = true;
          }else{
            i.is_view = false
          }
          i.display = this.getColumnNameQuotationManagement('boq_product_l', 'Product L');
        }
        if (i.value == 'boq_product_b') {
          if(this.is_QuotationManagement_column_visible('boq_product_b', false)){
            i.is_view = true;
          }else{
            i.is_view = false
          }
          i.display = this.getColumnNameQuotationManagement('boq_product_b', 'Product B');
        }
        if (i.value == 'boq_product_d') {
          if(this.is_QuotationManagement_column_visible('boq_product_d', false)){
            i.is_view = true;
          }else{
            i.is_view = false
          }
          i.display = this.getColumnNameQuotationManagement('boq_product_d', 'Product D');
        }
        columnList.push(i);
      }
    }

    this.commonVariableList.columnList = columnList;
    console.log("this.commonVariableList.columnList", this.commonVariableList.columnList)
    this.makeData();
  }

  getTotalByVendorId(id, itemList) {
    return  parseFloat(this.webService.convertNaN(itemList
    .reduce((total, m) => {
      return parseFloat(total) + m.item_list_saved_by_vendor
        .reduce((subtotal, v) => {
          return v.vendor_id == id
            ? parseFloat(subtotal) + parseFloat(this.webService.convertNaN((v.main_gst_amount || 0)))
            : parseFloat(this.webService.convertNaN(subtotal));
        }, 0);
    }, 0)));
  }

  getPoPrice(ship_to_location) {
    this.isProgressing = true;
    let payload: any = [];
    if (this.itemList) {
      let index: number = 0;
      for (let i of this.itemList) {
        let t = {
          "company_id": this._localStorageService.getEmpCompanyId(),
          "product_id": i.item_id ? i.item_id : '',
          "vendor_id": i.selected_vendor_id ? i.selected_vendor_id : '',
          "vendor_location_id": "",
          "cost_center_id": (ship_to_location != '0' && ship_to_location != null && ship_to_location != undefined) ? ship_to_location : '',
          "index": index,
          "parent_index": "0",
          "user_id": this._localStorageService.getUserId()
        }
        payload.push(t);
        index++;
      }
    }
    this.webService.commonPostMethod("/products/last_3_po_price_by_ven_cost", payload).
      subscribe(
        data => {
          if (data.status) {
            if (data.response) {
              for (let i of data.response) {
                this.itemList[i.index].po_price_list = i.response ? i.response : [];
              }
            }
          }
          this.isProgressing = false;

        },
        error => {
          this.isProgressing = false;
        }
      );
  }

  allowedDecimalDigit (key) {
    let allowedKeys = ["invoice_qty", "accepted_qty", "rejected_qty", "conversion_unit_price", "po_unit_price", "conversion_invoice_price",
      "invoice_unit_price", "conversion_paid_price", "paid_unit_price", "difference_unit_price"];

    if(allowedKeys.includes(key)) {
      return true;
    } else {
      return false;
    }
  }
  IsItemVisible(key, default_value) {
    return this.company_setup.po_item_level_list.length > 0 ? (this.company_setup.po_item_level_list.some((v) => { return v.key == key && v.is_visible })) : false;
  }
  getItemName(key) {
    return this.company_setup.po_item_level_list.length > 0 ? (this.company_setup.po_item_level_list.some((v) => { return v.key == key }) ? this.company_setup.po_item_level_list.filter((v) => { return v.key == key })[0].custom_name : '') : ''
  }
  isDirectInvoiceVisibled(key)
  {
     return this.company_setup.vendor_direct_invoice_column_list.some((v)=>{return v.id==key && v.isVisible})
  } 
  
  isAddinvoiceVisibled(key)
  {
    return this.company_setup.vendor_invoice_column_list.some((v)=>{return v.id==key && v.isVisible})
  }

   // Get allocable cost items for IRN (from tableDetails.data)
   getAllocableCostItemsForIrn(): any[] {
    if (!this.tableDetails.data) {
      return [];
    }
    // Try multiple possible locations for allocable_cost_items
    if (this.tableDetails.data.allocable_cost_items && Array.isArray(this.tableDetails.data.allocable_cost_items) && this.tableDetails.data.allocable_cost_items.length > 0) {
      return this.tableDetails.data.allocable_cost_items;
    }
    return [];
  }

  // Calculate total allocable cost amount for IRN
  getAllocableCostTotalForIrn(currencyType: string): number {
    const items = this.getAllocableCostItemsForIrn();
    if (!items || items.length === 0) {
      return 0;
    }
    let total = 0;
    for (let item of items) {
      if (currencyType === 'po_currency') {
        total += parseFloat(this.webService.convertNaN(item.planned_amount_in_po_currency)) || 0;
      } else {
        total += parseFloat(this.webService.convertNaN(item.planned_amount_in_base_currency)) || 0;
      }
    }
    return total;
  }

  setupFieldDocuments(responseData: any): void {
    this.fieldDocuments = {};
    if (responseData && responseData.vendor_portal_field_documents) {
      responseData.vendor_portal_field_documents.forEach((fieldDoc: any) => {
        if (fieldDoc.attachments && Array.isArray(fieldDoc.attachments)) {
          this.fieldDocuments[fieldDoc.field_key] = {
            files: fieldDoc.attachments || []
          };
        }
        else {
          const fieldKey = fieldDoc.field_type || fieldDoc.field_key;
          if (!this.fieldDocuments[fieldKey]) {
            this.fieldDocuments[fieldKey] = {
              files: []
            };
          }
          this.fieldDocuments[fieldKey].files.push({
            attachment_url: fieldDoc.attachment_url || fieldDoc.attachments_url || fieldDoc.attachment,
            attachment_name: fieldDoc.attachments_name || fieldDoc.attachment_name,
            attchement_type: fieldDoc.attachments_type || fieldDoc.attachment_type
          });
        }
      });
    }
  }

  getVisibleVendorPortalFields(): any[] {
    if (!this.company_setup || !this.company_setup.vendor_portal_pending_po_fields || this.company_setup.vendor_portal_pending_po_fields.length === 0) {
      return [];
    }
    return this.company_setup.vendor_portal_pending_po_fields.filter((field: any) => 
      field.is_visible === true || field.is_visible === '1' || field.is_visible === 1
    );
  }

  getVendorPortalFieldName(key: string, defaultName: string): string {
    if (!this.company_setup || !this.company_setup.vendor_portal_pending_po_fields || this.company_setup.vendor_portal_pending_po_fields.length === 0) {
      return defaultName;
    }
    const field = this.company_setup.vendor_portal_pending_po_fields.find((v: any) => v.key === key);
    return field && field.custom_name ? field.custom_name : (field && field.name ? field.name : defaultName);
  }

  getUniqueFieldDocuments(fieldKey: string): any[] {
    const files = (this.fieldDocuments[fieldKey] && this.fieldDocuments[fieldKey].files) || [];
    const seen = new Set<string>();
    return files.filter((f: any) => {
      const name = (f.attachment_name && f.attachment_name.toLowerCase()) || '';
      return seen.has(name) ? false : (seen.add(name), true);
    });
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src1330696905/src/src/app/generic-ui-components/generic-table/generic-table.component.ts